import { Injectable } from '@angular/core';
import { APIService } from './master/api.service';
import { BaseService } from './master/base.service';
import { apiUrl } from '../schema/api-url';
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpRequest,
} from '@angular/common/http';
import { AUTH } from 'src/app/constant/constant';
import { Observable } from 'rxjs';
import { UniqueSelectionDispatcher } from '@angular/cdk/collections';
import { data, param } from 'jquery';
import { map } from 'rxjs/operators';
import moment, { max } from 'moment';

@Injectable({
  providedIn: 'root',
})
export class ViecLamService extends BaseService {
  constructor(private _apiService: APIService, private http: HttpClient) {
    super(_apiService);
  }

  getHeader() {
    const token = localStorage.getItem(AUTH.TOKEN_KEY);
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + token);
    headers = headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    return headers;
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Tìm kiếm danh mục loại hợp đồng
   */
  timKiemLoaiHopDong(requestBody) {
    return super.post(apiUrl.LDVL.danhMuc.timKiemLoaiHopDong, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Thêm mới danh mục loại hợp đồng
   */
  themMoiLoaiHopDong(requestBody) {
    return super.post(apiUrl.LDVL.danhMuc.themMoiLoaiHopDong, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param requestBody
   * @description Cập nhật thông tin danh mục loại hợp đồng
   */
  capNhatLoaiHopDong(requestBody) {
    return super.put(apiUrl.LDVL.danhMuc.capNhatLoaiHopDong, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method DELETE
   * @param maLoaiHopDong
   * @description Xoá thông tin danh mục loại hợp đồng
   */
  xoaLoaiHopDong(maLoaiHopDong) {
    return super.delete(apiUrl.LDVL.danhMuc.xoaLoaiHopDong, {
      maLoaiHopDong: maLoaiHopDong,
    });
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Tìm kiếm danh mục bằng cấp - trình độ chuyên môn
   */
  timKiemTrinhDoChuyenMon(requestBody) {
    return super.post(apiUrl.LDVL.danhMuc.timKiemTrinhDoChuyenMon, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Thêm mới danh mục bằng cấp - trình độ chuyên môn
   */
  themMoiTrinhDoChuyenMon(requestBody) {
    return super.post(apiUrl.LDVL.danhMuc.themMoiTrinhDoChuyenMon, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param requestBody
   * @description Cập nhật thông tin danh mục bằng cấp - trình độ chuyên môn
   */
  capNhatTrinhDoChuyenMon(requestBody) {
    return super.put(apiUrl.LDVL.danhMuc.capNhatTrinhDoChuyenMon, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method DELETE
   * @param idDanhMucBangCap
   * @description Xoá thông tin danh mục bằng cấp - trình độ chuyên môn
   */
  xoaTrinhDoChuyenMon(idDanhMucBangCap) {
    return super.delete(apiUrl.LDVL.danhMuc.xoaTrinhDoChuyenMon, {
      idDanhMucBangCap: idDanhMucBangCap,
    });
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Tìm kiếm thông tin danh mục công ty
   */
  timKiemCongTy(requestBody) {
    return super.post(apiUrl.LDVL.congTy.timKiemCongTy, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method DELETE
   * @param { maCongTy,trangThaiXoa }
   * @description Xoá thông tin danh mục công ty
   */
  xoaCongTy(maCongTy, trangThaiXoa) {
    return super.delete(
      apiUrl.LDVL.congTy.xoaCongTy +
        '?maCongTy=' +
        maCongTy +
        '&trangThaiXoa=' +
        trangThaiXoa
    );
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param { idCha, capNganh }
   * @description Danh sách ngành nghề
   */
  danhMucNganhNghe(idCha, capNganh) {
    if (idCha == null) {
      return super.get(apiUrl.LDVL.danhMuc.danhSachNganhNghe, {
        capNganh: capNganh,
      });
    } else {
      return super.get(apiUrl.LDVL.danhMuc.danhSachNganhNghe, {
        idCha: idCha,
        capNganh: capNganh,
      });
    }
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param
   * @description Danh sách quy mô công ty
   */
  danhSachQuyMoCongTy() {
    return super.get(apiUrl.LDVL.danhMuc.danhMucQuyMoCongTy);
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param { maCongTy, trangThaiPheDuyet }
   * @description Phê duyệt tài khoản công ty
   */
  pheDuyetTaiKhoanCongTy(maCongTy, trangThaiPheDuyet) {
    return super.put(
      apiUrl.LDVL.congTy.pheDuyetCongTy +
        maCongTy +
        '&trangThaiPheDuyet=' +
        trangThaiPheDuyet
    );
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param { maCongTy, trangThaiKhoa }
   * @description Khoá tài khoản công ty
   */
  khoaTaiKhoanCongTy(maCongTy, trangThaiKhoa) {
    return super.put(
      apiUrl.LDVL.congTy.khoaTaiKhoanCongTy +
        maCongTy +
        '&trangThaiKhoa=' +
        trangThaiKhoa
    );
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Tìm kiếm danh sách tài khoản ứng viên
   */
  timKiemTaiKhoanUngVien(requestBody) {
    return super.post(apiUrl.LDVL.ungVien.timKiemTaiKhoanUngVien, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param requestBody
   * @description Phê duyệt tài khoản ứng viên
   */
  pheDuyetTaiKhoanUngVien(requestBody) {
    return super.put(apiUrl.LDVL.ungVien.pheDuyetTaiKhoanUngVien, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param { tenDangNhap, trangThaiKhoa }
   * @description Khoá - mở khoá tài khoản ứng viên
   */
  khoaTaiKhoanUngVien(tenDangNhap, trangThaiKhoa) {
    return super.put(
      apiUrl.LDVL.ungVien.khoaTaiKhoanUngVien +
        tenDangNhap +
        '&trangThaiKhoa=' +
        trangThaiKhoa
    );
  }

  /**
   * @author hangdtt.it5
   * @method DELETE
   * @param tenDangNhap
   * @description Xoá tài khoản ứng viên
   */
  xoaTaiKhoanUngVien(tenDangNhap) {
    return super.delete(apiUrl.LDVL.ungVien.xoaTaiKhoanUngVien + tenDangNhap);
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Tìm kiếm hồ sơ ứng viên
   */
  timKiemHoSoUngVien(requestBody) {
    return super.post(apiUrl.LDVL.ungVien.timKiemHoSoUngVien, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method POST
   * @param requestBody
   * @description Tìm kiếm tin tuyển dụng của công ty
   */
  timKiemTinTuyenDung(requestBody) {
    return super.post(apiUrl.LDVL.congTy.timKiemTinTuyenDung, requestBody);
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param { maBaiDang, trangThai }
   * @description Phê duyệt/ từ chối tin tuyển dụng của công ty
   */
  pheDuyetTinTuyenDung(maBaiDang, trangThai) {
    return super.put(
      apiUrl.LDVL.congTy.pheDuyetTinTuyenDung +
        maBaiDang +
        '&trangThai=' +
        trangThai
    );
  }

  /**
   * @author hangdtt.it5
   * @method DELETE
   * @param maBaiDang
   * @description Xoá tin tuyển dụng của công ty
   */
  xoaTinTuyenDung(maBaiDang) {
    return super.delete(apiUrl.LDVL.congTy.xoaTinTuyenDung + maBaiDang);
  }

  /**
   * @author hangdtt.it5
   * @method PUT
   * @param { idHoSo, trangThai }
   * @description Phê duyệt hồ sơ ứng viên
   */
  pheDuyetHoSoUngVien(idHoSo, trangThai) {
    return super.put(
      apiUrl.LDVL.ungVien.pheDuyetHoSoUngVien +
        idHoSo +
        '&trangThai=' +
        trangThai
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách hộ gia đình
   */
  getListHoGiaDinh(obj): Observable<any> {
    return super.get(apiUrl.LDVL.hoGiaDinh.getList, obj);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách hộ gia đình theo tu khoa
   */
  getListHoGiaDinhTK(page_size, page_number, tuKhoa) {
    return super.get(apiUrl.LDVL.hoGiaDinh.getListTK, {
      page_size: page_size,
      page_number: page_number,
      search: tuKhoa,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param maHo
   * @description Danh sách hộ gia đình id
   */
  getListHoGiaDinhID(maHo) {
    return super.get(apiUrl.LDVL.hoGiaDinh.MAHO + '/' + maHo);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Cập nhật hộ gia đình
   */
  addHoGiaDinh(requestBody) {
    return super.post(apiUrl.LDVL.hoGiaDinh.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật hộ gia đình
   */
  updateHoGiaDinh(requestBody) {
    return super.put(apiUrl.LDVL.hoGiaDinh.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maHo
   * @description Xóa hộ gia đình
   */
  deleteHoGiaDinh(maHo) {
    return super.delete(apiUrl.LDVL.hoGiaDinh.ADD_UPDATE_DELETE, {
      maHo: maHo,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Sổ ghi chép cung
   */
  getListSoGhiChepCung(obj): Observable<any> {
    return super.get(apiUrl.LDVL.soGhiChepCung.getList, obj);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách sổ ghi chép cung theo tu khoa
   */
  getListSoGhiChepCungTK(page_size, page_number, tuKhoa) {
    return super.get(apiUrl.LDVL.soGhiChepCung.getListTK, {
      page_size: page_size,
      page_number: page_number,
      tenSo: tuKhoa,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param maHo
   * @description Danh sách sổ ghi chép cung id
   */
  getListSoGhiChepCungID(maSo) {
    return super.get(apiUrl.LDVL.soGhiChepCung.getTheoID + '/' + maSo);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Cập nhật sổ ghi chép chung
   */
  addSoGhiChepCung(requestBody) {
    return super.post(apiUrl.LDVL.soGhiChepCung.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật sổ ghi chép cung
   */
  updateSoGhiChepCung(requestBody) {
    return super.put(apiUrl.LDVL.soGhiChepCung.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maHo
   * @description Xóa sổ ghi chép cung
   */
  deleteSoGhiChepCung(maSo) {
    return super.delete(apiUrl.LDVL.soGhiChepCung.ADD_UPDATE_DELETE, {
      maSo: maSo,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách thông tin người ghi
   */
  getListTTNguoiGhi() {
    return super.get(apiUrl.LDVL.TTNguoiGhi.getList);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới thông tin người ghi
   */
  addTTNguoiGhi(requestBody) {
    return super.post(apiUrl.LDVL.TTNguoiGhi.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật thông tin người ghi
   */
  updateTTNguoiGhi(requestBody) {
    return super.put(apiUrl.LDVL.TTNguoiGhi.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maHo
   * @description Xóa thông tin người ghi
   */
  deleteTTNguoiGhi(maSo) {
    return super.delete(apiUrl.LDVL.TTNguoiGhi.ADD_UPDATE_DELETE + '/', {
      id: maSo,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách cung ban đầu
   */
  getListCungBanDau(
    page_size,
    page_number,
    quyenSo,
    nam,
    obj
  ): Observable<any> {
    if (quyenSo != null) {
      return super.get(apiUrl.LDVL.cungBanDau.getListTheoQuyenSo, {
        maSo: quyenSo,
        nam: nam,
        page_size: page_size,
        page_number: page_number,
      });
    } else {
      return super.get(apiUrl.LDVL.cungBanDau.getList, obj);
    }
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách cung ban đầu
   */
  getAllDanhSachThanhVien(obj): Observable<any> {
    return super.get(apiUrl.LDVL.cungBanDau.getAllDanhSachThanhVien, obj);
  }
  /**
    //  * minhvn.bte - 12/07/2022
      * @author minhvn.bte
      * @method GET
      * @param requestBody
      * @description Danh sách cung ban đầu riềng của Bến Tre
      */
  getAllDanhSachThanhVienBTE(obj): Observable<any> {
    return super.get(apiUrl.LDVL.cungBanDau.getAllDanhSachThanhVienBTE, obj);
  }
  getDanhSachCungLDChoNguoiDan(obj): Observable<any> {
    return super.get(apiUrl.LDVL.cungBanDau.getDanhSachCungLDChoNguoiDan, obj);
  }
  // End minhvn.bte - 12/07/2022
  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description download file mẫu
   */
  xuatFileImportThanhVienBTE(): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.cungBanDau.exportThanhVienBTE,
      'File mẫu import thành viên bte.xlsx'
    );
  }

  xuatFileImportThanhVien(): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.cungBanDau.exportThanhVien,
      'File mẫu import thành viên.xlsx'
    );
  }
  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  uploadFileImport(obj): Observable<any> {
    return super.post(apiUrl.LDVL.cungBanDau.importThanhVien, obj);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới cung ban đầu
   */
  addCungBanDau(requestBody) {
    return super.post(apiUrl.LDVL.cungBanDau.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới cung biến động
   */
  addCungBienDong(requestBody) {
    return super.post(apiUrl.LDVL.cungBanDau.cungBienDong, requestBody);
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật cung ban đầu
   */
  updateCungBanDau(requestBody) {
    return super.put(apiUrl.LDVL.cungBanDau.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maHo
   * @description Xóa cung ban đầu
   */
  deleteCung(maSo) {
    return super.delete(apiUrl.LDVL.cungBanDau.ADD_UPDATE_DELETE, {
      idCungLD: maSo,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param idCungBD
   * @description Danh sách thành viên dựa trên cung lao động
   */
  getCungTheoHo(maHo, nam) {
    return super.get(apiUrl.LDVL.cungBanDau.getCungTheoHo + '/', {
      maHo: maHo,
      nam: nam,
    });
  }
  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới thành viên
   */
  addThanhVien(requestBody) {
    // return super.post(apiUrl.LDVL.thanhVien.ADD_UPDATE_DELETE, requestBody);
    return super.post(apiUrl.LDVL.thanhVien.ADD_THANH_VIEN, requestBody);
  }

  /**
   * @author sonnvt
   * @method POST
   * @param requestBody
   * @description Thêm mới thành viên
   */
  addThanhVienBTE(requestBody) {
    return super.post(apiUrl.LDVL.thanhVien.THEM_THANHVIEN_BTE, requestBody);
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật thành viên
   */
  updateThanhVien(requestBody) {
    return super.put(apiUrl.LDVL.thanhVien.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maHo
   * @description Xóa thành viên
   */
  deleteThanhVien(idthanhVien) {
    return super.delete(apiUrl.LDVL.thanhVien.ADD_UPDATE_DELETE, {
      idThanhVien: idthanhVien,
    });
  }

  // /**
  // * @author sonnvt
  // * @method DELETE
  // * @param idThanhVien
  // * @description Khôi phục thành viên
  // */
  // recoveryThanhVien(idthanhVien) {
  //     return super.get(apiUrl.LDVL.thanhVien.RECOVERY_DELETE, { idThanhVien: idthanhVien });
  // }

  /**
   * @author psdung
   * @method DELETE
   * @param maHo
   * @description Xóa thành viên
   */
  recoveryThanhVien(idthanhVien) {
    return super.get(apiUrl.LDVL.thanhVien.RECOVERY_DELETE + '/' + idthanhVien);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách thành viên theo hộ gia đình
   */
  getThanhVienBTXH(maHo) {
    return super.get(apiUrl.LDVL.thanhVien.getThanhVienBTXH, { maHo: maHo });
  }
  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description get thành viên theo id
   */
  getThanhVienBTXHid(id) {
    return super.get(apiUrl.LDVL.thanhVien.getThanhVienBTXHid + '/' + id);
  }
  //Danh mục
  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục dân tộc
   */
  getDanToc() {
    return super.get(apiUrl.LDVL.danhMuc.danToc);
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục đối tượng ưu tiên
   */
  getDoiTuongUuTien() {
    return super.get(apiUrl.LDVL.danhMuc.doiTuongUuTien);
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục loại hình hoạt động
   */
  getLoaiHinhHoatDong() {
    return super.get(apiUrl.LDVL.danhMuc.loaiHinhHoatDong);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới danh mục loại hình hoạt động
   */
  themMoiLoaiHinhHD(requestBody) {
    return super.post(
      apiUrl.LDVL.danhMuc.loaiHinhHoatDong_ADD_EDIT_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật lĩnh vực loại hình hoạt động
   */
  capNhatLoaiHinhHD(requestBody) {
    return super.put(
      apiUrl.LDVL.danhMuc.loaiHinhHoatDong_ADD_EDIT_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maLoaiHinhHoatDong
   * @description Xoá thông tin danh mục loại hình hoạt động
   */
  xoaLoaiHinhHD(maLoaiHinhHoatDong) {
    return super.delete(apiUrl.LDVL.danhMuc.loaiHinhHoatDong_ADD_EDIT_DELETE, {
      maLoaiHinhHoatDong: maLoaiHinhHoatDong,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục loại hình kinh tế
   */
  getLoaiHinhKinhTe() {
    return super.get(apiUrl.LDVL.danhMuc.loaiHinhKinhTe);
  }
  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới danh mục loại hình hoạt động
   */
  themMoiLoaiHinhKT(requestBody) {
    return super.post(
      apiUrl.LDVL.danhMuc.loaiHinhKT_ADD_UPDATE_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật lĩnh vực loại hình hoạt động
   */
  capNhatLoaiHinhKT(requestBody) {
    return super.put(
      apiUrl.LDVL.danhMuc.loaiHinhKT_ADD_UPDATE_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maLoaiHinhKT
   * @description Xoá thông tin danh mục loại hình hoạt động
   */
  xoaLoaiHinhKT(maLoaiHinhKT) {
    return super.delete(apiUrl.LDVL.danhMuc.loaiHinhKT_ADD_UPDATE_DELETE, {
      maLoaiHinhKT: maLoaiHinhKT,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục lý do không tg hoạt động kinh tế
   */
  getLyDoKTGHDKD() {
    return super.get(apiUrl.LDVL.danhMuc.lyDoKTGHDKD);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới danh mục lý do khong hoat dong kinh tế
   */
  themMoiLyDoKHDKT(requestBody) {
    return super.post(
      apiUrl.LDVL.danhMuc.lyDoKHDKT_ADD_UPDATE_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật ly do khong hoat dong kinh tế
   */
  capNhatLyDoKHDKT(requestBody) {
    return super.put(
      apiUrl.LDVL.danhMuc.lyDoKHDKT_ADD_UPDATE_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maLinhVucGDDT
   * @description Xoá thông tin thong tin khong hoat dong kinh tế
   */
  xoaLyDoKHDKT(maNhomNgnahKT) {
    return super.delete(apiUrl.LDVL.danhMuc.lyDoKHDKT_ADD_UPDATE_DELETE, {
      maLyDoKTGHDKT: maNhomNgnahKT,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục mối quan hệ
   */
  getMoiQH() {
    return super.get(apiUrl.LDVL.danhMuc.moiQH);
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục nhóm nghành kinh tế
   */
  getNhomNganhKT() {
    return super.get(apiUrl.LDVL.danhMuc.nhomNganhKT);
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục quy mô lao động
   */
  getDmQuyMoLaoDong() {
    return super.get(apiUrl.LDVL.danhMuc.quyMoLaoDong);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới danh mục nhóm ngành kinh tế
   */
  themMoiNhomNganhKT(requestBody) {
    return super.post(
      apiUrl.LDVL.danhMuc.nhomNganhKT_ADD_UPDATE_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật nhóm ngành kinh tế
   */
  capNhatNhomNganhKT(requestBody) {
    return super.put(
      apiUrl.LDVL.danhMuc.nhomNganhKT_ADD_UPDATE_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maLinhVucGDDT
   * @description Xoá thông tin nhóm ngành kinh tế
   */
  xoaNhomNganhKT(maNhomNgnahKT) {
    return super.delete(apiUrl.LDVL.danhMuc.nhomNganhKT_ADD_UPDATE_DELETE, {
      maNhomNghanhKT: maNhomNgnahKT,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục trình độ chuyên môn
   */
  getTrinhDoCM() {
    return super.get(apiUrl.LDVL.danhMuc.trinhDoCM);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới danh mục trình độ chuyên môn kinh tế
   */
  themMoiTrinhDoCMKT(requestBody) {
    return super.post(
      apiUrl.LDVL.danhMuc.trinhDoCMKT_ADD_UPDATE_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật loại trình độ chuyên môn kinh tế
   */
  capNhatTrinhDoCMKT(requestBody) {
    return super.put(
      apiUrl.LDVL.danhMuc.trinhDoCMKT_ADD_UPDATE_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maTrinhDoCMKT
   * @description Xoá thông tin danh mục trình độ chuyên môn kinh tế
   */
  xoaTrinhDocMKT(maTrinhDoCMKT) {
    return super.delete(apiUrl.LDVL.danhMuc.trinhDoCMKT_ADD_UPDATE_DELETE, {
      maTrinhDoChuyenMonKT: maTrinhDoCMKT,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục trình độ giáo dục đào tạo
   */
  getTrinhDoGDDT() {
    return super.get(apiUrl.LDVL.danhMuc.trinhDoGDDT);
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục vị thế công việc
   */
  getViTheCongViec() {
    return super.get(apiUrl.LDVL.danhMuc.viTheCongViec);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới danh mục trình độ giáo dục đào tạo
   */
  themMoiTrinhDoGDDT(requestBody) {
    return super.post(
      apiUrl.LDVL.danhMuc.trinhDoGDDT_ADD_UPDATE_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật loại trình độ giáo dục đào tạo
   */
  capNhatTrinhDoGDDT(requestBody) {
    return super.put(
      apiUrl.LDVL.danhMuc.trinhDoGDDT_ADD_UPDATE_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maTrinhDoCMKT
   * @description Xoá thông tin danh mục trình độ giáo dục đào tạo
   */
  xoaTrinhDoGDDT(maTrinhDoGDPT) {
    return super.delete(apiUrl.LDVL.danhMuc.trinhDoGDDT_ADD_UPDATE_DELETE, {
      maTrinhDoGDPT: maTrinhDoGDPT,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục mã công việc
   */
  getAllMaCongViec() {
    return super.get(apiUrl.LDVL.danhMuc.getAllMaCongViec);
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục quyển sổ
   */
  getQuyenSo() {
    return super.get(apiUrl.LDVL.danhMuc.quyenSo);
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục loại biến động
   */
  getLoaiBienDong() {
    return super.get(apiUrl.LDVL.danhMuc.loaiBienDong);
  }
  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới danh mục loại biến động
   */
  themMoiLoaiBienDong(requestBody) {
    return super.post(
      apiUrl.LDVL.danhMuc.loaiBienDong_ADD_EDIT_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật loại biến động
   */
  capNhatLoaiBienDong(requestBody) {
    return super.put(
      apiUrl.LDVL.danhMuc.loaiBienDong_ADD_EDIT_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maLoaiDoiTuong
   * @description Xoá thông tin danh mục loại biến động
   */
  xoaLoaiBienDong(maLoaiBienDong) {
    return super.delete(apiUrl.LDVL.danhMuc.loaiBienDong_ADD_EDIT_DELETE, {
      maLoaiBienDong: maLoaiBienDong,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param idCungBD
   * @description Danh sách thành viên dựa trên cung lao động
   */
  getThanhVien(idCung) {
    return super.get(apiUrl.LDVL.thanhVien.GET_ThanhVien_idCung + '/', {
      idCungLaoDong: idCung,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục lĩnh vực đào tạo
   */
  getLinhVucDT() {
    return super.get(apiUrl.LDVL.danhMuc.linhVucGDDT);
  }
  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới danh mục lĩnh vực giáo dục đào tạo
   */
  themMoiLinhVucGD(requestBody) {
    return super.post(
      apiUrl.LDVL.danhMuc.LinhVucGDDT_ADD_EDIT_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật lĩnh vực giáo dục đào tạo
   */
  capNhatLinhVucGDDT(requestBody) {
    return super.put(
      apiUrl.LDVL.danhMuc.LinhVucGDDT_ADD_EDIT_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maLinhVucGDDT
   * @description Xoá thông tin lĩnh vực giáo dục đào tạo
   */
  xoaLinhVucGDDT(maLinhVucGDDT) {
    return super.delete(apiUrl.LDVL.danhMuc.LinhVucGDDT_ADD_EDIT_DELETE, {
      maLinhVucGDDT: maLinhVucGDDT,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục quốc tịch
   */
  getQuocTich() {
    return super.get(apiUrl.LDVL.danhMuc.quocTich);
  }

  getChauLuc() {
    return super.get(apiUrl.LDVL.danhMuc.chauLuc);
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục tình trạng hoạt động
   */
  getTinhTrangHoatDong() {
    return super.get(apiUrl.LDVL.danhMuc.tinhTrangHoatDong);
  }
  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới danh mục tình trạng hoạt động
   */
  themMoiTinhTrangHD(requestBody) {
    return super.post(
      apiUrl.LDVL.danhMuc.tinhTrangHoatDongKT_ADD_UPDATE_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật tình trạng hoạt động
   */
  capNhatTinhTrangHD(requestBody) {
    return super.put(
      apiUrl.LDVL.danhMuc.tinhTrangHoatDongKT_ADD_UPDATE_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maLinhVucGDDT
   * @description Xoá thông tin danh mục tình trạng hoạt động
   */
  xoaTinhTrangHD(maTinhTrangHoatDongKT) {
    return super.delete(
      apiUrl.LDVL.danhMuc.tinhTrangHoatDongKT_ADD_UPDATE_DELETE,
      { maTinhTrangHoatDongKT: maTinhTrangHoatDongKT }
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục khu vực
   */
  getKhuVuc() {
    return super.get(apiUrl.LDVL.danhMuc.khuVuc);
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục loại đối tượng
   */
  getLoaiDoiTuong() {
    return super.get(apiUrl.LDVL.danhMuc.loaiDoiTuong);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới danh mục loại đối tượng
   */
  themMoiLoaiDoiTuong(requestBody) {
    return super.post(
      apiUrl.LDVL.danhMuc.loaiDoiTuong_ADD_EDIT_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật loại đối tượng
   */
  capNhatLoaiDoiTuong(requestBody) {
    return super.put(
      apiUrl.LDVL.danhMuc.loaiDoiTuong_ADD_EDIT_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maLoaiDoiTuong
   * @description Xoá thông tin danh mục loại đối tượng
   */
  xoaLoaiDoiTuong(maLoaiDoiTuong) {
    return super.delete(apiUrl.LDVL.danhMuc.loaiDoiTuong_ADD_EDIT_DELETE, {
      maLoaiDoiTuong: maLoaiDoiTuong,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục loại làm việc
   */
  getLoaiLamViec() {
    return super.get(apiUrl.LDVL.danhMuc.loaiLamViec);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới danh mục loại việc làm
   */
  themMoiLoaiViecLam(requestBody) {
    return super.post(
      apiUrl.LDVL.danhMuc.loaiViecLam_ADD_UPDATE_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật loại việc làm
   */
  capNhatLoaiViecLam(requestBody) {
    return super.put(
      apiUrl.LDVL.danhMuc.loaiViecLam_ADD_UPDATE_DELETE,
      requestBody
    );
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maLoaiViecLam
   * @description Xoá thông tin danh mục loại việc làm
   */
  xoaLoaiViecLam(maLoaiViecLam) {
    return super.delete(apiUrl.LDVL.danhMuc.loaiViecLam_ADD_UPDATE_DELETE, {
      maLoaiViecLam: maLoaiViecLam,
    });
  }

  /**
   * @author sangtv
   * @method GET
   * @param
   * @description Danh mục loại làm việc
   */
  timKiemLoaiTienLuong(obj) {
    return super.post(apiUrl.LDVL.danhMuc.loaiTienLuong, obj);
  }

  /**
   * @author sangtv
   * @method POST
   * @param requestBody
   * @description Thêm mới danh mục loại tiền lương
   */
  themMoiLoaiTienLuong(requestBody) {
    return super.post(apiUrl.LDVL.danhMuc.loaiTienLuong_ADD, requestBody);
  }

  /**
   * @author sangtv
   * @method PUT
   * @param requestBody
   * @description Cập nhật loại tiền lương
   */
  capNhatLoaiTienLuong(requestBody) {
    return super.put(apiUrl.LDVL.danhMuc.loaiTienLuong_UPDATE, requestBody);
  }

  /**
   * @author sangtv
   * @method DELETE
   * @param idDanhMuc
   * @param trangThaiXoa
   * @description Xoá thông tin danh mục loại tiền lương
   */
  xoaLoaiTienLuong(idDanhMuc, trangThaiXoa) {
    return super.delete(
      apiUrl.LDVL.danhMuc.loaiTienLuong_DELETE +
        '?idDanhMuc=' +
        idDanhMuc +
        '&trangThaiXoa=' +
        trangThaiXoa
    );
  }

  /**
   * @author sangtv
   * @method GET
   * @param
   * @description Danh mục loại làm việc
   */
  getChucDanhAll() {
    return super.get(apiUrl.LDVL.danhMuc.getAllChucDanh);
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Danh mục
   */
  getKhuCongNghiepKCX() {
    return super.get(apiUrl.LDVL.danhMuc.khuCongNghiepKCX);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách cung ban đầu
   */
  getListCungBienDong(
    page_size,
    page_number,
    quyenSo,
    idBienDong,
    nam,
    obj
  ): Observable<any> {
    if (idBienDong != null) {
      return super.get(apiUrl.LDVL.cungBanDau.getCungTheoLoaiBienDong, obj);
    } else if (quyenSo != null) {
      return super.get(apiUrl.LDVL.cungBanDau.getHoTheoSoCungBD, {
        maSo: quyenSo,
        nam: nam,
        page_size: page_size,
        page_number: page_number,
      });
    } else {
      return super.get(
        apiUrl.LDVL.cungBanDau.getCungLDBienDongTheoHuyenXaThon,
        obj
      );
    }
  }

  getThanhVienBienDong(obj): Observable<any> {
    return super.get(apiUrl.LDVL.cungBanDau.getThanhVienBienDong, obj);
  }
  getThanhVienBienDongBTE(obj): Observable<any> {
    return super.get(apiUrl.LDVL.cungBanDau.getThanhVienBienDongBTE, obj);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Sổ ghi chép cầu
   */
  getListSoGhiChepCau(page_size, page_number, maXa): Observable<any> {
    if (maXa == 'null') {
      return super.get(
        apiUrl.LDVL.soGhiChepCau.getList +
          '?page_size=' +
          page_size +
          '&page_number=' +
          page_number
      );
    } else {
      return super.get(
        apiUrl.LDVL.soGhiChepCau.getList +
          '?page_size=' +
          page_size +
          '&page_number=' +
          page_number +
          '&maXa=' +
          maXa
      );
    }
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách sổ ghi chép cầu theo tu khoa
   */
  getListSoGhiChepCauTK(page_size, page_number, tuKhoa) {
    return super.get(apiUrl.LDVL.soGhiChepCau.getListTK, {
      page_size: page_size,
      page_number: page_number,
      search: tuKhoa,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param maSo
   * @description Danh sách sổ ghi chép cau id
   */
  getListSoGhiChepCauID(maSo) {
    return super.get(apiUrl.LDVL.soGhiChepCau.getTheoID + '/' + maSo);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Cập nhật sổ ghi chép cầu
   */
  addSoGhiChepCau(requestBody) {
    return super.post(apiUrl.LDVL.soGhiChepCau.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật sổ ghi chép cau
   */
  updateSoGhiChepCau(requestBody) {
    return super.put(apiUrl.LDVL.soGhiChepCau.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maSo
   * @description Xóa sổ ghi chép cau
   */
  deleteSoGhiChepCau(maSo) {
    return super.delete(apiUrl.LDVL.soGhiChepCau.ADD_UPDATE_DELETE, {
      maSo: maSo,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách tổ chức
   */
  getListToChuc(obj): Observable<any> {
    return super.get(apiUrl.LDVL.toChuc.getList, obj);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách tổ chức theo tu khoa
   */
  getListToChucTK(obj): Observable<any> {
    return super.get(apiUrl.LDVL.toChuc.getListTK, obj);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách tổ chức
   */
  getToChucByMaTinh(obj): Observable<any> {
    return super.get(apiUrl.LDVL.toChuc.getToChucByMaTinh, obj);
  }

  getToChucByMaTinh_PhanTrang(obj): Observable<any> {
    return super.get(apiUrl.LDVL.toChuc.getToChucByMaTinh_PhanTrang, obj);
  }

  /**
   * @author psdung
   * @method GET
   * @param maSo
   * @description Danh sách sổ ghi chép cau id
   */
  getListToChucID(maSo) {
    return super.get(apiUrl.LDVL.toChuc.getTheoID + '/' + maSo);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Cập nhật danh sách tổ chức
   */
  addToChuc(requestBody) {
    return super.post(apiUrl.LDVL.toChuc.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật danh sách tổ chức
   */
  updateToChuc(requestBody) {
    return super.put(apiUrl.LDVL.toChuc.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maSo
   * @description Xóa danh sách tổ chức
   */
  deleteToChuc(maSo) {
    return super.delete(apiUrl.LDVL.toChuc.ADD_UPDATE_DELETE + '/', {
      maToChuc: maSo,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách thông tin người ghi
   */
  getTTNguoiGhi(maSo) {
    return super.get(apiUrl.LDVL.cauBanDau.getTTNguoiGhi, { maSo: maSo });
  }

  //  /**
  // * @author psdung
  // * @method GET
  // * @param requestBody
  // * @description Danh sách thông tin người ghi theo maSo
  // */
  //   getTTNguoiGhiTheoSoGhiChepcau(maSo) {
  //     return super.get(apiUrl.LDVL.cauBanDau.getTTNguoiGhiTheoSoGhiChepcau, {maSo: maSo});
  //   }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách sổ ghi chép cầu
   */
  getAllSoGhiChepCau() {
    return super.get(apiUrl.LDVL.soGhiChepCau.getAllSoGhiChepCau);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách cầu ban đầu
   */
  getListCauBanDau(
    page_size,
    page_number,
    maHuyen,
    maXa,
    quyenSo,
    nguoiGhi,
    nam
  ) {
    if (quyenSo != null) {
      return super.get(apiUrl.LDVL.cauBanDau.getCauLDTheoQuyenSo, {
        maSo: quyenSo,
        page_size: page_size,
        page_number: page_number,
        nam: nam,
      });
    } else if (nguoiGhi != null) {
      return super.get(apiUrl.LDVL.cauBanDau.getCauLDTheoNguoiGhiSo, {
        idNguoiGhi: nguoiGhi,
        page_size: page_size,
        page_number: page_number,
        nam: nam,
      });
    } else if (maXa == 'null') {
      return super.get(
        apiUrl.LDVL.cauBanDau.getCauLDTheoHuyenXa +
          '?page_size=' +
          page_size +
          '&page_number=' +
          page_number +
          '&maHuyen=' +
          maHuyen +
          '&nam=' +
          nam
      );
    } else {
      return super.get(
        apiUrl.LDVL.cauBanDau.getCauLDTheoHuyenXa +
          '?page_size=' +
          page_size +
          '&page_number=' +
          page_number +
          '&maHuyen=' +
          maHuyen +
          '&maXa=' +
          maXa +
          '&nam=' +
          nam
      );
    }
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách tổ chức biến động
   */
  getDanhSachToChuc(obj): Observable<any> {
    return super.get(apiUrl.LDVL.cauBanDau.getDanhSachToChuc, obj);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách tổ chức biến động
   */
  getDanhSachToChucBienDong(obj): Observable<any> {
    return super.get(apiUrl.LDVL.cauBanDau.getDanhSachToChucBienDong, obj);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới cau ban đầu
   */
  addCauBanDau(requestBody) {
    return super.post(apiUrl.LDVL.cauBanDau.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật cau ban đầu
   */
  updateCauBanDau(requestBody) {
    return super.put(apiUrl.LDVL.cauBanDau.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method DELETE
   * @param maHo
   * @description Xóa cau ban đầu
   */
  deleteCau(maSo, isDelete) {
    return super.delete(apiUrl.LDVL.cauBanDau.ADD_UPDATE_DELETE, {
      id: maSo,
      isDelete: isDelete,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get cầu lao động theo to chức
   */
  getCauLDTheoToChuc(maToChuc, nam) {
    return super.get(apiUrl.LDVL.cauBanDau.getCauLDTheoToChuc, {
      maToChuc: maToChuc,
      nam: nam,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param idCungBD
   * @description Danh sách thông tin lao động
   */
  getTTLaoDong(obj): Observable<any> {
    return super.get(apiUrl.LDVL.cauBanDau.getTTLaoDong, obj);
  }

  /**
   * @author psdung
   * @method PUT
   * @param requestBody
   * @description Cập nhật thông tin lao động
   */
  editTTLaoDong(requestBody) {
    return super.post(apiUrl.LDVL.cauBanDau.UPDATE_TTLaoDong, requestBody);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách cung lao động
   */
  getTraCuuNhanhCungLD(obj): Observable<any> {
    return super.get(apiUrl.LDVL.traCuuNhanh.getTraCuuNhanhCungLD, obj);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách cung lao động
   */
  getCauLaoDongBienDong(
    page_size,
    page_number,
    maHuyen,
    maXa,
    quyenSo,
    idNguoiGhi,
    nam
  ) {
    if (quyenSo != null) {
      return super.get(apiUrl.LDVL.cauBanDau.getCauLDBDtheoQuyenSo, {
        maSo: quyenSo,
        page_size: page_size,
        page_number: page_number,
        nam: nam,
      });
    } else if (idNguoiGhi != null) {
      return super.get(apiUrl.LDVL.cauBanDau.getCauLDBDTheoNguoiGhiSo, {
        idNguoiGhi: idNguoiGhi,
        page_size: page_size,
        page_number: page_number,
        nam: nam,
      });
    } else if (maXa == 'null') {
      return super.get(
        apiUrl.LDVL.cauBanDau.getCauLDBDTheoHuyenXa +
          '?page_size=' +
          page_size +
          '&page_number=' +
          page_number +
          '&maHuyen=' +
          maHuyen +
          '&nam=' +
          nam
      );
    } else {
      return super.get(
        apiUrl.LDVL.cauBanDau.getCauLDBDTheoHuyenXa +
          '?page_size=' +
          page_size +
          '&page_number=' +
          page_number +
          '&maHuyen=' +
          maHuyen +
          '&maXa=' +
          maXa +
          '&nam=' +
          nam
      );
    }
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  uploadFileImportCau(obj): Observable<any> {
    return super.post(apiUrl.LDVL.cauBanDau.importCau, obj);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description
   */
  checkFileImportCau(obj): Observable<any> {
    return super.post(apiUrl.LDVL.cauBanDau.checkImportCau, obj);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description download file mẫu
   */
  xuatFileImportCau(): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.cauBanDau.exportCau,
      'File mẫu import cầu lao động.xlsx'
    );
  }
  // minhvn.bte - IT5ASXH-6262 - 15/09/2022
  xuatFileImportCauBTE(): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.cauBanDau.exportCauBTE,
      'File mẫu import cầu lao động.xlsx'
    );
  }
  // End minhvn.bte - IT5ASXH-6262 - 15/09/2022

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới giải quyết việc làm
   */
  addGiaiQuyetViecLam(requestBody) {
    return super.post(apiUrl.LDVL.giaiQuyetViecLam.ADD_GQVL, requestBody);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách đối tượng (giải quyết lao động)
   */
  getListDoiTuong(obj): Observable<any> {
    return super.get(apiUrl.LDVL.giaiQuyetViecLam.getDoiTuong, obj);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách hộ gia đình theo sổ cung lao động
   */
  getHoTheoSo(page_size, page_number, quyenSo) {
    return super.get(apiUrl.LDVL.cungBanDau.getListTheoQuyenSo, {
      maSo: quyenSo,
      page_size: page_size,
      page_number: page_number,
    });
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Cập nhật giải quyết việc làm
   */
  editGiaiQuyetViecLam(requestBody) {
    return super.put(apiUrl.LDVL.giaiQuyetViecLam.UPDATE_GQVL, requestBody);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Xóa giải quyết việc làm
   */
  deleteGiaiQuyetViecLam(idGQVL) {
    return super.delete(apiUrl.LDVL.giaiQuyetViecLam.DELETE_GQVL, {
      id: idGQVL,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách đối tượng (giải quyết lao động)
   */

  getGiaQuyetViecLam(obj): Observable<any> {
    return super.post(apiUrl.LDVL.giaiQuyetViecLam.getGiaQuyetViecLam, obj);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get giải quyết việc làm id
   */
  getGiaiQuyetViecLamID(idGQVL) {
    return super.get(apiUrl.LDVL.giaiQuyetViecLam.getGQVLID + '/' + idGQVL);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách chỉ tiêu giải quyết việc làm
   */
  getChiTieuGQVL(obj): Observable<any> {
    return super.get(apiUrl.LDVL.chiTieuGQVL.getChiTieuGQVL, obj);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get chỉ tiêu giải quyết việc làm id
   */
  getChiTieuID(idGQVL) {
    return super.get(apiUrl.LDVL.chiTieuGQVL.getChiTieuID + '/' + idGQVL);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới chỉ tiêu giải quyết việc làm
   */
  addChiTieuGQVL(requestBody) {
    return super.post(apiUrl.LDVL.chiTieuGQVL.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Cập nhật chỉ tiêu giải quyết việc làm
   */
  updateChiTieuGQVL(requestBody) {
    return super.put(apiUrl.LDVL.chiTieuGQVL.ADD_UPDATE_DELETE, requestBody);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Xóa chỉ tiêu giải quyết việc làm
   */
  deleteChiTieuGQVL(idChiTieu) {
    return super.delete(apiUrl.LDVL.chiTieuGQVL.ADD_UPDATE_DELETE, {
      idChiTieu: idChiTieu,
    });
  }
  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get room
   */
  getRoom() {
    return super.get(apiUrl.LDVL.phongVanOnline.getRoom);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Thêm mới room
   */
  addRoom(requestBody) {
    return super.post(apiUrl.LDVL.phongVanOnline.meetingRoom, requestBody);
  }
  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get room theo id
   */
  getRoomID(idRoom) {
    return super.get(apiUrl.LDVL.phongVanOnline.getRoomID + '/' + idRoom);
  }
  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Cập nhật phòng pv trực tuyến
   */
  updateRoom(requestBody) {
    return super.put(apiUrl.LDVL.phongVanOnline.meetingRoom, requestBody);
  }
  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Xóa phòng pv trực tuyến
   */
  deleteRoom(idRoom) {
    return super.delete(apiUrl.LDVL.phongVanOnline.meetingRoom, { id: idRoom });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get room
   */
  getCloseRoom(idToChuc, thoiGianHop): Observable<any> {
    return super.put(
      apiUrl.LDVL.phongVanOnline.dongPhong +
        '?idToChuc=' +
        idToChuc +
        '&thoiGianHop=' +
        thoiGianHop
    );
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description
   */
  getDSPheDuyet() {
    return super.get(apiUrl.LDVL.phongVanOnline.getDSPheDuyet);
  }
  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description
   */
  getDSDaDuyet() {
    return super.get(apiUrl.LDVL.phongVanOnline.getDSDaDuyet);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Cập nhật phòng pv trực tuyến
   */
  pheDuyet(requestBody) {
    return super.put(apiUrl.LDVL.phongVanOnline.pheDuyet, requestBody);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get Excel bao cao so ghi chep cung
   */
  getBCSoGhiChepCung(maTinh, maXa, maThon, maSo, nam) {
    if (maXa == 'null') {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.soGhiChepCung +
          '?maTinh=' +
          maTinh,
        'Sổ ghi chép cung'
      );
    } else if (maThon == 'null') {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.soGhiChepCung +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa,
        'Sổ ghi chép cung'
      );
    } else if (maSo == 'null') {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.soGhiChepCung +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&maThon=' +
          maThon,
        'Sổ ghi chép cung'
      );
    } else if (nam == 'null') {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.soGhiChepCung +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&maThon=' +
          maThon +
          '&maSo=' +
          maSo,
        'Sổ ghi chép cung'
      );
    } else {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.soGhiChepCung +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&maThon=' +
          maThon +
          '&maSo=' +
          maSo +
          '&nam=' +
          nam,
        'Sổ ghi chép cung'
      );
    }
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PDF bao cao so ghi chep cung trang bia
   */
  getSoGhiChepCungTrangBia(
    maTinh,
    maXa,
    maThon,
    nam
  ): Observable<any> {
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };

    if (maXa == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepTrangBiaPDF +
          '?maTinh=' +
          maTinh +
        requestOptions
      );
    } else if (maThon == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepTrangBiaPDF +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa,
        requestOptions
      );
    } else if (nam == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepTrangBiaPDF +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&maThon=' +
          maThon,
        requestOptions
      );
    } else {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepTrangBiaPDF +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&maThon=' +
          maThon +
          '&nam=' +
          nam,
        requestOptions
      );
    }
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PDF so ghi chep cung TTCoBan
   */
  getSoGhiChepCungTTCoBan(maTinh, maXa, maThon, nam): Observable<any> {
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };

    if (maXa == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepTTCoBan +
          '?maTinh=' +
          maTinh,
        requestOptions
      );
    } else if (maThon == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepTTCoBan +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa,
        requestOptions
      );
    } else if (nam == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepTTCoBan +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&maThon=' +
          maThon,
        requestOptions
      );
    } else {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepTTCoBan +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&maThon=' +
          maThon +
          '&nam=' +
          nam,
        requestOptions
      );
    }
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PDF bao cao so ghi chep bang ke
   */
  getSoGhiChepBangKe(maTinh, maXa, maThon, nam): Observable<any> {
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };

    if (maXa == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepBangKe +
          '?maTinh=' +
          maTinh,
        requestOptions
      );
    } else if (maThon == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepBangKe +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa,
        requestOptions
      );
    } else if (nam == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepBangKe +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&maThon=' +
          maThon,
        requestOptions
      );
    } else {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepBangKe +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&maThon=' +
          maThon +
          '&nam=' +
          nam,
        requestOptions
      );
    }
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get Excel bao cao so ghi chep cau
   */
  getBCSoGhiChepCau(maTinh, maXa, tuNam, denNam): Observable<any> {
    if (maXa == 'null') {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.soGhiChepCau +
          '?maTinh=' +
          maTinh,
        'Sổ ghi chép cầu'
      );
    } else if (tuNam == 'null') {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.soGhiChepCau +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa,
        'Sổ ghi chép cầu'
      );
    } else {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.soGhiChepCau +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&tuNam=' +
          tuNam +
          '&denNam=' +
          denNam,
        'Sổ ghi chép cầu'
      );
    }
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PdF bao cao tong hop cung cau
   */
  xuatBaoCaoTongHopCungCau(
    maTinh,
    maXa,
    nam,
    type,
    tenTinh,
    maubaocao,
    namBTE,
    trangThaiNgayGhi
  ): Observable<any> {
    if (maXa == 'null') {
      if (maTinh == 86)
        return super.downloadFile(
          apiUrl.LDVL.baoCao.getBCTongHopCungCauXuatFile +
            '?maTinh=' +
            maTinh +
            '&nam=' +
            nam +
            '&tenTinh=' +
            tenTinh +
            '&type=' +
            type +
            '&namBTE=' +
            namBTE +
            '&idTrangThai=' +
            trangThaiNgayGhi,
          'Báo cáo tổng hợp cung cầu lao động'
        );
      if (maubaocao == 1) {
        return super.downloadFile(
          apiUrl.LDVL.baoCao.getBCTongHopCungCau +
            '?maTinh=' +
            maTinh +
            '&nam=' +
            nam +
            '&type=' +
            type +
            '&namBTE=' +
            namBTE +
            '&idTrangThai=' +
            trangThaiNgayGhi,
          'Báo cáo tổng hợp cung cầu lao động'
        );
      } else if (maubaocao == 2) {
        return super.downloadFile(
          apiUrl.LDVL.baoCao.getBCTongHopCungCauMau2STG +
            '?maTinh=' +
            maTinh +
            '&nam=' +
            nam +
            '&type=' +
            type +
            '&namBTE=' +
            namBTE,
          'Báo cáo tổng hợp cung cầu lao động mẫu 2'
        );
      } else if (maubaocao == 3) {
        return super.downloadFile(
          apiUrl.LDVL.baoCao.getBCTongHopCungCauMau3STG +
            '?maTinh=' +
            maTinh +
            '&nam=' +
            nam +
            '&type=' +
            type +
            '&namBTE=' +
            namBTE,
          'Báo cáo tổng hợp cung cầu lao động mẫu 3'
        );
      } else if (maubaocao == 4) {
        return super.downloadFile(
          apiUrl.LDVL.baoCao.getBCTongHopCungCauMau4STG +
            '?maTinh=' +
            maTinh +
            '&nam=' +
            nam +
            '&type=' +
            type +
            '&namBTE=' +
            namBTE,
          'Báo cáo tổng hợp cung cầu lao động mẫu 4'
        );
      }
    } else {
        if (maTinh == 86)
        return super.downloadFile(
          apiUrl.LDVL.baoCao.getBCTongHopCungCauXuatFile +
            '?maTinh=' +
            maTinh +
            '&maXa=' +
            maXa +
            '&nam=' +
            nam +
            '&tenTinh=' +
            tenTinh +
            '&type=' +
            type +
            '&namBTE=' +
            namBTE +
            '&idTrangThai=' +
            trangThaiNgayGhi,
          'Báo cáo tổng hợp cung cầu lao động'
        );
      if (maubaocao == 1) {
        return super.downloadFile(
          apiUrl.LDVL.baoCao.getBCTongHopCungCau +
            '?maTinh=' +
            maTinh +
            '&maXa=' +
            maXa +
            '&nam=' +
            nam +
            '&type=' +
            type +
            '&namBTE=' +
            namBTE +
            '&idTrangThai=' +
            trangThaiNgayGhi,
          'Báo cáo tổng hợp cung cầu lao động'
        );
      } else if (maubaocao == 2) {
        return super.downloadFile(
          apiUrl.LDVL.baoCao.getBCTongHopCungCauMau2STG +
            '?maTinh=' +
            maTinh +
            '&nam=' +
            nam +
            '&type=' +
            type +
            '&namBTE=' +
            namBTE,
          'Báo cáo tổng hợp cung cầu lao động mẫu 2'
        );
      } else if (maubaocao == 3) {
        return super.downloadFile(
          apiUrl.LDVL.baoCao.getBCTongHopCungCauMau3STG +
            '?maTinh=' +
            maTinh +
            '&nam=' +
            nam +
            '&type=' +
            type +
            '&namBTE=' +
            namBTE,
          'Báo cáo tổng hợp cung cầu lao động mẫu 3'
        );
      } else if (maubaocao == 4) {
        return super.downloadFile(
          apiUrl.LDVL.baoCao.getBCTongHopCungCauMau4STG +
            '?maTinh=' +
            maTinh +
            '&nam=' +
            nam +
            '&type=' +
            type +
            '&namBTE=' +
            namBTE,
          'Báo cáo tổng hợp cung cầu lao động mẫu 4'
        );
      }
    }
  }

  /**
   * @author nhanhh.dtp
   */
  getBCTongHopCungCauDTP(maTinh, maXa, nam, type): Observable<any> {
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };
    if (maXa == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.getBCTongHopCungCauDTP +
          '?maTinh=' +
          maTinh +
          '&nam=' +
          nam +
          '&type=' +
          type,
        requestOptions
      );
    } else {
      return this.http.get(
        apiUrl.LDVL.baoCao.getBCTongHopCungCauDTP +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&nam=' +
          nam +
          '&type=' +
          type,
        requestOptions
      );
    }
  }

  /**
   * @author nhanhh.dtp
   */
  xuatBaoCaoTongHopCungCauDTP(maTinh, maXa, nam, type): Observable<any> {
    if (maXa == 'null') {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.getBCTongHopCungCauDTP +
          '?maTinh=' +
          maTinh +
          '&nam=' +
          nam +
          '&type=' +
          type,
        'Báo cáo tổng hợp cung cầu lao động DTP'
      );
    } else {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.getBCTongHopCungCauDTP +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&nam=' +
          nam +
          '&type=' +
          type,
        'Báo cáo tổng hợp cung cầu lao động DTP'
      );
    }
  }

   /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PDF bao cao so ghi chep cung trang bia
   */
  getBCTongHopCungCau(
    maTinh,
    maXa,
    nam,
    type,
    tenTinh,
    namBTE,
    trangThaiNgayGhi
  ): Observable<any> {
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };
    if (maXa == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.getBCTongHopCungCauXuatFile +
          '?maTinh=' +
          maTinh +
          '&nam=' +
          nam +
          '&type=' +
          type +
          '&tenTinh=' +
          tenTinh +
          '&namBTE=' +
          namBTE +
          '&idTrangThai=' +
          trangThaiNgayGhi,
        requestOptions
      );
    } else {
      return this.http.get(
        apiUrl.LDVL.baoCao.getBCTongHopCungCauXuatFile +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&nam=' +
          nam +
          '&type=' +
          type +
          '&tenTinh=' +
          tenTinh +
          '&namBTE=' +
          namBTE +
          '&idTrangThai=' +
          trangThaiNgayGhi,
        requestOptions
      );
    }
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get Excel bao cao
   */
  getBCToChuc(idToChuc, nam): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.baoCao.getBCToChuc + '?idToChuc=' + idToChuc + '&nam=' + nam,
      'Báo cáo tổ chức'
    );
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get Excel bao cao
   */
  getBCThanhVien(idThanhVien): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.baoCao.getBCThanhVien + '?idThanhVien=' + idThanhVien,
      'Báo cáo thành viên'
    );
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PDF so ghi chep cau trang bia
   */
  getSoGhiChepCauTrangBia(
    maTinh,
    maXa,
    tuNam,
    denNam
  ): Observable<any> {
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };

    if (maXa == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepCauTrangBiaPDF +
          '?maTinh=' +
          maTinh,
        requestOptions
      );
    } else if (tuNam == null) {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepCauTrangBiaPDF +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa,
        requestOptions
      );
    } else {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepCauTrangBiaPDF +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&tuNam=' +
          tuNam +
          '&denNam=' +
          denNam,
        requestOptions
      );
    }
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PDF bao cao so ghi chep cau TT Co Ban
   */
  getSoGhiChepCauTTCoBan(
    maTinh,
    maXa,
    tuNam,
    denNam
  ): Observable<any> {
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };

    if (maXa == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepCauTTCoBan +
          '?maTinh=' +
          maTinh ,
        requestOptions
      );
    } else if (tuNam == null) {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepCauTTCoBan +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa,
        requestOptions
      );
    } else {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepCauTTCoBan +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&tuNam=' +
          tuNam +
          '&denNam=' +
          denNam,
        requestOptions
      );
    }
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PdF bao cao so ghi chep cau bao cao
   */
  getSoGhiChepCauBangKe(maTinh, maXa, tuNam, denNam): Observable<any> {
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };

    if (maXa == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepCauBangKe +
          '?maTinh=' +
          maTinh,
        requestOptions
      );
    } else if (tuNam == null) {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepCauBangKe +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa,
        requestOptions
      );
    } else {
      return this.http.get(
        apiUrl.LDVL.baoCao.soGhiChepCauBangKe +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&tuNam=' +
          tuNam +
          '&denNam=' +
          denNam,
        requestOptions
      );
    }
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get Excel bao cao thong tin TTLD cap xa
   */
  getBCCapXa(maTinh, maXa, nam): Observable<any> {
    if (maXa == 'null') {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.baoCaoCapXa +
          '?maTinh=' +
          maTinh,
        'Thông tin TTLĐ cấp xã'
      );
    } else if (nam == null) {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.baoCaoCapXa +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa,
        'Thông tin TTLĐ cấp xã'
      );
    } else {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.baoCaoCapXa +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&nam=' +
          nam,
        'Thông tin TTLĐ cấp xã'
      );
    }
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PdF bao cao cung cap xa
   */
  getBCCungCapXa(maTinh, maXa, nam): Observable<any> {
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };

    if (maXa == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.cungCapXa +
          '?maTinh=' +
          maTinh +
        requestOptions
      );
    } else if (nam == null) {
      return this.http.get(
        apiUrl.LDVL.baoCao.cungCapXa +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa,
        requestOptions
      );
    }
    {
      return this.http.get(
        apiUrl.LDVL.baoCao.cungCapXa +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&nam=' +
          nam,
        requestOptions
      );
    }
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PdF bao cao chi tiet cung cap xa
   */
  getBCChiTietCungCapXa(maTinh, maXa, nam): Observable<any> {
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };

    if (maXa == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.chiTietCungCapXa +
          '?maTinh=' +
          maTinh +
        requestOptions
      );
    } else if (nam == null) {
      return this.http.get(
        apiUrl.LDVL.baoCao.chiTietCungCapXa +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa,
        requestOptions
      );
    }
    {
      return this.http.get(
        apiUrl.LDVL.baoCao.chiTietCungCapXa +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&nam=' +
          nam,
        requestOptions
      );
    }
  }

  /**
   * @author nhanhh.dtp
   * @method POST
   * @param requestBody
   * @description Get PdF bao cao ve thong tin thi truong lao dong nam ...
   */
  getBCCungCapXaVeThongTinThiTruongLaoDongDTP(
    maTinh,
    maXa,
    nam
  ): Observable<any> {
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };

    if (maXa == 'null') {
      return this.http.get(
        apiUrl.LDVL.baoCao.cungCapXaVeThongTinLaoDongDTP +
          '?maTinh=' +
          maTinh +
        requestOptions
      );
    } else if (nam == null) {
      return this.http.get(
        apiUrl.LDVL.baoCao.cungCapXaVeThongTinLaoDongDTP +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa,
        requestOptions
      );
    }
    {
      return this.http.get(
        apiUrl.LDVL.baoCao.cungCapXaVeThongTinLaoDongDTP +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&nam=' +
          nam,
        requestOptions
      );
    }
  }

  /**
   * @author nhanhh.dtp
   * @method POST
   * @param requestBody
   * @description Get Excel bao cao thong tin TTLD cap xa
   */
  getBCCungCapXaVeThongTinThiTruongLaoDongDTP_Excel(
    maTinh,
    maXa,
    nam
  ): Observable<any> {
    if (maXa == 'null') {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.cungCapXaVeThongTinLaoDongDTPExcel +
          '?maTinh=' +
          maTinh,
        'Thông tin TTLĐ cấp xã - DTP'
      );
    } else if (nam == null) {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.cungCapXaVeThongTinLaoDongDTPExcel +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa,
        'Thông tin TTLĐ cấp xã - DTP'
      );
    } else {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.cungCapXaVeThongTinLaoDongDTPExcel +
          '?maTinh=' +
          maTinh +
          '&maXa=' +
          maXa +
          '&nam=' +
          nam,
        'Thông tin TTLĐ cấp xã - DTP'
      );
    }
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách tổ chức theo ATVSLD
   */
  getATVSLDTheoHuyenXa(obj): Observable<any> {
    return super.get(apiUrl.LDVL.atvsld.getATVSLDTheoHuyenXa, obj);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách an toàn vệ sinh lao động
   */
  getListATVSLD(): Observable<any> {
    return super.get(apiUrl.LDVL.atvsld.getList);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách an toàn vệ sinh lao động theo tổ chức
   */
  getListATVSLDByToChuc(data): Observable<any> {
    return super.get(apiUrl.LDVL.atvsld.getByToChuc, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách an toàn vệ sinh lao động theo tổ chức
   */
  addATVSLD(obj): Observable<any> {
    return super.post(apiUrl.LDVL.atvsld.add_edit_delete, obj);
  }

  // getAnhATVSLD(id): Observable<any> {
  //     return super.get(apiUrl.LDVL.atvsld.load_image + "/" + id);
  // }

  getAnhATVSLD(fileID): Observable<any> {
    // return super.get(apiUrl.GDNN.CAN_BO_QUAN_LY.GET_ANH_DAI_DIEN + fileID);
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };
    return this.http.get(
      apiUrl.LDVL.atvsld.load_image + '/' + fileID,
      requestOptions
    );
  }

  uploadImgATVSLD(file, originalFilename, idToChuc, fileName, ngayGhi) {
    const payload = {
      file: file,
      originalFilename: originalFilename,
      idToChuc: idToChuc,
      ngayGhi: ngayGhi,
      fileName: fileName,
    };
    return super.post(apiUrl.LDVL.atvsld.upload_image, payload);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Phê duyệt an toàn vệ sinh lao động
   */
  pheDuyetATVSLD(idToChuc, ngayGhi) {
    return super.put(
      apiUrl.LDVL.atvsld.pheDuyet +
        '?idToChuc=' +
        idToChuc +
        '&ngayGhi=' +
        ngayGhi
    );
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Từ chối báo cáo an toàn vệ sinh lao động
   */
  tuChoiATVSLD(idToChuc, ngayGhi, lyDoTuChoi) {
    return super.put(
      apiUrl.LDVL.atvsld.tuChoi +
        '?idToChuc=' +
        idToChuc +
        '&ngayGhi=' +
        ngayGhi +
        '&lyDoTuChoi=' +
        lyDoTuChoi
    );
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PdF bao cao chi tiet cung cap xa
   */
  xuatBienBanATVSLD(idDonViDuocKT, ngayKT): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.atvsld.xuatBienBanATVSLD +
        '?idDonViDuocKT=' +
        idDonViDuocKT +
        '&ngayKT=' +
        ngayKT,
      'Biên bản an toàn vệ sinh lao động'
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Trạng thái biên bản kiểm tra
   */
  getBienBanKiemTra() {
    return super.get(apiUrl.LDVL.atvsld.bienBanKiemTra);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách doanh nghiệp đã kiểm tra
   */
  getDSDoanhNghiepDaKT(data): Observable<any> {
    return super.get(apiUrl.LDVL.atvsld.getDSDoanhNghiepDaKT, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  addBienBanKT(data): Observable<any> {
    return super.post(apiUrl.LDVL.atvsld.ADD_EDIT, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  editBienBanKT(data): Observable<any> {
    return super.put(apiUrl.LDVL.atvsld.ADD_EDIT, data);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PdF bao cao ATVSLD
   */
  getBaoCaoATVSLD(idToChuc, maTinh, maXa, nam): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.atvsld.xuatBaoCao +
        '?idToChuc=' +
        idToChuc +
        '&maTinh=' +
        maTinh +
        '&maXa=' +
        maXa +
        '&nam=' +
        nam,
      'Báo cáo an toàn vệ sinh lao động'
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Thông tin đơn vị được kiểm tra
   */
  getAllDonViDuocKT() {
    return super.get(apiUrl.LDVL.atvsld.getAllDonViDuocKT);
  }

  /**
   * @author psdung
   * @method GET
   * @param
   * @description Thông tin đơn vị được kiểm tra
   */
  getAllDoanKT() {
    return super.get(apiUrl.LDVL.atvsld.getAllDoanKT);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  addDoanKT(data): Observable<any> {
    return super.post(apiUrl.LDVL.atvsld.ADD_EDIT_DELETE_DKT, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  editDoanKT(data): Observable<any> {
    return super.put(apiUrl.LDVL.atvsld.ADD_EDIT_DELETE_DKT, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  deleteDoanKT(idDoanKT): Observable<any> {
    return super.delete(apiUrl.LDVL.atvsld.ADD_EDIT_DELETE_DKT, {
      idDoanKT: idDoanKT,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  addDonViDuocKT(data): Observable<any> {
    return super.post(apiUrl.LDVL.atvsld.ADD_EDIT_DELETE_DVDKT, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  editDonViDuocKT(data): Observable<any> {
    return super.put(apiUrl.LDVL.atvsld.ADD_EDIT_DELETE_DVDKT, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  deleteDonViDuocKT(idDonViDuocKT): Observable<any> {
    return super.delete(apiUrl.LDVL.atvsld.ADD_EDIT_DELETE_DVDKT, {
      idDonViDuocKT: idDonViDuocKT,
    });
  }

  //Người nước ngoài làm việc tại Việt Nam
  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get tổ chức
   */
  //Người nước ngoài làm việc tại Việt Nam
  getByToChucNNNLVTVN(data): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getByToChucNNNLVTVN, data);
  }

  //Người nước ngoài làm việc tại Việt Nam
  /**
   * @author AnhNT
   * @method GET
   * @param requestParam
   * @description Get thông tin
   */
  //Người nước ngoài làm việc tại Việt Nam
  getTTNLLVTVN(
    maXa,
    pageSize,
    pageNumber,
    isDelete = 0
  ): Observable<any> {
    const token = localStorage.getItem(AUTH.TOKEN_KEY);
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + token);
    headers.append('Access-Control-Allow-Origin', '*');
    return this.http.get(
      apiUrl.LDVL.nguoiNNLVTaiVN.getTTNLLVTVN +
        '?maXa=' +
        maXa +
        '&pageSize=' +
        pageSize +
        '&pageNumber=' +
        pageNumber +
        '&trangThai=' +
        isDelete,
      { headers }
    );
  }

  getTTNLLVTVNMau03(
    maTinh,
    maXa,
    pageSize,
    pageNumber,
    tenDoanhNghiep,
    maSoThue,
    kcn,
    isDelete = 0
  ): Observable<any> {
    const token = localStorage.getItem(AUTH.TOKEN_KEY);
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + token);
    headers.append('Access-Control-Allow-Origin', '*');
    if (maTinh == 86) {
      return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getTTNLLVTVN_BTE, {
        maXa: maXa,
        pageSize: pageSize,
        pageNumber: pageNumber,
        tenDoanhNghiep: tenDoanhNghiep,
        maSoThue: maSoThue,
        kcn: kcn,
      });
    } else {
      return this.http.get(
        apiUrl.LDVL.nguoiNNLVTaiVN.getTTNLLVTVN +
          '?maXa=' +
          maXa +
          '&pageSize=' +
          pageSize +
          '&pageNumber=' +
          pageNumber +
          '&trangThai=' +
          isDelete,
        { headers }
      );
    }
  }
  ///////////////////////////////////////////////////////////////////////////

  getTTNLLVTVN_STG(
    maXa,
    pageSize,
    pageNumber,
    isDelete = 0
  ): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getTTNLLVTVN_STG, {
      maXa: maXa,
      pageSize: pageSize,
      pageNumber: pageNumber,
      isDelete: isDelete,
    });
  }

  addNewTTNLLVTVN_STG(body): Observable<any> {
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.addNewM03_STG, body);
  }

  UpdateTTNLVTVN_STG(body): Observable<any> {
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.updateM03_STG, body);
  }

  xuatTTNLVTVN_STG(id): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.nguoiNNLVTaiVN.xuatM03_STG + '?id=' + id,
      'Mẫu số 03 THÔNG TIN NGƯỜI LAO ĐỘNG NƯỚC NGOÀI LÀM VIỆCTẠI VIỆT NAM'
    );
  }

  findTTNLVTVN_STG(soHoChieu, soGiayPhep): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.findTTNLVTVN_STG, {
      soHoChieu: soHoChieu,
      soGiayPhep: soGiayPhep,
    });
  }

  giaHanTTNLVTVN_STG(body): Observable<any> {
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.giaHanM03_STG, body);
  }

  capLaiTTNLVTVN_STG(body): Observable<any> {
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.capLaiM03_STG, body);
  }

  koCapTTNLVTVN_STG(body): Observable<any> {
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.koCapM03_STG, body);
  }

  DeleteTTNLVTVN_STG(id, isdelete): Observable<any> {
    return super.delete(apiUrl.LDVL.nguoiNNLVTaiVN.deleteM03_STG, {
      id: id,
      isdelete: isdelete,
    });
  }

  thuHoiTTNLVTVN_STG(body): Observable<any> {
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.thuHoiM03_STG, body);
  }

  getDSCPLD_STG(nam, loaiFile = 0): Observable<any> {
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };

    return this.http.get(
      apiUrl.LDVL.nguoiNNLVTaiVN.xuatDSCPLD_STG +
        '?nam=' +
        nam +
        '&loaiFile=' +
        loaiFile,
      requestOptions
    );
  }

  xuatDSCPLD_STG(nam, loaiFile = 0): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.nguoiNNLVTaiVN.xuatDSCPLD_STG +
        '?nam=' +
        nam +
        '&loaiFile=' +
        loaiFile,
      'Danh sách cấp phép lao động ' + nam
    );
  }

  getBCTHLDNN_STG(nam, loaiFile = 0): Observable<any> {
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };

    return this.http.get(
      apiUrl.LDVL.nguoiNNLVTaiVN.xuatBCTHLDNN_STG +
        '?nam=' +
        nam +
        '&loaiFile=' +
        loaiFile,
      requestOptions
    );
  }

  xuatBCTHLDNN_STG(nam, loaiFile = 0): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.nguoiNNLVTaiVN.xuatBCTHLDNN_STG +
        '?nam=' +
        nam +
        '&loaiFile=' +
        loaiFile,
      'Báo cáo tình hình lao động nước ngoài ' + nam
    );
  }

  getDS_TTNLLVTVN_STG(maXa, trangThai, loaiFile = 0): Observable<any> {
    let requestOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Content-Type': 'application/json',
      }),
    };

    return this.http.get(
      apiUrl.LDVL.nguoiNNLVTaiVN.xuatDS_TTNLLVTVN_STG +
        '?maXa=' +
        maXa +
        '&trangThai=' +
        trangThai +
        '&loaiFile=' +
        loaiFile,
      requestOptions
    );
  }

  xuatDS_TTNLLVTVN_STG(maXa, trangThai, loaiFile): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.nguoiNNLVTaiVN.xuatDS_TTNLLVTVN_STG +
        '?maXa=' +
        maXa +
        '&trangThai=' +
        trangThai +
        '&loaiFile=' +
        loaiFile,
      'Danh sách TTNLLVTVN'
    );
  }

  getImportTemplate_TTNLLVTVN_STG(): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.nguoiNNLVTaiVN.getImportTemplate_TTNLLVTVN_STG,
      'File_Mau_Import_LDNN_LamViecTai_VN.xlsx'
    );
  }

  getFileDSToChuc_TTNLLVTVN_STG(maTinh): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.nguoiNNLVTaiVN.getFileDSToChuc_TTNLLVTVN_STG +
        '?maTinh=' +
        maTinh,
      'DS_ToChuc.xlsx'
    );
  }

  importDS_TTNLLVTVN_STG(file): Observable<any> {
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.importDS_TTNLLVTVN_STG, file);
  }

  ///////////////////////////////////////////////////////////////////////////

  /**
   * @author AnhNT
   * @method GET
   * @param requestBody
   * @description Them mới thông tin Người nước ngoài làm việc tại Việt Nam
   */
  //Người nước ngoài làm việc tại Việt Nam
  addNewM03(body): Observable<any> {
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.addNewM03, body);
  }

  /**
   * @author AnhNT
   * @method GET
   * @param requestBody
   * @description Cập nhật tt Người nước ngoài làm việc tại Việt Nam
   */
  //Người nước ngoài làm việc tại Việt Nam
  UpdateM03(body): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.updateM03, body);
  }

  /**
   * @author AnhNT
   * @method GET
   * @param requestBody
   * @description Xóa tt Người nước ngoài làm việc tại Việt Nam
   */
  //Người nước ngoài làm việc tại Việt Nam
  DeleteM03(id, isdelete): Observable<any> {
    return super.delete(apiUrl.LDVL.nguoiNNLVTaiVN.deleteM03, {
      id: id,
      isdelete: isdelete,
    });
  }

  /**
   * @author AnhNT
   * @method GET
   * @param requestBody
   * @description Xuất mẫu tt Người nước ngoài làm việc tại Việt Nam
   */
  //Người nước ngoài làm việc tại Việt Nam
  xuatM03(id): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.nguoiNNLVTaiVN.xuatM03 + '?id=' + id,
      'Mẫu số 03 THÔNG TIN NGƯỜI LAO ĐỘNG NƯỚC NGOÀI LÀM VIỆCTẠI VIỆT NAM'
    );
    //return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.xuatM03, {id:id});
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  //  uploadFileImg(data): Observable<any> {
  //     return super.post(apiUrl.congTy.uploadFileNNNLDTVN, data);
  // }
  uploadFileImg(selectedFilesMau01, idToChuc, fileBoSungS): Observable<any> {
    const payload = {
      selectedFilesMau01: selectedFilesMau01,
      idToChuc: idToChuc,
      fileBoSungS: fileBoSungS,
    };
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.uploadFileNNNLDTVN, payload);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  suaDangKyNhuCauSuDung(data): Observable<any> {
    return super.put(
      apiUrl.LDVL.nguoiNNLVTaiVN.ADD_EDIT_DELETE_dangKyNhuCau,
      data
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  themDangKyNhuCauSuDung(data): Observable<any> {
    return super.post(
      apiUrl.LDVL.nguoiNNLVTaiVN.ADD_EDIT_DELETE_dangKyNhuCau,
      data
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  xoaDangKyNhuCauSuDung(idNhuCauSuDungLD, status): Observable<any> {
    return super.delete(
      apiUrl.LDVL.nguoiNNLVTaiVN.ADD_EDIT_DELETE_dangKyNhuCau,
      { idNhuCauSuDungLD: idNhuCauSuDungLD, status: status }
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  xoaFile(fileID, status): Observable<any> {
    return super.delete(apiUrl.LDVL.nguoiNNLVTaiVN.xoaFile, {
      fileID: fileID,
      status: status,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  xoaFileThayDoi(fileID, status): Observable<any> {
    return super.delete(apiUrl.LDVL.nguoiNNLVTaiVN.xoaFileThayDoi, {
      fileID: fileID,
      status: status,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  pheDuyetNguoiNNLDTVN(idNhuCauSuDungLD, status): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.pheDuyet, {
      idNhuCauSuDungLD: idNhuCauSuDungLD,
      status: status,
    });
  }
  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get tổ chức
   */
  getListViTriCV(idNhuCauSDLD): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.listViTriCV, {
      idNhuCauSuDungLD: idNhuCauSDLD,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get tổ chức
   */
  getAllViTriCV(): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getAllViTri);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get tổ chức
   */
  getTrinhDoChuyenMon(): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.trinhDoChuyenMon);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get tổ chức
   */
  getHinhThucLamViec(): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.hinhThucLamViec);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get
   */
  getNgheCongViec(): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.ngheCongViec);
  }

  getgiaypheplaodong(): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.giaypheplaodong);
  }
  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get
   */
  getTrinhDo(): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.trinhDo);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  suaViTriCV(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.viTriCV_ADD_EDIT_DELETE, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  themViTriCV(data): Observable<any> {
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.viTriCV_ADD_EDIT_DELETE, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  xoaViTriCV(id, status): Observable<any> {
    return super.delete(apiUrl.LDVL.nguoiNNLVTaiVN.viTriCV_ADD_EDIT_DELETE, {
      id: id,
      status: status,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  capPhepNguoiNNLDTVN(idNhuCauSuDungLD): Observable<any> {
    return super.put(
      apiUrl.LDVL.nguoiNNLVTaiVN.capPhep +
        '?idNhuCauSuDungLD=' +
        idNhuCauSuDungLD
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  xuLyNguoiNNLDTVN(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.xuLy, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  daTiepNhanNguoiNNLDTVN(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.daTiepNhan, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  tuChoiNguoiNNLDTVN(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.tuChoi, data);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PdF bao cao cap phep nhu cau su dung lao dong
   */
  xuatBaoCaoDKNhuCau(idNhuCauSuDungLD): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.nguoiNNLVTaiVN.xuatBaoCaoDKNhuCau +
        '?idNhuCauSuDungLD=' +
        idNhuCauSuDungLD,
      'Báo cáo nhu cầu sử dụng lao động'
    );
  }

  //Cấp phép
  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PdF bao cao cap phep
   */
  xuatBaoCaoCapPhep(idDKCapPhepLD): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.nguoiNNLVTaiVN.xuatBaoCaoCapPhep +
        '?idDKCapPhepLD=' +
        idDKCapPhepLD,
      'Báo cáo cấp giấy phép'
    );
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PdF bao cao cap phep lai
   */
  xuatBaoCaoCapPhepLai(idDKCapPhepLD): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.nguoiNNLVTaiVN.baoCaoCapPhepLai +
        '?idDKCapLaiGiayPhepLD=' +
        idDKCapPhepLD,
      'Báo cáo cấp giấy phép lại'
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get tổ chức
   */
  getAllLyDoCapLai(): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getAllLyDoCapLai);
  }
  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  uploadFileImgCapPhep(obj): Observable<any> {
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.upLoadImgeCapPhep, obj);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  xoaFileCapPhep(fileID): Observable<any> {
    return super.delete(apiUrl.LDVL.nguoiNNLVTaiVN.xoaFileCapPhep, {
      fileID: fileID,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get mã chấp thuận
   */
  getByMaTB(data): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getByMaTB, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get tổ chức cấp phép
   */
  getByToChucCapPhep(data): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getAllByStatus, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  suaCapPhep(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.capPhep_ADD_EDIT_DELETE, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  themCapPhep(data): Observable<any> {
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.capPhep_ADD_EDIT_DELETE, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  xoaCapPhep(id, status): Observable<any> {
    return super.delete(apiUrl.LDVL.nguoiNNLVTaiVN.capPhep_ADD_EDIT_DELETE, {
      idDKCapPhepLD: id,
      status: status,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  capPhep(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.capPhepCapPhep, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  xuLyCapPhep(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.xuLyCapPhep, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  daTiepNhanCapPhep(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.daTiepNhanCapPhep, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  tuChoiCapPhep(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.tuChoiCapPhep, data);
  }

  //Thay đổi yêu cầu đăng ký sử dụng lao động
  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get vị trí công việc thay đổi
   */
  getListThayDoi(data): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getListThayDoiYeuCau, data);
  }
  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  suaThayDoiYeuCau(data): Observable<any> {
    return super.put(
      apiUrl.LDVL.nguoiNNLVTaiVN.thayDoiYeuCau_ADD_EDIT_DELETE,
      data
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  themThayDoiYeuCau(data): Observable<any> {
    return super.post(
      apiUrl.LDVL.nguoiNNLVTaiVN.thayDoiYeuCau_ADD_EDIT_DELETE,
      data
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get vị trí công việc thay đổi
   */
  getAllViTriCVThayDoi(idNhuCauSuDungLD): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getViTriCVThayDoiYeuCau, {
      idNhuCauSuDungLD: idNhuCauSuDungLD,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  suaViTriCVThayDoi(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.viTriCVThayDoi_ADD_EDIT, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  themViTriCVThayDoi(data): Observable<any> {
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.viTriCVThayDoi_ADD_EDIT, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  uploadFileThayDoi(
    fileMau02,
    idToChuc,
    fileBoSungThayDoiNhuCau
  ): Observable<any> {
    const payload = {
      fileMau02: fileMau02,
      idToChuc: idToChuc,
      fileBoSungThayDoiNhuCau: fileBoSungThayDoiNhuCau,
    };
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.uploadAnhThayDoi, payload);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  capPhepThayDoi(idNhuCauSuDungLD): Observable<any> {
    return super.put(
      apiUrl.LDVL.nguoiNNLVTaiVN.capPhepThayDoiYeuCau +
        '?idNhuCauSuDungLD=' +
        idNhuCauSuDungLD
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  xuLyThayDoi(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.xuLyThayDoiYeuCau, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  daTiepNhanThayDoi(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.tiepNhanThayDoiYeuCau, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  tuChoiThayDoi(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.tuChoiThayDoiYeuCau, data);
  }

  /**
   * @author psdung
   * @method POST
   * @param requestBody
   * @description Get PdF bao cao cap phep thay doi nhu cau su dung lao dong
   */
  xuatBaoCaoThayDoi(idNhuCauSuDungLD): Observable<any> {
    return super.downloadFile(
      apiUrl.LDVL.nguoiNNLVTaiVN.xuatBaoCaoThayDoi +
        '?idThayDoiNhuCauSuDungLD=' +
        idNhuCauSuDungLD,
      'Báo cáo thay đổi nhu cầu sử dụng lao động'
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get vị trí công việc cũ
   */
  getAllViTriCVOld(maTB): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getViTriCVOld, { maTB: maTB });
  }

  //Cấp phép lại
  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  uploadFileImgCapPhepLai(obj): Observable<any> {
    return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.upLoadImgeCapPhepLai, obj);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  xoaFileCapPhepLai(fileID): Observable<any> {
    return super.delete(apiUrl.LDVL.nguoiNNLVTaiVN.xoaFileCapPhepLai, {
      fileID: fileID,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get tổ chức cấp phép
   */
  getByToChucCapPhepLai(data): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getAllByStatusLai, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  suaCapPhepLai(data): Observable<any> {
    return super.put(
      apiUrl.LDVL.nguoiNNLVTaiVN.capPhepLai_ADD_EDIT_DELETE,
      data
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  themCapPhepLai(data): Observable<any> {
    return super.post(
      apiUrl.LDVL.nguoiNNLVTaiVN.capPhepLai_ADD_EDIT_DELETE,
      data
    );
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  xoaCapPhepLai(id, status): Observable<any> {
    return super.delete(apiUrl.LDVL.nguoiNNLVTaiVN.capPhepLai_ADD_EDIT_DELETE, {
      idDKCapPhepLD: id,
      status: status,
    });
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  capPhepLai(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.capPhepCapPhepLai, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  xuLyCapPhepLai(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.xuLyCapPhepLai, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  daTiepNhanCapPhepLai(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.daTiepNhanCapPhepLai, data);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description
   */
  tuChoiCapPhepLai(data): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.tuChoiCapPhepLai, data);
  }

  //End

  /**
   * @author hangdtt.it5
   * @method GET
   * @param maCongTy
   * @description Thông tin chi tiết công ty
   */
  getChiTietCongTy(maCongTy) {
    return super.get(apiUrl.LDVL.congTy.chiTietCongTy, { maCongTy: maCongTy });
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param maBaiDang
   * @description Thông tin chi tiết tin tuyển dụng của công ty
   */
  getChiTietTinTuyenDung(maBaiDang) {
    return super.get(apiUrl.LDVL.congTy.chiTietTinTuyenDung, {
      maBaiDang: maBaiDang,
    });
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param uuidUngVien
   * @description Thông tin chi tiết tài khoản ứng viên
   */
  getChiTietThongTinUngVien(uuidUngVien) {
    return super.get(apiUrl.LDVL.ungVien.chiTietUngVien, {
      uuidUngVien: uuidUngVien,
    });
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param idCongViecMongMuon
   * @description Thông tin chi tiết hồ sơ của ứng viên
   */
  getChiTietHoSoUngVien(idCongViecMongMuon) {
    return super.get(apiUrl.LDVL.ungVien.chiTietHoSo, {
      idCongViecMongMuon: idCongViecMongMuon,
    });
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param fileID
   * @description Download file để hiển thị file
   */
  downloadFileDinhKemKhongToken(fileID) {
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: headers,
    };
    return this.http.get(apiUrl.file.downloadNotToken + fileID, httpOptions);
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param
   * @description Danh sách ngôn ngữ
   */
  danhSachNgonNgu() {
    return super.get(apiUrl.LDVL.danhMuc.danhMucNgonNgu);
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param
   * @description Danh sách trình độ
   */
  danhSachTrinhDo() {
    return super.get(apiUrl.LDVL.danhMuc.danhSachTrinhDo);
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param
   * @description Danh sách mức lương tối đa
   */
  danhSachMucLuongToiDa() {
    return super.get(apiUrl.LDVL.danhMuc.danhMucMucLuongToiDa);
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param
   * @description Danh sách mức lương tối thiểu
   */
  danhSachMucLuongToiThieu() {
    return super.get(apiUrl.LDVL.danhMuc.danhMucMucLuongToiThieu);
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param
   * @description Danh mục quốc tịch
   */
  danhMucQuocTich() {
    return super.get(apiUrl.LDVL.danhMuc.danhMucQuocTich);
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param
   * @description Danh sách cấp độ công việc
   */
  danhSachCapDoCongViec() {
    return super.get(apiUrl.LDVL.danhMuc.danhMucCapDoCongViec);
  }

  /**
   * @author hangdtt.it5
   * @method GET
   * @param
   * @description Danh sách loại công việc
   */
  danhSachLoaiCongViec() {
    return super.get(apiUrl.LDVL.danhMuc.danhMucLoaiCongViec);
  }

  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Get thành viên theo id
   */
  getThanhVienTheoID(idThanhVien) {
    return super.get(apiUrl.LDVL.thanhVien.getThanhVienID + '/' + idThanhVien);
  }
  /**
   * @description Get thành viên người dân theo id
   */
  getThanhVienNguoiDanTheoID(idThanhVien) {
    return super.get(apiUrl.LDVL.thanhVien.getThanhVienNguoiDanID + '/' + idThanhVien);
  }
  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description Danh sách tổ chức của cầu lao động
   */
  getTraCuuNhanhCauLD(obj): Observable<any> {
    return super.get(apiUrl.LDVL.cauBanDau.getTraCuuNhanhCauLD, obj);
  }
  /**
   * @author toitv.tgg
   * @method GET
   * @param requestBody
   * @description Danh sách bhtn chờ duyệt
   */
  getDanhSachChoDuyetBHTN(request) {
    return super.get(apiUrl.LDVL.bhtn.getDanhSachTroCapThatNghiep, request);
  }

  /**
   * @author toitv.tgg
   * @method PUT
   * @param requestBody
   * @description Change status
   */
  changeStatus(body) {
    return super.put(apiUrl.LDVL.bhtn.changeStatus, body);
  }

  /**
   * @author toitv.tgg
   * @method GET
   * @param requestBody
   * @description Get danh sách file đính kèm
   */
  getListFile(uuid) {
    return super.get(apiUrl.LDVL.bhtn.getDanhSachFile, { uuid: uuid });
  }

  /**
   * @author toitv.tgg
   * @method GET
   * @param fileID,fileName
   * @description Download file để hiển thị file
   */
  downloadFileBHTN(fileID, fileName) {
    return super.downloadFile(apiUrl.LDVL.bhtn.downloadFile + fileID, fileName);
  }

  /**
   * @author toitv.tgg
   * @method POST
   * @param fileID
   * @description Hoàn thành HS
   */
  hoanthanhhoso(file, uuid, maNguoiDung) {
    return super.post(
      apiUrl.LDVL.bhtn.hoanthanh +
        '?uuid=' +
        uuid +
        '&maNguoiDung=' +
        maNguoiDung,
      file
    );
  }

  /**
   * @author toitv.tgg
   * @method GET
   * @param uuid
   * @description Download file quyết định
   */
  inquyetdinh(uuid, fileName) {
    return super.downloadFile(
      apiUrl.LDVL.bhtn.inquyetdinh + '?uuid=' + uuid,
      fileName
    );
  }

  getBaoCaoTongHopMauMot(obj): Observable<any> {
    let requestOptions = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
      'Content-Type': 'application/json',
    });

    return this.http.get(apiUrl.LDVL.baoCao.baoCaoTongHopBieuMau1, {
      headers: requestOptions,
      responseType: 'blob',
      params: obj,
    });
  }

  getBaoCaoTongHopMauHai(obj): Observable<any> {
    let requestOptions = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
      'Content-Type': 'application/json',
    });

    return this.http.get(apiUrl.LDVL.baoCao.baoCaoTongHopBieuMau2, {
      headers: requestOptions,
      responseType: 'blob',
      params: obj,
    });
  }

  getBaoCaoTongHopMauBa(obj): Observable<any> {
    let requestOptions = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
      'Content-Type': 'application/json',
    });

    return this.http.get(apiUrl.LDVL.baoCao.baoCaoTongHopBieuMau3, {
      headers: requestOptions,
      responseType: 'blob',
      params: obj,
    });
  }

  getBaoCaoTongHopMauBon(obj): Observable<any> {
    let requestOptions = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
      'Content-Type': 'application/json',
    });

    return this.http.get(apiUrl.LDVL.baoCao.baoCaoTongHopBieuMau4, {
      headers: requestOptions,
      responseType: 'blob',
      params: obj,
    });
  }

  getBaoCaoTongHopMauNam(obj): Observable<any> {
    let requestOptions = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
      'Content-Type': 'application/json',
    });

    return this.http.get(apiUrl.LDVL.baoCao.baoCaoTongHopBieuMau5, {
      headers: requestOptions,
      responseType: 'blob',
      params: obj,
    });
  }

  getXuatBaoCaoTongHop(maTinh, nam, idTrangThai): Observable<any> {
    if (idTrangThai == 0) {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.xuatBaoCao +
          '?maTinh=' +
          maTinh +
          '&nam=' +
          nam +
          '&type=xlsx',
        'Báo cáo'
      );
    } else {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.xuatBaoCao +
          '?maTinh=' +
          maTinh +
          '&nam=' +
          nam +
          '&idTrangThai=' +
          idTrangThai +
          '&type=xlsx',
        'Báo cáo'
      );
    }
  }

  getBCDanSoTu10(obj): Observable<any> {
    let requestOptions = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
      'Content-Type': 'application/json',
    });

    return this.http.get(apiUrl.LDVL.baoCao.exportBCDanSoTu10, {
      headers: requestOptions,
      responseType: 'blob',
      params: obj,
    });
  }

  getBCLaoDongCoViecLamTu15(obj): Observable<any> {
    let requestOptions = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
      'Content-Type': 'application/json',
    });

    return this.http.get(apiUrl.LDVL.baoCao.exportBCLaoDongCoViecLamTu15, {
      headers: requestOptions,
      responseType: 'blob',
      params: obj,
    });
  }

  getBCLucLuongLaoDongTu15(obj): Observable<any> {
    let requestOptions = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
      'Content-Type': 'application/json',
    });

    return this.http.get(apiUrl.LDVL.baoCao.exportBCLucLuongLaoDongTu15, {
      headers: requestOptions,
      responseType: 'blob',
      params: obj,
    });
  }

  getBCKhongThamGiaHdKT(obj): Observable<any> {
    let requestOptions = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
      'Content-Type': 'application/json',
    });

    return this.http.get(apiUrl.LDVL.baoCao.exportBCKhongThamGiaHDKT, {
      headers: requestOptions,
      responseType: 'blob',
      params: obj,
    });
  }

  getBCLaoDongCoViecLamTrongDoTuoi(obj): Observable<any> {
    let requestOptions = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
      'Content-Type': 'application/json',
    });

    return this.http.get(
      apiUrl.LDVL.baoCao.exportBCLaoDongCoViecLamTrongDoTuoi,
      { headers: requestOptions, responseType: 'blob', params: obj }
    );
  }

  getBCLaoDongCoViecLamTheoKhuVucKT(obj): Observable<any> {
    let requestOptions = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
      'Content-Type': 'application/json',
    });

    return this.http.get(
      apiUrl.LDVL.baoCao.exportBCLaoDongCoViecLamTheoKhuVucKT,
      { headers: requestOptions, responseType: 'blob', params: obj }
    );
  }

  getBCLaoDongQuaDaoTao(obj): Observable<any> {
    let requestOptions = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
      'Content-Type': 'application/json',
    });

    return this.http.get(apiUrl.LDVL.baoCao.exportBaoCaoLaoDongQuaDaoTao, {
      headers: requestOptions,
      responseType: 'blob',
      params: obj,
    });
  }

  getXuatBaoCaoLaoDongQuaDaoTao(maTinh, nam, namBTE, bieuMau, reportType): Observable<any> {
    return super.downloadFile(apiUrl.LDVL.baoCao.exportBaoCaoLaoDongQuaDaoTao + "?maTinh=" + maTinh + "&nam=" + nam  + "&namBTE=" + namBTE + "&bieuMau=" + bieuMau + "&reportType=" + reportType, "Báo cáo lao động qua đào tạo");
  }

  getBCTongHopKetQuaThucHienViecLamvaXKLD(
    nam,
    namBatDau,
    namKetThuc
  ): Observable<any> {
    let requestOptions = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
      'Content-Type': 'application/json',
    });

    let url =
      apiUrl.LDVL.baoCao.baoCaoCTGQVLVXKLD_Chung_STG +
      '?tinh=93' +
      '&nam=' +
      nam +
      '&nam_bd=' +
      namBatDau +
      '&nam_kt=' +
      namKetThuc +
      '&kieuXuat=1';

    return this.http.get(url, {
      headers: requestOptions,
      responseType: 'blob',
    });
  }

  getBCTongHopKetQuaThucHienGQViecLamvaXKLD(
    nam,
    namBatDau,
    namKetThuc
  ): Observable<any> {
    let requestOptions = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
      'Content-Type': 'application/json',
    });

    let url =
      apiUrl.LDVL.baoCao.baoCaoCTGQVLVXKLD_XKLDChiaTheoTT_STG +
      '?tinh=93' +
      '&nam=' +
      nam +
      '&nam_bd=' +
      namBatDau +
      '&nam_kt=' +
      namKetThuc +
      '&kieuXuat=1';

    return this.http.get(url, {
      headers: requestOptions,
      responseType: 'blob',
    });
  }

  maTinh = JSON.parse(localStorage.getItem('user')).maTinhBhxh;
  getBCTienDoDieuTraTTLD_Cung(obj): Observable<any> {
    if(this.maTinh == '86'){
        return super.get(apiUrl.LDVL.baoCao.getBCTienDoDieuTraTTLD_Cung_BTE, obj);
    }
    return super.get(apiUrl.LDVL.baoCao.getBCTienDoDieuTraTTLD_Cung, obj);
  }

  getBCTienDoDieuTraTTLD_Cau(obj): Observable<any> {
    if(this.maTinh == '86'){
        return super.get(apiUrl.LDVL.baoCao.getBCTienDoDieuTraTTLD_Cau_BTE, obj);
    }
    return super.get(apiUrl.LDVL.baoCao.getBCTienDoDieuTraTTLD_Cau, obj);
  }

  getBCTienDoDieuTraTTLD(obj): Observable<any> {
    return super.get(apiUrl.LDVL.baoCao.getBCTienDoDieuTraTTLD, obj);
  }

  getThuocLinhVuc() {
    return super.get(apiUrl.LDVL.danhMuc.getThuocLinhVuc);
  }

  getThoiGianThatNghiep() {
    return super.get(apiUrl.LDVL.danhMuc.thoiGianThatNghiep);
  }

  getDieuKienSearch() {
    return super.get(apiUrl.LDVL.danhMuc.dieuKiemSearch);
  }
  //exportThanhVien
  exportThanhVien(
    maXa,
    maThon,
    nam,
    isGioiTinh,
    tuTuoi,
    denTuoi,
    tinhTrangViecLam,
    ngayGhi,
    option,
    isBienDong,
    trangThaiNgayGhi
  ) {
    if (maXa == 'null') {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.exportThanhVienBTE +
          '?nam=' +
          nam +
          '&isGioiTinh=' +
          isGioiTinh +
          '&tuTuoi=' +
          tuTuoi +
          '&denTuoi=' +
          denTuoi +
          '&tinhTrangViecLam=' +
          tinhTrangViecLam +
          '&ngayGhi=' +
          ngayGhi +
          '&option=' +
          option +
          '&isBienDong=' +
          isBienDong +
          '&trangThaiNgayGhi=' +
          trangThaiNgayGhi,
        'Dữ liệu cung lao động'
      );
    } else if (maThon == 'null') {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.exportThanhVienBTE +
          '?nam=' +
          nam +
          '&maXa=' +
          maXa +
          '&isGioiTinh=' +
          isGioiTinh +
          '&tuTuoi=' +
          tuTuoi +
          '&denTuoi=' +
          denTuoi +
          '&tinhTrangViecLam=' +
          tinhTrangViecLam +
          '&ngayGhi=' +
          ngayGhi +
          '&option=' +
          option +
          '&isBienDong=' +
          isBienDong +
          '&trangThaiNgayGhi=' +
          trangThaiNgayGhi,
        'Dữ liệu cung lao động'
      );
    } else {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.exportThanhVienBTE +
          '?nam=' +
          nam +
          '&maXa=' +
          maXa +
          '&maThon=' +
          maThon +
          '&isGioiTinh=' +
          isGioiTinh +
          '&tuTuoi=' +
          tuTuoi +
          '&denTuoi=' +
          denTuoi +
          '&tinhTrangViecLam=' +
          tinhTrangViecLam +
          '&ngayGhi=' +
          ngayGhi +
          '&option=' +
          option +
          '&isBienDong=' +
          isBienDong +
          '&trangThaiNgayGhi=' +
          trangThaiNgayGhi,
        'Dữ liệu cung lao động'
      );
    }
  }

  exportThanhVienBTE(
    maXa,
    maThon,
    nam,
    isGioiTinh,
    tuTuoi,
    denTuoi,
    tinhTrangViecLam,
    ngayGhi,
    option,
    isBienDong,
    trangThaiNgayGhi
  ) {
    if (maXa == 'null') {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.exportThanhVienBTE +
          '?nam=' +
          nam +
          '&isGioiTinh=' +
          isGioiTinh +
          '&tuTuoi=' +
          tuTuoi +
          '&denTuoi=' +
          denTuoi +
          '&tinhTrangViecLam=' +
          tinhTrangViecLam +
          '&ngayGhi=' +
          ngayGhi +
          '&option=' +
          option +
          '&isBienDong=' +
          isBienDong +
          '&trangThaiNgayGhi=' +
          trangThaiNgayGhi,
        'Dulieucunglaodong.csv.gz'
      );
    } else if (maThon == 'null') {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.exportThanhVienBTE +
          '?nam=' +
          nam +
          '&maXa=' +
          maXa +
          '&isGioiTinh=' +
          isGioiTinh +
          '&tuTuoi=' +
          tuTuoi +
          '&denTuoi=' +
          denTuoi +
          '&tinhTrangViecLam=' +
          tinhTrangViecLam +
          '&ngayGhi=' +
          ngayGhi +
          '&option=' +
          option +
          '&isBienDong=' +
          isBienDong +
          '&trangThaiNgayGhi=' +
          trangThaiNgayGhi,
        'Dulieucunglaodong.csv.gz'
      );
    } else {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.exportThanhVienBTE +
          '?nam=' +
          nam +
          '&maXa=' +
          maXa +
          '&maThon=' +
          maThon +
          '&isGioiTinh=' +
          isGioiTinh +
          '&tuTuoi=' +
          tuTuoi +
          '&denTuoi=' +
          denTuoi +
          '&tinhTrangViecLam=' +
          tinhTrangViecLam +
          '&ngayGhi=' +
          ngayGhi +
          '&option=' +
          option +
          '&isBienDong=' +
          isBienDong +
          '&trangThaiNgayGhi=' +
          trangThaiNgayGhi,
        'Dulieucunglaodong.csv.gz'
      );
    }
  }

  //exportToChuc
  exportToChuc(
    maXa,
    nam,
    isBienDong,
    loaiHinh,
    trangThaiNgayGhi,
    ngayGhi,
    isDelete
  ) {
    if (maXa == 'null') {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.exportToChuc +
          '?nam=' +
          nam +
          '&isBienDong=' +
          isBienDong +
          '&loaiHinh=' +
          loaiHinh +
          '&trangThaiNgayGhi=' +
          trangThaiNgayGhi +
          '&ngayGhi=' +
          ngayGhi +
          '&isDelete=' +
          isDelete,
        'Dữ liệu cầu lao động'
      );
    } else {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.exportToChuc +
          '?nam=' +
          nam +
          '&maXa=' +
          maXa +
          '&isBienDong=' +
          isBienDong +
          '&loaiHinh=' +
          loaiHinh +
          '&trangThaiNgayGhi=' +
          trangThaiNgayGhi +
          '&ngayGhi=' +
          ngayGhi +
          '&isDelete=' +
          isDelete,
        'Dữ liệu cầu lao động'
      );
    }
  }

  //export tổ chức cho các tỉnh
  exportToChucProvinces(search, maXa, nam, isBienDong, isDelete) {
    let params = `?nam=${nam}`;
    let url = apiUrl.LDVL.baoCao.exportToChucProvinces;
    if (isBienDong != 'null' && isBienDong != null) {
      params += `&isBienDong=${isBienDong}`;
    }
    if (isDelete != 'null' && isDelete != null) {
      params += `&isDelete=${isDelete}`;
    }
    if (maXa != 'null' && maXa != null) {
      params += `&maXa=${maXa}`;
    }
    if (search != 'null' && search != null && search.trim() != '') {
      params += `&search=${search}`;
    }
    return super.downloadFile(url + params, 'Dữ liệu cầu lao động');
  }

  //exportTienDo
  exportTienDo_Cung(maXa, tuNgay, denNgay, option) {
    let _nameFile = 'Báo cáo tiến độ điều tra (Cung lao động)';
    if (maXa == 'null') {
        if (tuNgay == 'null') {
          return super.downloadFile(
            apiUrl.LDVL.baoCao.exportTienDo_Cung +
              '?denNgay=' +
              denNgay +
              '&option=' +
              option,
            _nameFile
          );
        } else {
          return super.downloadFile(
            apiUrl.LDVL.baoCao.exportTienDo_Cung +
              '?tuNgay=' +
              tuNgay +
              '&denNgay=' +
              denNgay +
              '&option=' +
              option,
            _nameFile
          );
        }

    } else {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.exportTienDo_Cung +
          '?maXa=' +
          maXa +
          '&tuNgay=' +
          tuNgay +
          '&denNgay=' +
          denNgay +
          '&option=' +
          option,
        _nameFile
      );
    }
  }
  exportTienDo_Cau(maXa, tuNgay, denNgay, option) {
    let _nameFile = 'Báo cáo tiến độ điều tra (Cầu lao động)';
    if (maXa == 'null') {
        if (tuNgay == 'null') {
          return super.downloadFile(
            apiUrl.LDVL.baoCao.exportTienDo_Cau +
              '?denNgay=' +
              denNgay +
              '&option=' +
              option,
            _nameFile
          );
        } else {
          return super.downloadFile(
            apiUrl.LDVL.baoCao.exportTienDo_Cau +
              '?tuNgay=' +
              tuNgay +
              '&denNgay=' +
              denNgay +
              '&option=' +
              option,
            _nameFile
          );
        }

    } else {
      return super.downloadFile(
        apiUrl.LDVL.baoCao.exportTienDo_Cau +
          '?maXa=' +
          maXa +
          '&tuNgay=' +
          tuNgay +
          '&denNgay=' +
          denNgay +
          '&option=' +
          option,
        _nameFile
      );
    }
  }

  getAllNgach() {
    return super.get(apiUrl.LDVL.danhMuc.getAllNgach);
  }

  getAllLinhVuc() {
    return super.get(apiUrl.LDVL.danhMuc.getAllLinhVuc);
  }

  getAllViTri() {
    return super.get(apiUrl.LDVL.danhMuc.getAllViTri);
  }

  getDmDichVuViecLam(obj): Observable<any> {
    return super.get(apiUrl.LDVL.danhMuc.getDmDichVuVieclam, obj);
  }

  addDmDichVuViecLam(requestBody) {
    return super.post(apiUrl.LDVL.danhMuc.getDmDichVuVieclam, requestBody);
  }

  updateDmDichVuViecLam(requestBody) {
    return super.put(apiUrl.LDVL.danhMuc.getDmDichVuVieclam, requestBody);
  }

  deleteDmDichvuViecLam(uuid) {
    return super.delete(apiUrl.LDVL.danhMuc.getDmDichVuVieclam + '/' + uuid);
  }

  getDmDichVuViecLamDetail(uuid): Observable<any> {
    return super.get(apiUrl.LDVL.danhMuc.getDmDichVuViecLamDetail + '/' + uuid);
  }

  getListVanBan(data): Observable<any> {
    return super.get(apiUrl.LDVL.vanban.getListVanBan, data);
  }

  xoaVanBan(id): Observable<any> {
    return super.delete(apiUrl.LDVL.vanban.vanBan, { id: id });
  }

  chuyenVanBan(id, status): Observable<any> {
    return super.put(
      apiUrl.LDVL.vanban.setStatus + '?id=' + id + '&status=' + status
    );
  }

  suaVanBan(payload, data): Observable<any> {
    const queryString = Object.entries(data)
      .filter(([key, value]) => value !== null)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
    return super.put(
      apiUrl.LDVL.vanban.vanBanAddUpdate + '?' + queryString,
      payload
    );
  }

  themVanBan(payload, data): Observable<any> {
    const queryString = Object.entries(data)
      .filter(([key, value]) => value !== null)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
    return super.post(
      apiUrl.LDVL.vanban.vanBanAddUpdate + '?' + queryString,
      payload
    );
  }
  // START STG IT5ASXH-6210
  getDonViXKLD(): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiVNLVTaiNN.donViXKLD);
  }
  getDoiTuongXKLD(): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiVNLVTaiNN.doiTuongXKLD);
  }
  getTenNuocLamViecXKLD(): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiVNLVTaiNN.tenNuocLamViecXKLD);
  }
  //Người Việt Nam làm việc tại nước ngoài
  getDSNVNLVTNN(obj): Observable<any> {
    return super.get(apiUrl.LDVL.nguoiVNLVTaiNN.getDSNVNLVTNN, obj);
  }
  /**
   * @author psdung
   * @method GET
   * @param requestBody
   * @description get theo id
   */
  getNVNLVTNNById(id) {
    return super.get(apiUrl.LDVL.nguoiVNLVTaiNN.getNVNLVTNNByID + '/' + id);
  }
  /**
   * @author AnhNT
   * @method GET
   * @param requestBody
   * @description Them mới thông tin
   */
  addNewNguoiVN(body): Observable<any> {
    return super.post(apiUrl.LDVL.nguoiVNLVTaiNN.addNewNguoiVN, body);
  }
  /**
   * @author AnhNT
   * @method GET
   * @param requestBody
   * @description Cập nhật tt
   */
  updateNguoiVN(id, body): Observable<any> {
    return super.put(apiUrl.LDVL.nguoiVNLVTaiNN.updateNguoiVN + '/' + id, body);
  }

  /**
   * @author AnhNT
   * @method GET
   * @param requestBody
   * @description Xóa tt Người nước ngoài làm việc tại Việt Nam
   */
  //Người Việt Nam
  deleteNguoiVN(id): Observable<any> {
    return super.delete(apiUrl.LDVL.nguoiVNLVTaiNN.deleteNguoiVN + '/' + id);
  }
  /**
   * @author AnhNT
   * @method GET
   * @param requestBody
   * @description Khoi phục tt Người nước ngoài làm việc tại Việt Nam
   */
    //Người Việt Nam
    restoreNguoiVN(id): Observable<any> {
        return super.put(apiUrl.LDVL.nguoiVNLVTaiNN.restoreNguoiVN + "/" + id);

    }
    xuatBCDanhSachNLDThamGiaXKLD(tuNgay, denNgay, tenFile): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.nguoiVNLVTaiNN.xuatBCDanhSachNLDThamGiaXKLD + "?tuNgay=" + tuNgay + "&denNgay=" + denNgay, tenFile);
    }

    // END STG IT5ASXH-6210
    //dang ky gio lam them cua doanh nghiep
    getDKGioLamThemDN(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.getListDKGioLamThemDN, obj);
    }

    //doanh nghiệp cho thuê lại lao động
    getDoanhNghiepThueLaiLaoDong(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.getDNChoThueLaiLD, obj);
    }

    addDoanhNghiepThueLaiLaoDong(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.addDNChoThueLaiLD, obj);
    }

    updateDoanhNghiepThueLaiLaoDong(obj): Observable<any> {
        return super.put(apiUrl.LDVL.doanhNghiep.editDNChoThueLaiLD, obj);
    }

    deleteDoanhNghiepThueLaiLaoDong(uuid, trangThaiXoa): Observable<any> {
        return super.delete(apiUrl.LDVL.doanhNghiep.deleteDNChoThueLaiLD, { uuid: uuid, trangThaiXoa: trangThaiXoa });
    }

    getUuidDoanhNghiepThueLaiLaoDong(uuid): Observable<any> {
        return super.get(apiUrl.LDVL.doanhNghiep.getUuidDNChoThueLaiLD, { uuid: uuid });
    }

    //Lao động tham gia bảo hiểm xã hội
    getLaoDongThamGiaBHXH(obj): Observable<any> {
        return super.post(apiUrl.LDVL.BHXH.getLaoDongThamGiaBHXH, obj);
    }

    addLaoDongThamGiaBHXH(obj): Observable<any> {
        return super.post(apiUrl.LDVL.BHXH.addLaoDongThamGiaBHXH, obj);
    }

    //noi quy cong ty
    getNoiQuyCongTy(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.noiQuyCongTy, obj);
    }

    //Tiền lương, thu nhập của người lao động
    getTienLuongThuNhap(obj): Observable<any> {
        return super.post(apiUrl.LDVL.chucNangKhac.getTienLuongThuNhap, obj);
    }

    addTienLuongThuNhap(obj): Observable<any> {
        return super.post(apiUrl.LDVL.chucNangKhac.addTienLuongThuNhap, obj);
    }

    //doanh nghiệp xuất khẩu lao động
    getDoanhNghiepxkld(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.getListDNXuatKhauLD, obj);
    }

    addDoanhNghiepxkld(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.addDNXuatKhauLD, obj);
    }

    updateDoanhNghiepxkld(obj): Observable<any> {
        return super.put(apiUrl.LDVL.doanhNghiep.editDNXuatKhauLD, obj);
    }

    deleteDoanhNghiepxkld(uuid, trangThaiXoa): Observable<any> {
        return super.delete(apiUrl.LDVL.doanhNghiep.deleteDNXuatKhauLD, { uuid: uuid, trangThaiXoa: trangThaiXoa });
    }

    getUuidDoanhNghiepxkld(uuid): Observable<any> {
        return super.get(apiUrl.LDVL.doanhNghiep.getUuidDNXuatKhauLD, { uuid: uuid });
    }

    //khai báo sử dụng máy móc
    getKhaiBaoSuDungMayMoc(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.getListKhaiBaoSuDungMayMoc, obj);
    }

    postKhaiBaoSuDungMayMoc(uuidToChuc, tenVatTu, tinhTrangSuDung, userUuid): Observable<any> {
        return super.get(apiUrl.LDVL.doanhNghiep.addKhaiBaoSuDungMayMoc + "?uuidToChuc=" + uuidToChuc + "&tenVatTu=" + tenVatTu + "&tinhTrangSuDung=" + tinhTrangSuDung + "&userUuid=" + userUuid);
    }

    putKhaiBaoSuDungMayMoc(uuidVatTu, tenVatTu, tinhTrangSuDung, userUuid): Observable<any> {
        return super.get(apiUrl.LDVL.doanhNghiep.editKhaiBaoSuDungMayMoc + "?uuidVatTu=" + uuidVatTu + "&tenVatTu=" + tenVatTu + "&tinhTrangSuDung=" + tinhTrangSuDung + "&userUuid=" + userUuid);
    }

    deteleKhaiBaoSuDungMayMoc(uuidNoiQuy, isDeleted, userUuid): Observable<any> {
        return super.get(apiUrl.LDVL.doanhNghiep.deleteKhaiBaoSudungMayMoc + "?uuidVatTu=" + uuidNoiQuy + "&isDeleted=" + isDeleted + "&userUuid=" + userUuid);
    }

    //tai nạn lao động khong co hop dong lao dong
    getTaiNanLaoDongKhongCoHDLD(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.getListTaiNanLDKhongCoHDLD, obj);
    }

    postTaiNanLaoDongKhongCoHDLD(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.addTaiNanLDKhongCoHDLD, obj);
    }

    putTaiNanLaoDongKhongCoHDLD(obj): Observable<any> {
        return super.put(apiUrl.LDVL.doanhNghiep.editTaiNanLDKhongCoHDLD, obj);
    }

    deteleTaiNanLaoDongKhongCoHDLD(obj): Observable<any> {
        return super.put(apiUrl.LDVL.doanhNghiep.deleteTaiNanLDKhongCoHDLD, obj);
    }

    exportBaoCao(body): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.doanhNghiep.exportBaoCao, "Báo cáo tai nạn lao động của người lao động làm việc không theo hợp đồng lao động", body);
    }

    xemBaoCao(body): Observable<any> {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        return this.http.post(apiUrl.LDVL.doanhNghiep.exportBaoCao, body, requestOptions);
    }

    //tai nạn lao động từ người sử dụng lao động
    getTaiNanLaoDongTuNguoiSDLD(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.getListTaiNanLDTuNguoiSDLD, obj);
    }

    postTaiNanLaoDongTuNguoiSDLD(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.addTaiNanLDTuNguoiSDLD, obj);
    }

    putTaiNanLaoDongTuNguoiSDLD(obj): Observable<any> {
        return super.put(apiUrl.LDVL.doanhNghiep.editTaiNanLDTuNguoiSDLD, obj);
    }

    deteleTaiNanLaoDongTuNguoiSDLD(obj): Observable<any> {
        return super.put(apiUrl.LDVL.doanhNghiep.deleteTaiNanLDTuNguoiSDLD, obj);
    }

    //tai nạn lao động nặng từ 2 người trở lên
    getTaiNanLaoDongNangTu2NguoiTroLen(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.getTaiNanLaoDongNang, obj);
    }

    xemBaoCaoTaiNanLaoDongNang(body): Observable<any> {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        return this.http.post(apiUrl.LDVL.doanhNghiep.exportBaoCaoTaiNanLaoDongNang, body, requestOptions);

    }

    exportBaoCaoTNLDnang(body): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.doanhNghiep.exportBaoCaoTaiNanLaoDongNang, "Báo cáo tai nạn lao động chết người, tai nạn lao động nặng từ 2 người trở lên - Phụ lục 13 – 39/2016/NĐCP ", body);
    }

    //kết qua kiem tra chat luong san pham
    getKetQuaKiemTraChatLuongSP(obj): Observable<any> {
        return super.get(apiUrl.LDVL.doanhNghiep.getKetQuaKiemTraChatLuongSP, obj);
    }

    postKetQuaKiemTraChatLuongSP(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.addKetQuaKiemTraChatLuongSP, obj);
    }

    putKetQuaKiemTraChatLuongSP(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.editKetQuaKiemTraChatLuongSP, obj);
    }

    deteleKetQuaKiemTraChatLuongSP(id): Observable<any> {
        return super.delete(apiUrl.LDVL.doanhNghiep.deleteKetQuaKiemTraChatLuongSP + "?id=" + id);
    }

    //kết qua triển khai hanh động
    getKetQuaTrienKhaiHanhDong(obj): Observable<any> {
        return super.get(apiUrl.LDVL.doanhNghiep.getKetQuaTrienKhaiHanhDong, obj);
    }

    postKetQuaTrienKhaiHanhDong(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.addKetQuaTrienKhaiHanhDong, obj);
    }

    putKetQuaTrienKhaiHanhDong(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.editKetQuaTrienKhaiHanhDong, obj);
    }

    deteleKetQuaTrienKhaiHanhDong(id): Observable<any> {
        return super.delete(apiUrl.LDVL.doanhNghiep.deleteKetQuaTrienKhaiHanhDong + "?id=" + id);
    }

    //tình hình thực hiện atvsld
    getTinhHinhThucHien(obj): Observable<any> {
        return super.get(apiUrl.LDVL.doanhNghiep.getTinhHinhThucHien, obj);
    }

    postTinhHinhThucHien(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.addTinhHinhThucHien, obj);
    }

    putTinhHinhThucHien(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.editTinhHinhThucHien, obj);
    }

    deteleTinhHinhThucHien(id): Observable<any> {
        return super.delete(apiUrl.LDVL.doanhNghiep.deleteTinhHinhThucHien + "?id=" + id);
    }

    //tình hình hỗ tro huan luyen atvsld
    getTinhHinhHoTroHuanLuyen(obj): Observable<any> {
        return super.get(apiUrl.LDVL.doanhNghiep.getTinhHinhHoTroHuanLuyen, obj);
    }

    postTinhHinhHoTroHuanLuyen(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.addTinhHinhHoTroHuanLuyen, obj);
    }

    putTinhHinhHoTroHuanLuyen(obj): Observable<any> {
        return super.post(apiUrl.LDVL.doanhNghiep.editTinhHinhHoTroHuanLuyen, obj);
    }

    deteleTinhHinhHoTroHuanLuyen(id): Observable<any> {
        return super.delete(apiUrl.LDVL.doanhNghiep.deleteTinhHinhHoTroHuanLuyen + "?id=" + id);
    }

    exportBaoCaoThongKe(body): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.doanhNghiep.exportBaoCaoThongKe, "Báo cáo thống kê tai nạn lao động của người lao động làm việc không theo hợp đồng lao động", body);
    }

    exportBaoCaoThongKeNguoiSDLD(body): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.doanhNghiep.exportBaoCaoThongKeNguoiSDLD, "Báo cáo thống kê tình hình tai nạn lao động từ người sử dụng lao động", body);
    }
    // =========================== Cac mau BC STG
    cleanParam(body){
        for (let key in body)
            if (body[key] == null
                || body[key] === ''
                || body[key] === 'null'
                || Number.isNaN(body[key])
            ) delete body[key];

        return body;
    }

    getDmDonViXKLD(){
        return super.get(apiUrl.LDVL.danhMuc.danhMucDonViXKLD);
    }

    getTTNLLVTVNMau03_STG(body): Observable<any> {
        return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getTTNLLVTVN_GNBV_STG, this.cleanParam(body));
    }

    addNewM03_STG(body): Observable<any> {
        return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.addNewM03_GNBV_STG, body);

    }

    UpdateM03_STG(body): Observable<any> {
        return super.put(apiUrl.LDVL.nguoiNNLVTaiVN.updateM03_GNBV_STG, body);

    }

    getChiTietTTNLLVTVNMau03_STG(id): Observable<any> {
        return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.detailM03_GNBV_STG, {id: id});
    }

    getListTinhTrangGiaoNopMau03(): Observable<any>{
        return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getListTinhTrangGiaoNop);
    }

    giaoNopTTMau03(body) : Observable<any>{
        return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.giaoNopTTLDNuocNgoai, body);
    }

    getDSNVNLVTNN_STG(obj): Observable<any> {
        return super.get(apiUrl.LDVL.nguoiVNLVTaiNN.getDSNVNLVTNN_STG, obj);
    }

    getBaoCaoLDVL_STG(apiUrl, nam, arg = new Map<string, string>(), kieuXuat = 1, tinh = 92) {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };

        let url = apiUrl + "?tinh=" + tinh + "&nam=" + nam + "&kieuXuat=" + kieuXuat;

        arg.forEach((value: string, key: string) => {
            url += "&" + key + "=" + value;
        });

        return this.http.get(url, requestOptions);
    }

    xuatBaoCaoLDVL_STG(apiUrl, nam, tenBC, arg = new Map<string, string>(), kieuXuat = 1, tinh = 92): Observable<any> {
        let url = apiUrl + "?tinh=" + tinh + "&nam=" + nam + "&kieuXuat=" + kieuXuat;
        arg.forEach((value: string, key: string) => {
            url += "&" + key + "=" + value;
        });
        return super.downloadFile(url, tenBC);
    }

    getChiTieuGQVL_STG(obj): Observable<any> {
        return super.get(apiUrl.LDVL.chiTieuGQVL_STG.getChiTieuGQVL, obj);
    }

    addChiTieuGQVL_STG(requestBody) {
        return super.post(apiUrl.LDVL.chiTieuGQVL_STG.addChiTieu, requestBody);
    }

    editChiTieuGQVL_STG(requestBody) {
        return super.post(apiUrl.LDVL.chiTieuGQVL_STG.editChiTieu, requestBody);
    }

    getChiTieuIDGQVL_STG(id): Observable<any> {
        return super.post(apiUrl.LDVL.chiTieuGQVL_STG.getChiTieuID + "?id=" + id);
    }

    delete_restoreChiTieuGQVL_STG(id, is_delete = 1) {
        return super.post(apiUrl.LDVL.chiTieuGQVL_STG.delete_restoreChiTieuID + "?id=" + id + "&trangthai=" + is_delete);
    }
    getBCTNLDChetNguoi(type): Observable<any> {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        return this.http.get(apiUrl.LDVL.baoCao.bcTNLDChetNguoi + "?loaiBaoCao=" + type, requestOptions);
    }

    xuatBaoCaoTNLDChetNguoi(type): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.baoCao.bcTNLDChetNguoi + "?loaiBaoCao=" + type, "Báo cáo tai nạn lao động chết người");
    }

    getBCTNLDTrenDiaBan(type): Observable<any> {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        return this.http.get(apiUrl.LDVL.baoCao.bcTNLDTrenDiaBanTinh + "?loaiBaoCao=" + type, requestOptions);
    }

    xuatBaoCaoTNLDTrenDiaBan(type): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.baoCao.bcTNLDTrenDiaBanTinh + "?loaiBaoCao=" + type, "Báo cáo tai nạn lao động từ người sử dụng lao động trên địa bàn Tỉnh");
    }

    getBCTNLDKhongTheoHDLD(type): Observable<any> {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        return this.http.get(apiUrl.LDVL.baoCao.bcTNLDKhongTheoHD + "?loaiBaoCao=" + type, requestOptions);
    }

    xuatBaoCaoTNLDKhongTheoHDLD(type): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.baoCao.bcTNLDKhongTheoHD + "?loaiBaoCao=" + type, "Báo cáo tai nạn lao động của người lao động không theo hợp đồng lao động");
    }


    xuatBaoCaoCucThongKe(maTinh, maHuyen, type): Observable<any> {
        if (maHuyen == "null") {
            return super.downloadFile(apiUrl.LDVL.baoCao.bcCucThongKe + "?maTinh=" + maTinh + "&reportType=" + type, "Báo cáo tại cục thống kê");
        } else {
            return super.downloadFile(apiUrl.LDVL.baoCao.bcCucThongKe + "?maTinh=" + maTinh + "&maHuyen=" + maHuyen + "&reportType=" + type, "Báo cáo tại cục thống kê");
        }
    }

    getBCTaiCucThongKe(maTinh, maXa, type): Observable<any> {
        let requestOptions = {
            responseType: 'response' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        if (maXa == "null") {
            return this.http.get(apiUrl.LDVL.baoCao.bcCucThongKe + "?maTinh=" + maTinh + "&reportType=" + type, requestOptions);
        } else {
            return this.http.get(apiUrl.LDVL.baoCao.bcCucThongKe + "?maTinh=" + maTinh + "&maXa=" + maXa + "&reportType=" + type, requestOptions);
        }
    }

    danhSachTheTuKhoa() {
        return super.get(apiUrl.LDVL.danhMuc.danhMucTheTuKhoa);
    }

    danhSachDonViTienTe() {
        return super.get(apiUrl.LDVL.danhMuc.getAllDonViTienTe);
    }

    danhSachCongTy(maTinh) {
        return super.get(apiUrl.LDVL.danhMuc.danhSachCongTy, { maTinh: maTinh });
    }

    addDangTin(requestBody) {
        return super.post(apiUrl.LDVL.congTy.dangTin, requestBody);
    }

    getBCDanhSachDoanhnghiep(reportType): Observable<any> {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        return this.http.get(apiUrl.LDVL.baoCao.getBCDanhSachDoanhNghiep + "?reportType=" + reportType, requestOptions);

    }

    xuatBaoCaoDanhSachDoanhNghiep(reportType): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.baoCao.getBCDanhSachDoanhNghiep + "?reportType=" + reportType, "Báo cáo danh sách doanh nghiệp");
    }

    getBCTongHopDoanhNghiep(reportType): Observable<any> {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        return this.http.get(apiUrl.LDVL.baoCao.getBCTongHopDoanhNghiep + "?reportType=" + reportType, requestOptions);

    }

    xuatBaoCaoTongHopDoanhNghiep(reportType): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.baoCao.getBCTongHopDoanhNghiep + "?reportType=" + reportType, "Báo cáo tổng hợp doanh nghiệp");
    }

    xuatBaoCaoDanhSachLaoDong(): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.baoCao.getBCDanhSachLaoDong, "Báo cáo danh sách lao động", {});
    }

    getAllDanhSachLDCMUBanDau(obj): Observable<any> {
        return super.get(apiUrl.LDVL.cungBanDau.getAllDanhSachLDCMUBanDau, obj);
    }
    getAllDanhSachLDCMUBienDong(obj): Observable<any> {
        return super.get(apiUrl.LDVL.cungBanDau.getAllDanhSachLDCMUBienDong, obj);
    }

    searchCMND(cmnd, nam): Observable<any> {
        return super.get(apiUrl.LDVL.thanhVien.getByCCCD, { 'cccd': cmnd, 'nam': nam }).pipe(map(respone => respone.data));
    }

    getHinhThucNhuCauLamViecVayVon() {
        return super.get(apiUrl.LDVL.danhMuc.getHinhThucNhuCauLamViecVayVon);
    }
    getAllNganhNgheDT() {
        return super.get(apiUrl.LDVL.danhMuc.getAllNganhNgheDT);
    }

    getTextGQVL() {
        return super.get(apiUrl.LDVL.giaiQuyetViecLam.getMa);
    }
    getAllLoaiViecLam() {
        return super.get(apiUrl.LDVL.danhMuc.loaiLamViec);
    }
    getAllKhuVuc() {
        return super.get(apiUrl.LDVL.danhMuc.khuVuc);
    }

    themMoiGiaiQuyetViecLamCMU(requestBody) {
        return super.post(apiUrl.LDVL.giaiQuyetViecLam.themMoiGQVLCMU, requestBody);
    }
    capNhatGiaiQuyetViecLamCMU(requestBody) {
        return super.put(apiUrl.LDVL.giaiQuyetViecLam.capNhatGQVLCMU, requestBody);
    }
    getGiaiQuyetViecLamCMU(obj): Observable<any> {
        return super.get(apiUrl.LDVL.giaiQuyetViecLam.getGQVLCMU, obj);
    }

    /**
* @author anhnt.it5
* @method POST
* @param requestBody
* @description download file mẫu
*/
    xuatFileGQVL(): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.giaiQuyetViecLam.exportMauGQVL, "File mẫu import giải quyết việc làm.xlsx");
    }

    /**
    * @author anhnt.it5
    * @method POST
    * @param requestBody
    * @description
    */
    checkFileImportGQVL(obj): Observable<any> {

        const token = localStorage.getItem(AUTH.TOKEN_KEY);
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

        const formData = new FormData();
        formData.append("maTinh", obj.maTinh);
        formData.append("nam", obj.nam);
        formData.append("file", obj.file);

        return this.http.post(apiUrl.LDVL.giaiQuyetViecLam.checkImportQGVL, formData, { headers });
    }

    /**
    * @author psdung
    * @method GET
    * @param requestBody
    * @description
    */
    uploadFileImportGQVL(obj): Observable<any> {

        const token = localStorage.getItem(AUTH.TOKEN_KEY);
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

        const formData = new FormData();
        formData.append("maTinh", obj.maTinh);
        formData.append("nam", obj.nam);
        formData.append("file", obj.file);

        return this.http.post(apiUrl.LDVL.giaiQuyetViecLam.importGQVL, formData, { headers });
    }


    getgiayPhepLaoDong(idDKCapPhep, idDkCapLaiGiayPhep, type): Observable<any> {
        let token = this.getAccessToken();
        const params: any = {};
        if (idDKCapPhep) {
            params.idDKCapPhep = idDKCapPhep;
        }
        if (idDkCapLaiGiayPhep) {
            params.idDkCapLaiGiayPhep = idDkCapLaiGiayPhep;
        }
        params.type = type;
        if (type.includes('PDF')) {
            return this.http.get(apiUrl.LDVL.baoCao.giayPhepLaoDong, { params: params, responseType: 'blob' as 'json', headers: new HttpHeaders({ Authorization: token }) });

        } else {
            if (idDKCapPhep) {
                return super.downloadFile(apiUrl.LDVL.baoCao.giayPhepLaoDong + "?idDKCapPhep=" + idDKCapPhep + "&type=DOCX", "Giấy phép lao động.DOCX");
            } else {
                return super.downloadFile(apiUrl.LDVL.baoCao.giayPhepLaoDong + "?idDkCapLaiGiayPhep=" + idDkCapLaiGiayPhep + "&type=DOCX", "Giấy phép lao động.DOCX");
            }
        }

    }
    getAccessToken = () => {
        return 'Bearer ' + localStorage.getItem('access_token');
    }

    mauBCLaoDongTheoTrinhDoCMU(maTinh, maXa, nam, type): Observable<any> {
        let requestOptions = {
            responseType: 'text' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'text/plain'
            })
        };

        if (maXa == 'null') {
            return this.http.get(apiUrl.LDVL.baoCao.mauBCLaoDongTheoTrinhDoChuyenMonCMU + "?maTinh=" + maTinh + "&nam=" + nam + "&type=" + type, requestOptions);
        }
        else {
            return this.http.get(apiUrl.LDVL.baoCao.mauBCLaoDongTheoTrinhDoChuyenMonCMU + "?maTinh=" + maTinh + "&maXa=" + maXa + "&nam=" + nam + "&type=" + type, requestOptions);
        }
    }

    mauBCLaoDongTheoTrinhDoCMUChiTiet(maTinh, maXa, nam, type): Observable<any> {
      let requestOptions = {
          responseType: 'text' as 'json',
          headers: new HttpHeaders({
              Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
              'Content-Type': 'text/plain'
          })
      };

      if (maXa == 'null') {
          return this.http.get(apiUrl.LDVL.baoCao.mauBCLaoDongTheoTrinhDoChuyenMonChiTietCMU + "?maTinh=" + maTinh + "&nam=" + nam + "&type=" + type, requestOptions);
      }
      else {
          return this.http.get(apiUrl.LDVL.baoCao.mauBCLaoDongTheoTrinhDoChuyenMonChiTietCMU + "?maTinh=" + maTinh + "&maXa=" + maXa + "&nam=" + nam + "&type=" + type, requestOptions);
      }
  }

    mauBCLaoDongTheoTrinhDoCMUExcell(maTinh, maXa, nam, type) {
        if (maXa == 'null') {
            return super.downloadFile(apiUrl.LDVL.baoCao.mauBCLaoDongTheoTrinhDoChuyenMonCMU + "?maTinh=" + maTinh + "&nam=" + nam + "&type=" + type, "Báo cáo lao động theo trình độ");
        }
        else {
            return super.downloadFile(apiUrl.LDVL.baoCao.mauBCLaoDongTheoTrinhDoChuyenMonCMU + "?maTinh=" + maTinh + "&maXa=" + maXa + "&nam=" + nam + "&type=" + type, "Báo cáo lao động theo trình độ");
        }
    }

    mauBCLaoDongTheoTrinhDoCMUChiTietExcell(maTinh, maXa, nam, type) {
      if (maXa == 'null') {
          return super.downloadFile(apiUrl.LDVL.baoCao.mauBCLaoDongTheoTrinhDoChuyenMonChiTietCMU + "?maTinh=" + maTinh + "&nam=" + nam + "&type=" + type, "Báo cáo lao động theo trình độ");
      }
      else {
          return super.downloadFile(apiUrl.LDVL.baoCao.mauBCLaoDongTheoTrinhDoChuyenMonChiTietCMU + "?maTinh=" + maTinh + "&maXa=" + maXa + "&nam=" + nam + "&type=" + type, "Báo cáo lao động theo trình độ");
      }
  }

    xuatExcelMau03(maXa, maSoThue, tenDoanhNghiep, kcn): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.baoCao.excelMau03 + "?maXa=" + maXa + "&maSoThue=" + maSoThue + "&tenDoanhNghiep=" + tenDoanhNghiep + "&kcn=" + kcn, "Thông tin NLĐNN làm việc tại VN (Mẫu 03)");
    }
    getListTinTuc(obj): Observable<any> {
        return super.post(apiUrl.LDVL.congTy.dangTinTuc.getDanhSach, obj);

    }

    /**
    * @author psdung
    * @method POST
    * @param requestBody
    * @description Thêm mới cau ban đầu
    */
    addTinTuc(requestBody) {
        return super.post(apiUrl.LDVL.congTy.dangTinTuc.themMoiTin, requestBody);
    }

    /**
    * @author psdung
    * @method PUT
    * @param requestBody
    * @description Cập nhật cau ban đầu
    */
    updateTinTuc(requestBody) {
        return super.put(apiUrl.LDVL.congTy.dangTinTuc.capNhatTin, requestBody);
    }

    /**
    * @author psdung
    * @method DELETE
    * @param maHo
    * @description Xóa cau ban đầu
    */
    deleteTinTuc(uuid, trangThaiXoa) {
        return super.delete(apiUrl.LDVL.congTy.dangTinTuc.xoaTin, { uuid: uuid, trangThaiXoa: trangThaiXoa });
    }

    uploadFileDinhKem(userUUID, file): Observable<any> {
        return super.post(apiUrl.LDVL.congTy.dangTinTuc.uploadFile + "?userUUID=" + userUUID, file);
    }

    getChiTietTinTuc(uuid): Observable<any> {
        return super.get(apiUrl.LDVL.congTy.dangTinTuc.getChiTiet + "?uuid=" + uuid);
    }

    getFileDangTin(fileID, fileName): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.congTy.dangTinTuc.downloadFile + "/" + fileID, fileName);
    }

    getBanner(body): Observable<any> {
        return super.get(apiUrl.LDVL.congTy.dangTinTuc.getBanner, body);
    }

    getAnhDaiDien(fileID): Observable<any> {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        return this.http.get(apiUrl.LDVL.congTy.dangTinTuc.downloadFile + "/" + fileID, requestOptions);
    }

    uploadImgTinTuc(userUUID, file): Observable<any> {
        return super.post(apiUrl.LDVL.congTy.dangTinTuc.uploadFile + "?userUUID=" + userUUID, file);
    }

    addThanhVienCMU(requestBody) {
        // return super.post(apiUrl.LDVL.thanhVien.ADD_UPDATE_DELETE, requestBody);
        return super.post(apiUrl.LDVL.thanhVien.ADD_THANH_VIEN_CMU, requestBody);
    }

    getThanhVienBanDauTheoID(idThanhVien) {
        return super.get(apiUrl.LDVL.thanhVien.getThanhVienBanDauID + "/" + idThanhVien);
    }
    getChiTieuGQVLCapHuyenCMU(obj): Observable<any> {

        return super.get(apiUrl.LDVL.chiTieuGQVL.getChiTieuGQVLCMU, obj);

    }
    addChiTieuGQVLCMU(requestBody) {
        return super.post(apiUrl.LDVL.chiTieuGQVL.ADD_CMU, requestBody);
    }
    getChiTieuGQVLCapXaCMU(obj): Observable<any> {

        return super.get(apiUrl.LDVL.chiTieuGQVL.getChiTieuGQVLCMU_CAP_XA, obj);
    }

    deleteThanhVienBienDongCmu(idthanhVien) {
        return super.delete(apiUrl.LDVL.thanhVien.deleteThanhVienBienDongCmu, { idThanhVien: idthanhVien, isBienDong: true });
    }

    tongHopThongTinCungLD(maTinh, maXa, nam, type): Observable<any> {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };

        if (maXa == 'null') {
            return this.http.get(apiUrl.LDVL.baoCao.tongHopThongTinCungLD + "?maTinh=" + maTinh + "&nam=" + nam + "&reportType=" + type, requestOptions);
        }
        else {
            return this.http.get(apiUrl.LDVL.baoCao.tongHopThongTinCungLD + "?maTinh=" + maTinh + "&maXa=" + maXa + "&nam=" + nam + "&reportType=" + type, requestOptions);
        }
    }

    tongHopThongTinCungLDExcel(maTinh, maXa, nam, type) {
        if (maXa == 'null') {
            return super.downloadFile(apiUrl.LDVL.baoCao.tongHopThongTinCungLD + "?maTinh=" + maTinh + "&nam=" + nam + "&reportType=" + type, "Tổng hợp thông tin cung lao động");
        }
        else {
            return super.downloadFile(apiUrl.LDVL.baoCao.tongHopThongTinCungLD + "?maTinh=" + maTinh + "&maXa=" + maXa + "&nam=" + nam + "&reportType=" + type, "Tổng hợp thông tin cung lao động");
        }
    }

    searchDoiTuongGQVL(obj): Observable<any> {

        return super.get(apiUrl.LDVL.giaiQuyetViecLam.getDoiTuongGQVLCMU, obj);

    }

    xuatFileTemplateCMU(maXa): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.cungBanDau.exportTemplateCMU + "?maXa=" + maXa, "File_mẫu_import_cung_ban_đầu.xlsx");
    }

    uploadFileImportCMU(obj): Observable<any> {
        return super.post(apiUrl.LDVL.cungBanDau.importThanhVienCMU, obj);
    }
    updateThanhVienBanDauCMU(requestBody) {
        return super.put(apiUrl.LDVL.thanhVien.ADD_UPDATE_BAN_DAU_CMU, requestBody);
    }

    /**
    * @author anhnt
    * @method POST
    * @param requestBody
    * @description Tìm kiếm danh mục loại chấn thương
    */
    timKiemChanThuong(obj) {
        return super.post(apiUrl.LDVL.danhMuc.timKiemChanThuong, obj);
    }

    /**
    * @author anhnt
    * @method POST
    * @param requestBody
    * @description Thêm mới danh mục loại chấn thương
    */
    themMoiChanThuong(requestBody) {
        return super.post(apiUrl.LDVL.danhMuc.loaiChanThuong_ADD, requestBody);
    }

    /**
* @author anhnt
* @method POST
* @param requestBody
* @description Cập nhật chấn thương
*/
    capNhatChanThuong(requestBody) {
        return super.post(apiUrl.LDVL.danhMuc.loaiChanThuong_UPDATE, requestBody);
    }

    /**
* @author anhnt
* @method DELETE
* @param idDanhMuc
* @param trangThaiXoa
* @description Xoá chấn thương
*/
    xoaChanThuong(uuid) {
        return super.delete(apiUrl.LDVL.danhMuc.loaiChanThuong_DELETE + "?uuid=" + uuid);
    }

    /**
    * 23/08/2023
    * @author anhnt
    * @method POST
    * @param requestBody
    * @description Tìm kiếm danh mục kinh tế/ hành chính sự nghiệp
    */
    timKiemHCSN(obj) {
        return super.post(apiUrl.LDVL.danhMuc.timKiemKTHCSN, obj);
    }

    /**
    * 23/08/2023
    * @author anhnt
    * @method POST
    * @param requestBody
    * @description Thêm mới danh mục kinh tế/ hành chính sự nghiệp
    */
    themMoiKTHCSN(requestBody) {
        return super.post(apiUrl.LDVL.danhMuc.themMoiKTHCSN, requestBody);
    }

    /**
    * 23/08/2023
    * @author anhnt
    * @method POST
    * @param requestBody
    * @description Cập nhật kinh tế/ hành chính sự nghiệp
    */
    capNhatKTHCSN(requestBody) {
        return super.post(apiUrl.LDVL.danhMuc.capNhatKTHCSN, requestBody);
    }

    /**
    * 23/08/2023
    * @author anhnt
    * @method DELETE
    * @param uuid
    * @description Xoá kinh tế/ hành chính sự nghiệp
    */
    xoaKTHCSN(uuid) {
        return super.delete(apiUrl.LDVL.danhMuc.xoaKTHCSN + "?uuid=" + uuid);
    }

    /**
    * 25/08/2023
    * @author anhnt
    * @method POST
    * @param requestBody
    * @description Tìm kiếm danh mục quốc tịch
    */
    timKiemQuocTich(obj) {
        return super.post(apiUrl.LDVL.danhMuc.timKiemQuocTich, obj);
    }

    /**
    * 25/08/2023
    * @author anhnt
    * @method POST
    * @param requestBody
    * @description Thêm mới danh mục quốc tịch
    */
    themMoiQuocTich(requestBody) {
        return super.post(apiUrl.LDVL.danhMuc.themMoiQuocTich, requestBody);
    }

    /**
    * 25/08/2023
    * @author anhnt
    * @method POST
    * @param requestBody
    * @description Cập nhật danh mục quốc tịch
    */
    capNhatQuocTich(requestBody) {
        return super.post(apiUrl.LDVL.danhMuc.capNhatQuocTich, requestBody);
    }

    /**
    * 25/08/2023
    * @author anhnt
    * @method DELETE
    * @param uuid
    * @description Xoá danh mục quốc tịch
    */
    xoaQuocTich(uuid) {
        return super.delete(apiUrl.LDVL.danhMuc.xoaQuocTich + "?uuid=" + uuid);
    }

    //anhnt.it5
    //Xuất khẩu lao động CMU

    getAll(obj): Observable<any> {
        return super.get(apiUrl.LDVL.XKLD_CMU.getAll, obj);
    }

    getByID(id): Observable<any> {
        return super.get(apiUrl.LDVL.XKLD_CMU.getByID + '/' + id);
    }

    /**
       * @author AnhNT
       * @method GET
       * @param requestBody
       * @description Them mới thông tin
       */
    addNewXKLDCMU(body): Observable<any> {
        return super.post(apiUrl.LDVL.XKLD_CMU.addNewXKLD, body);

    }

    updateXKLD(body, id): Observable<any> {
        return super.put(apiUrl.LDVL.XKLD_CMU.updateXKLD + '/' + id, body);

    }

    deleteXKLD(id): Observable<any> {
        return super.delete(apiUrl.LDVL.XKLD_CMU.deleteXKLD + '/' + id);
    }

    getAllMucLuong_CMU() {
        return super.get(apiUrl.LDVL.XKLD_CMU.getAllMucLuong_CMU);
    }
    getBCLaoDongTrongDoTuoi(obj): Observable<any> {
        let requestOptions = new HttpHeaders({
            Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
            'Content-Type': 'application/json'
        });

        return this.http.get(apiUrl.LDVL.baoCao.exportBCLaoDongTrongDoTuoi, { headers: requestOptions, responseType: 'blob', params: obj });
    }


    // Thân nhân

    addNewTN(body): Observable<any> {
        return super.post(apiUrl.LDVL.XKLD_CMU.addTN, body);

    }

    getAllTN(id) {
        return super.get(apiUrl.LDVL.XKLD_CMU.getAllTN + '/' + id);
    }

    updateTN(body, id) {
        return super.post(apiUrl.LDVL.XKLD_CMU.updateTN + '/' + id, body);
    }

    deleteTN(id) {
        return super.delete(apiUrl.LDVL.XKLD_CMU.deleteTN + '/' + id);
    }

    vb_cmu(file): Observable<any> {
        return super.post(apiUrl.LDVL.XKLD_CMU.vb_cmu, file);
    }
    getVB_CMU(id) {
        return super.get(apiUrl.LDVL.XKLD_CMU.vb_cmu + '/' + id);
    }

    getVB_CMU_Down(id, name): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.XKLD_CMU.vb_cmu_download + '/' + id, name);
    }

    getDTCMU(data): Observable<any> {
        return super.get(apiUrl.LDVL.XKLD_CMU.getAllDT, data);
    }

    mauBCLaoDongTheoTinhTrangViecLamCMU(maTinh, maXa, nam, type): Observable<any> {
        let requestOptions = {
            responseType: 'text' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'text/plain'
            })
        };

        if (maXa == 'null') {
            return this.http.get(apiUrl.LDVL.baoCao.mauBCLaoDongTheoTinhTrangViecLamCMU + "?maTinh=" + maTinh + "&nam=" + nam + "&type=" + type, requestOptions);
        }
        else {
            return this.http.get(apiUrl.LDVL.baoCao.mauBCLaoDongTheoTinhTrangViecLamCMU + "?maTinh=" + maTinh + "&maXa=" + maXa + "&nam=" + nam + "&type=" + type, requestOptions);
        }
    }

    mauBCLaoDongTheoTinhTrangViecLamCMUExcell(maTinh, maHuyen, maXa, nam, type) {
        if (maHuyen == 'null') {
            return super.downloadFile(apiUrl.LDVL.baoCao.mauBCLaoDongTheoTinhTrangViecLamCMU + "?maTinh=" + maTinh + "&nam=" + nam + "&type=" + type, "Báo cáo lao động theo trình độ");
        } else if (maXa == 'null') {
            return super.downloadFile(apiUrl.LDVL.baoCao.mauBCLaoDongTheoTinhTrangViecLamCMU + "?maTinh=" + maTinh + "&maHuyen=" + maHuyen + "&nam=" + nam + "&type=" + type, "Báo cáo lao động theo trình độ");
        }
        else {
            return super.downloadFile(apiUrl.LDVL.baoCao.mauBCLaoDongTheoTinhTrangViecLamCMU + "?maTinh=" + maTinh + "&maHuyen=" + maHuyen + "&maXa=" + maXa + "&nam=" + nam + "&type=" + type, "Báo cáo lao động theo trình độ");
        }
    }

    downloadListXKLD(obj): Observable<any> {
        if (obj.maTinh === '04') {
            return super.downloadFile(apiUrl.LDVL.XKLD_CMU.xuatDanhSach, 'Danh sách người lao động tỉnh Cao Bằng đi làm việc ở nước ngoài theo hợp đồng.xlsx', obj);
        } else {
            return super.downloadFile(apiUrl.LDVL.XKLD_CMU.downLoadListXKLD, 'Danh sách người lao động Việt Nam làm việc tại nước ngoài.xlsx', obj);
        }
    }

    getDataDashboardLDVLViecLam(maTinh, maXa, maAp, nam): Observable<any> {
        return super.get(apiUrl.LDVL.thanhVien.dashboardLDVLViecLam + "?maTinh=" + maTinh + "&maXa=" + maXa + "&maAp=" + maAp + "&nam=" + nam);
    }

    getDataDashboardLdvlHGI(requestBody) {
        return super.get(apiUrl.LDVL.thanhVien.dasboardLDVL_HGI, requestBody);
    }

    getDataDashboardLdvlHGICoViecLam(requestBody) {
        return super.get(apiUrl.LDVL.thanhVien.dasboardLDVL_HGI_CoViecLam, requestBody);
    }

    getDataDashboardLdvlHGIThatNghiep(requestBody) {
        return super.get(apiUrl.LDVL.thanhVien.dasboardLDVL_HGI_ThatNghiep, requestBody);
    }

    // Begin AGG

    getListDtHuongBHTN(obj): Observable<any> {
        return super.get(apiUrl.BHTN_AGG.troCapThatNghiep.timKiem, obj);
    }

    upload(data): Observable<HttpEvent<any>> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

        const formData = new FormData();
        formData.append("file", data.file);
        formData.append("uuidHsTuVanViecLam", data.hoSoID);
        formData.append("userUUID", data.userUUID);

        const req = new HttpRequest('POST', apiUrl.BHTN_CMU.tuVanViecLam.uploadFile, formData, {
            reportProgress: true, headers
        });

        return this.http.request(req)
    }


    downloadFile(fileId, tenFile) {
        return super.downloadFile(apiUrl.BHTN_CMU.tuVanViecLam.downloadFile + "/" + fileId, tenFile);
    }



    baoCaoGQvLThangXa(requestBody) {
        return super.downloadFile(apiUrl.LDVL.giaiQuyetViecLam.baoCaoGQVLThangXa, "Báo cáo giải quyết việc làm tháng xã", requestBody);
    }

    getBaoCaoGQVLThangXa(requestBody): Observable<any> {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        return this.http.post(apiUrl.LDVL.giaiQuyetViecLam.baoCaoGQVLThangXa, requestBody, requestOptions);

    }

    getKyBaoCao() {
        return super.get(apiUrl.LDVL.danhMuc.kyBaoCao);
    }

    baoCaoGQvLQuyXa(requestBody) {
        return super.downloadFile(apiUrl.LDVL.giaiQuyetViecLam.baoCaoGQVLQuyXa, "Báo cáo giải quyết việc làm quý xã", requestBody);
    }

    getBaoCaoGQVLQuyXa(requestBody): Observable<any> {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        return this.http.post(apiUrl.LDVL.giaiQuyetViecLam.baoCaoGQVLQuyXa, requestBody, requestOptions);

    }
    //Việc tìm người
    getChiTietViecTimNguoi(id): Observable<any> {
        return super.get(apiUrl.AGG.getDanhSachChiTietViecTimNguoi + "?id=" + id);
    }
    updateDanhSachViecTimNguoi(requestBody) {
        return super.put(apiUrl.AGG.updateDanhSachViecTimNguoi, requestBody);
    }
    dowloadFileExcelMauQlViecTimNguoi(requestBody) {
        return super.get("", requestBody);
    }
    uploadFileImportQlViecTimNguoi(obj,file): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');
        const formData = new FormData();
        formData.append("thang", obj.thang);
        formData.append("nam", obj.nam);
        formData.append("file", obj.file);
        let api = apiUrl.AGG.importDataFromExcelDanhSachViecTimNguoi;
        if (obj.nam != null && obj.nam != "null") {
            api += "?nam=" + obj.nam;
        }
        if (obj.thang != null && obj.thang != "null") {
            api += "&thang=" + obj.thang;
        }
        return this.http.post(api, file, { reportProgress: true, headers });
    }

    deleteDanhSachViecTimNguoi(id, trang_thai_xoa): Observable<any> {
        return super.delete(apiUrl.AGG.deleteDanhSachViecTimNguoi + "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
    }
    themDanhSachViecTimNguoi(requestBody) {
        return super.post(apiUrl.AGG.addDanhSachViecTimNguoi, requestBody);
    }
    downloadTemplateImportHsViecTimNguoi(filename) {
        return super.downloadFile(apiUrl.AGG.exportSampleFile, filename);
    }
    // Begin AGG

    getListSoLieuDN(obj): Observable<any> {
        return super.get(apiUrl.SLDN_AGG.sldn.timKiem, obj);
    }

    getListSoLieuDNKV(obj): Observable<any> {
        return super.get(apiUrl.SLDN_AGG.sldn.timKiemKV, obj);
    }

    uploadFileImportSLDN(file, obj): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

        let api = apiUrl.SLDN_AGG.sldn.importSoLieuDN;
        if (obj.thoiGian != null && obj.thoiGian != "null") {
            api += "?thoiGian=" + obj.thoiGian;
        }
        return this.http.post(api, file, { reportProgress: true, headers });
    }

    uploadFileImportSLDNKV(file, obj): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

        let api = apiUrl.SLDN_AGG.sldn.importSoLieuDNKV;
        if (obj.thoiGianKV != null && obj.thoiGianKV != "null") {
            api += "?thoiGianKV=" + obj.thoiGianKV;
        }
        return this.http.post(api, file, { reportProgress: true, headers });
    }

    getDataTKThiTruongLD(obj): Observable<any> {
        const token = localStorage.getItem(AUTH.TOKEN_KEY);
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

        // return this.http.get(apiUrl.LDVL.thongKeThiTruong.timKiemThongKeThiTruongLaoDong + "?tenChiTieu=" + obj.tenChiTieu
        // + "&maDanhMucCha=" + obj.maDanhMucCha + "&nam=" + obj.nam + "&pageIndex=" + obj.pageIndex + "&pageSize=" + obj.pageSize, { headers });

        return super.get(apiUrl.LDVL.thongKeThiTruong.timKiemThongKeThiTruongLaoDong, obj)

    }

    importFileTKThiTruongLD(obj): Observable<any> {
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'X-Tenant': 'so_ld',
            })
        };
        return this.http.post(apiUrl.LDVL.thongKeThiTruong.importThongKeThiTruongLaoDong, obj, requestOptions);
    }

    updateDataTKThiTruongLD(nam, obj): Observable<any> {
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
            })
        };

        let api = apiUrl.LDVL.thongKeThiTruong.capNhatThongKeThiTruongLaoDong + "?nam=" + nam;

        return this.http.post(api, obj, requestOptions);
    }

    addDataTKThiTruongLD(nam, obj): Observable<any> {
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
            })
        };

        let api = apiUrl.LDVL.thongKeThiTruong.themMoiThongKeThiTruongLaoDong + "?nam=" + nam;

        return this.http.post(api, obj, requestOptions);
    }

    xoaDataTKThiTruongLD(obj): Observable<any> {
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json',
            })
        };
        return this.http.delete(apiUrl.LDVL.thongKeThiTruong.xoaThongKeThiTruongLaoDong + "?id=" + obj.id, requestOptions);
    }

    //Danh mục thị trường lao động
    getDMTKThiTruongLD(): Observable<any> {
        const token = localStorage.getItem(AUTH.TOKEN_KEY);
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');
        return super.get(apiUrl.LDVL.thongKeThiTruong.getDMTKThiTruongLD);
    }

    danhMucLoaiHinhDoanhNghiep() {
        return super.get(apiUrl.SLDN_AGG.sldn.danhMucLoaiHinhDoanhNghiep);
    }

    themMoiSoLieuDN_LH(obj): Observable<any> {
        return super.post(apiUrl.SLDN_AGG.sldn.themMoiSoLieuDN_LH, obj);
    }

    capNhatSoLieuDN_LH(obj): Observable<any> {
        return super.post(apiUrl.SLDN_AGG.sldn.capNhatSoLieuDN_LH, obj);
    }

    xoaSoLieuDN_LH(id): Observable<any> {
        return super.delete(apiUrl.SLDN_AGG.sldn.xoaSoLieuDN_LH, { id: id });
    }

    downloadTemplate_LH(filename): Observable<any> {
        return super.downloadFile(apiUrl.SLDN_AGG.sldn.templateSoLieuDN_LH, filename);
    }

    themMoiSoLieuDN_KV(obj): Observable<any> {
        return super.post(apiUrl.SLDN_AGG.sldn.themMoiSoLieuDN_KV, obj);
    }

    capNhatSoLieuDN_KV(obj): Observable<any> {
        return super.post(apiUrl.SLDN_AGG.sldn.capNhatSoLieuDN_KV, obj);
    }

    xoaSoLieuDN_KV(id): Observable<any> {
        return super.delete(apiUrl.SLDN_AGG.sldn.xoaSoLieuDN_KV, { id: id });
    }

    downloadTemplate_KV(filename): Observable<any> {
        return super.downloadFile(apiUrl.SLDN_AGG.sldn.templateSoLieuDN_KV, filename);
    }
    // End AGG
    themMoiSoLD(obj): Observable<any> {
        return super.post(apiUrl.LDVL.nld_dn.themMoiSoLDTrongDNTheoHuyen, obj);
    }
    getBCThanhVien_CMU(idThanhVien): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.baoCao.getBCThanhVien_CMU + "?idThanhVien=" + idThanhVien, "Báo cáo thành viên");
    }

    //doanh nghiệp xuất khẩu lao động
    getXuatKhauLaoDong(obj): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.getXuatKhauLaoDong, obj);
    }

    addXuatKhauLaoDong(obj, oLaiLamHDMoi): Observable<any> {
        return super.post(apiUrl.LDVL.AGG.addXuatKhauLaoDong + "?oLaiLamHDMoi=" + oLaiLamHDMoi, obj);
    }

    updateXuatKhauLaoDong(obj, uuid, oLaiLamHDMoi): Observable<any> {
        console.log("Cập nhật");
        return super.post(apiUrl.LDVL.AGG.editXuatKhauLaoDong + '?uuid=' + uuid + "&oLaiLamHDMoi=" + oLaiLamHDMoi, obj);
    }

    deleteXuatKhauLaoDong(uuid): Observable<any> {
        return super.delete(apiUrl.LDVL.AGG.deleteXuatKhauLaoDong + "/" + uuid);
    }

    uploadFileImportXuatKhauLaoDong(file, obj): Observable<any> {
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
            })
        };

        let api = apiUrl.LDVL.AGG.importXuatKhauLaoDong;
        if (obj.nam != null && obj.nam != "null") {
            api += "?nam=" + obj.nam;
        }

        if (obj.thang != null && obj.thang != "null") {
            api += "&thang=" + obj.thang;
        }

        if (obj.maTinh != null && obj.maTinh != "null") {
            api += "&maTinh=" + obj.maTinh;
        }

        return this.http.post(api, file, requestOptions);
    }

    downloadTemplateXuatKhauLD(filename): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.AGG.templateXuatKhauLaoDong, filename);
    }


    //lao động nước ngoài làm việc tại Việt Nam
    getLDNNLVTaiVN(obj): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.getLDNNLVTaiVN, obj);
    }

    addLDNNLVTaiVN(obj): Observable<any> {
        return super.post(apiUrl.LDVL.AGG.addLDNNLVTaiVN, obj);
    }

    updateLDNNLVTaiVN(obj, uuid): Observable<any> {
        return super.put(apiUrl.LDVL.AGG.editLDNNLVTaiVN, obj);
    }

    deleteLDNNLVTaiVN(uuid): Observable<any> {
        return super.delete(apiUrl.LDVL.AGG.deleteLDNNLVTaiVN, { id: uuid });
    }

    uploadFileImportLDNNLVTaiVN(file, obj): Observable<any> {
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
            })
        };

        let api = apiUrl.LDVL.AGG.importLDNNLVTaiVN + "?trangThaiGiayPhep=" + obj.trangThaiGiayPhep;

        return this.http.post(api, file, requestOptions);
    }

    //AGG

    exportBaoCaoTH(body): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.doanhNghiep.exportBaoCaoTaiNanLaoDongTH, "BÁO CÁO TỔNG HỢP TÌNH HÌNH TAI NẠN LAO ĐỘNG", body);
    }

    exportBaoCaoTinhHinh(body): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.doanhNghiep.exportBaoCaoTaiNanLaoDongTinhHinh, "BÁO CÁO TỔNG HỢP TÌNH HÌNH TAI NẠN LAO ĐỘNG (Đối tượng không theo hợp đồng lao động)", body);
    }

    getDataAnToanLD(obj): Observable<any> {
        const token = localStorage.getItem(AUTH.TOKEN_KEY);
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

        return this.http.get(apiUrl.LDVL.AGG.anToanLaoDong.searchATLD + "?nam=" + obj.nam + "&tenChiTieu=" + obj.tenChiTieu
            + "&loai=" + obj.loai + "&pageIndex=" + obj.pageIndex + "&pageSize=" + obj.pageSize, { headers });

    }

    importFileAnToanLD(file, obj): Observable<any> {
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
            })
        };

        let api = apiUrl.LDVL.AGG.anToanLaoDong.importATLD;
        if (obj.nam != null && obj.nam != "null") {
            api += "?nam=" + obj.nam;
        }

        if (obj.loai != null && obj.loai != "null") {
            api += "&loai=" + obj.loai;
        }

        if (obj.startRow != null && obj.startRow != "null") {
            api += "&startRow=" + obj.startRow;
        }

        return this.http.post(api, file, requestOptions);
    }

    addATLD(requestBody) {
        return super.post(apiUrl.LDVL.AGG.anToanLaoDong.addATLD, requestBody);
    }

    editATLD(requestBody) {
        return super.post(apiUrl.LDVL.AGG.anToanLaoDong.updateATLD, requestBody);
    }

    deleteATLD(obj) {
        return super.delete(apiUrl.LDVL.AGG.anToanLaoDong.deleteATLD, obj);
    }

    downloadTemplateATLD(filename): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.AGG.anToanLaoDong.downloadTemplateATLD, filename);
    }

    downloadTemplateATLD_KHD(filename): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.AGG.anToanLaoDong.downloadTemplateATLD_KHD, filename);
    }

    getDMChiTieu() {
        return super.get(apiUrl.LDVL.AGG.anToanLaoDong.dmChiTieuATLD);
    }

    getDMMaSo() {
        return super.get(apiUrl.LDVL.AGG.anToanLaoDong.dmMaSoATLD);
    }

    downloadTemplateNNNLVTaiVN(filename): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.AGG.templateLDNNLVTaiVN, filename);
    }

    luuChuyenTrangThaiGP(obj): Observable<any> {
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
            })
        };

        let api = apiUrl.LDVL.AGG.chuyenTrangThaiGPLDNNLVTaiVN
        + "?uuid=" + obj.uuid + "&trangThaiGP=" + obj.trangThaiGP + "&soGiayPhep=" + obj.soGiayPhep + "&tuNgay=" + obj.tuNgay + "&denNgay=" + obj.denNgay
        + "&lanCapLai=" + obj.lanCapLai + "&soVBXacNhan=" + obj.soVBXacNhan;
        return this.http.post(api, obj, requestOptions);
    }

    getHinhThucLamViecAGG(){
        return super.get(apiUrl.LDVL.AGG.getHinhThucLamViec);
    }

    // End AGG
    // Người lao động làm việc ở nước ngoài
    getDataLabelXKLD(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataLabelXKLD + "?nam=" + nam + "&thang=" + thang);
    }

    getDataXKLDTheoThiTruong(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataXKLDTheoThiTruong + "?nam=" + nam + "&thang=" + thang);
    }

    getDataXKLDTheoGioiTinh(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataXKLDTheoGioiTinh + "?nam=" + nam + "&thang=" + thang);
    }

    getDataXKLDTheoHuyen(maTinh, nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataXKLDTheoHuyen + "?maTinh=" + maTinh +  "&nam=" + nam + "&thang=" + thang);
    }

    getDataXKLDTheoNganh(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataXKLDTheoNganh + "?nam=" + nam + "&thang=" + thang);
    }

    // Người lao động và việc làm
    getDataLabelBHTN(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataLabelBHTN + "?nam=" + nam + "&thang=" + thang);
    }

    getDataLabelVTN(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataLabelVTN + "?nam=" + nam + "&thang=" + thang);
    }

    getDataLabelNTV(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataLabelNTV + "?nam=" + nam + "&thang=" + thang);
    }

    getDataBHTNTheoGioiTinh(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataXKLDTheoGioiTinh + "?nam=" + nam + "&thang=" + thang);
    }

    getDataLDVLTheoTrinhDo(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataLDVLTheoTrinhDo + "?nam=" + nam + "&thang=" + thang);
    }

    getDataLDVLTheoLoaiHinh(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataLDVLTheoLoaiHinh + "?nam=" + nam + "&thang=" + thang);
    }

    getDataLDVLTrongDoanhNghiep(maTinh, nam): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataLDVLTrongDoanhNghiep + "?maTinh=" + maTinh + "&nam=" + nam);
    }

    getDataLDVLTheoNhom(nam, huyen): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataLDVLTheoNhom + "?nam=" + nam + "&huyen=" + huyen);
    }

    getDataLDVLTheoHuyen(nam, huyen): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataLDVLTheoHuyen + "?nam=" + nam + "&huyen=" + huyen);
    }


    // An toàn lao động
    getDataLabelATLD(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataLabelATLD + "?nam=" + nam + "&thang=" + thang);
    }

    getDataATLDChiPhiHoTro(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataATLDChiPhiHoTrop + "?nam=" + nam + "&thang=" + thang);
    }

    getDataATLDTNLDTheoCoSo(nam): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataATLDTNLDCoSo + "?nam=" + nam);
    }
    // End AGG


    resetPass(tenDangNhap) {
        return super.put(apiUrl.LDVL.ungVien.resetPass + '?username=' + tenDangNhap);
    }

    /**
    * @author sangtv
    * @method POST
    * @param requestBody
    * @description Get template đăng tin
    */
    getTemplateDangTin(): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.baoCao.templateDangTinTuyenDung, "Mẫu đăng tin tuyển dụng");
    }

    capNhatThongTinCongTy(requestBody) {
        return super.post(apiUrl.LDVL.congTy.capNhatThongTinCongTy, requestBody);
    }

    // Người lao động làm việc ở nước ngoài
    getDataLDVLLabelNNNLvTaiVN(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataLDVLLabelNNNLvTaiVN + "?nam=" + nam + "&thang=" + thang);
    }

    getDataLDVLNNNLvTaiVNTheoQuocGia(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataLDVLNNNLvTaiVNTheoQuocGia + "?nam=" + nam + "&thang=" + thang);
    }

    getDataLDVLNNNLvTaiVNTheoGioiTinh(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataLDVLNNNLvTaiVNTheoGioiTinh + "?nam=" + nam + "&thang=" + thang);
    }

    getDataLDVLNNNLvTaiVNTheoChucDanh(nam, thang): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.DASHBOARD.getDataLDVLNNNLvTaiVNTheoChucDanh + "?nam=" + nam + "&thang=" + thang);
    }

    importFileLaoDongCoViecLam(file, obj): Observable<any> {
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
            })
        };

        let api = apiUrl.LDVL.AGG.laoDongToanTinh.importLaoDongCoViecLam;
        if (obj.nam != null && obj.nam != "null") {
            api += "?nam=" + obj.nam;
        }

        if (obj.maHuyen != null && obj.maHuyen != "null") {
            api += "&maHuyen=" + obj.maHuyen;
        }

        if (obj.loai != null && obj.loai != "null") {
            api += "&loai=" + obj.loai;
        }

        if(obj.maTinh != null && obj.maTinh != "null") {
          api += "&maTinh=" + obj.maTinh;
      }

        return this.http.post(api, file, requestOptions);
    }

    importFileLaoDongThatNghiep(file, obj): Observable<any> {
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
            })
        };

        let api = apiUrl.LDVL.AGG.laoDongToanTinh.importLaoDongThatNghiep;
        if (obj.nam != null && obj.nam != "null") {
            api += "?nam=" + obj.nam;
        }

        if (obj.maHuyen != null && obj.maHuyen != "null") {
            api += "&maHuyen=" + obj.maHuyen;
        }

        if (obj.loai != null && obj.loai != "null") {
            api += "&loai=" + obj.loai;
        }

        if(obj.maTinh != null && obj.maTinh != "null") {
          api += "&maTinh=" + obj.maTinh;
      }

        return this.http.post(api, file, requestOptions);
    }

    importFileLaoDongKHDKT(file, obj): Observable<any> {
        let requestOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
            })
        };

        let api = apiUrl.LDVL.AGG.laoDongToanTinh.importLaoDongKHDKT;
        if (obj.nam != null && obj.nam != "null") {
            api += "?nam=" + obj.nam;
        }

        if (obj.maHuyen != null && obj.maHuyen != "null") {
            api += "&maHuyen=" + obj.maHuyen;
        }

        if (obj.loai != null && obj.loai != "null") {
            api += "&loai=" + obj.loai;
        }

        if(obj.maTinh != null && obj.maTinh != "null") {
            api += "&maTinh=" + obj.maTinh;
        }

        const formData = new FormData();
        formData.append("file", obj.file);

        return this.http.post(api, file, requestOptions);
    }

    getDataLaoDongToanTinh(obj): Observable<any> {
        return super.get(apiUrl.LDVL.AGG.laoDongToanTinh.searchLaoDongToanTinh, obj);

    }

    addLaoDongToanTinh(requestBody) {
        return super.post(apiUrl.LDVL.AGG.laoDongToanTinh.addLaoDongToanTinh, requestBody);
    }

    updateLaoDongtoanTinh(requestBody) {
        return super.post(apiUrl.LDVL.AGG.laoDongToanTinh.updateLaoDongToanTinh, requestBody);
    }

    deleteLaoDongToanTinh(obj) {
        return super.delete(apiUrl.LDVL.AGG.laoDongToanTinh.deleteLaoDongToanTinh, obj);
    }

    downloadTemplateLaoDongCVL(obj): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.AGG.laoDongToanTinh.downloadTemplateLaoDongCVL + "?maHuyen=" + obj.maHuyen, obj.filename);
    }

    downloadTemplateLaoDongTN(obj): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.AGG.laoDongToanTinh.downloadTemplateLaoDongTN + "?maHuyen=" + obj.maHuyen, obj.filename);
    }

    downloadTemplateLaoDongKHDKT(obj): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.AGG.laoDongToanTinh.downloadTemplateLaoDongKHDKT + "?maHuyen=" + obj.maHuyen, obj.filename);
    }

    addOrUpdatePhienGD(obj): Observable<any> {
        return super.post(apiUrl.LDVL.phienGiaoDichVL.addOrUpdatePhienGD, obj);
    }

    getFileSampleDoiTuongBHTN(filename: string): Observable<any> {
        return super.downloadFile(apiUrl.BHTN_AGG.bhtn.getSampleFileDTHuongBHTN, filename);
    }

    updateTrangThai(obj): Observable<any> {
        return super.post(apiUrl.LDVL.phienGiaoDichVL.updateTrangThai, obj);
    }

    getDSPhienGD(obj): Observable<any> {
        const String = Object.entries(obj).map(([key, value]) => `${key}=${value}`).join('&');
        return super.get(apiUrl.LDVL.phienGiaoDichVL.getDSPhienGD + "?" + String);
    }

    lichSuPhienGD(obj): Observable<any> {
        const String = Object.entries(obj).filter(([key, value]) => value != null && value != "").map(([value, key]) => `${key}=${value}`).join('&');
        return super.get(apiUrl.LDVL.phienGiaoDichVL.lichSuPhienGD + "?" + String);
    }

    chiTietPhienGD(obj): Observable<any> {
        const String = Object.entries(obj).filter(([key, value]) => value != null && value != "").map(([value, key]) => `${key}=${value}`).join('&');
        return super.get(apiUrl.LDVL.phienGiaoDichVL.chiTietPhienGD + "?" + String);
    }

    chiTietLSPhienGD(obj): Observable<any> {
        const String = Object.entries(obj).filter(([key, value]) => value != null && value != "").map(([value, key]) => `${key}=${value}`).join('&');
        return super.get(apiUrl.LDVL.phienGiaoDichVL.chiTietLSPhienGD + "?" + String);
    }


    /**
    * 15/05/2023
    * @author anhnt
    * @method POST
    * @param requestBody
    * @description Tìm kiếm danh mục quốc tịch
    */
    timKiemDmYTDH(obj) {
        return super.post(apiUrl.LDVL.danhMuc.timKiemYTDH, obj);
    }

    /**
    * 15/05/2023
    * @author anhnt
    * @method POST
    * @param requestBody
    * @description Thêm mới danh mục quốc tịch
    */
    themMoiDmYTDH(requestBody) {
        return super.post(apiUrl.LDVL.danhMuc.themMoiYTDH, requestBody);
    }

    /**
    * 15/05/2023
    * @author anhnt
    * @method POST
    * @param requestBody
    * @description Cập nhật danh mục quốc tịch
    */
    capNhatDmYTDH(requestBody) {
        return super.put(apiUrl.LDVL.danhMuc.capNhatYTDH, requestBody);
    }

    /**
    * 25/08/2023
    * @author anhnt
    * @method DELETE
    * @param uuid
    * @description Xoá danh mục quốc tịch
    */
    xoaDmYTDH(uuid) {
        return super.delete(apiUrl.LDVL.danhMuc.xoaYTDH + "?uuid=" + uuid);
    }

    /**
    * 25/08/2023
    * @author anhnt
    * @method DELETE
    * @param uuid
    * @description Xoá danh mục quốc tịch
    */
    getDmYTDH(uuid) {
        return super.get(apiUrl.LDVL.danhMuc.getDSYTDH);
    }

    getSoLuongDN(obj) {
        return super.post(apiUrl.LDVL.doanhNghiep.getSoLuongDN, obj);
    }

    getTLQuyMoDN(obj) {
        return super.post(apiUrl.LDVL.doanhNghiep.getTLQuyMoDN, obj);
    }

    getloaiHinhDN(obj) {
        return super.post(apiUrl.LDVL.doanhNghiep.getloaiHinhDN, obj);
    }

    getDNByHC(obj) {
        return super.post(apiUrl.LDVL.doanhNghiep.getDNByHC, obj);
    }
    getFileSampleTKThiTruongLD(filename) {
        return super.downloadFile(apiUrl.LDVL.thongKeThiTruong.getSampleFileThiTruongLaoDong, filename);
    }

    // Begin AGG

    // SỐ LAO ĐỘNG TRONG DOANH NGHIỆP THEO HUYỆN
    uploadFileImportSoLD(file, obj): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

        let api = apiUrl.LDVL.nld_dn.importSoLDTrongDNTheoHuyen;
        // console.log("obj: ", obj)
        if (obj.nam != null && obj.nam != "null") {
            api += "?nam=" + obj.nam;
        }
        return this.http.post(api, file, { reportProgress: true, headers });
    }

    getSoLDTrongDNTheoHuyen(obj): Observable<any> {
        return super.get(apiUrl.LDVL.nld_dn.timKiemSoLDTrongDNTheoHuyen, obj);
    }

    themMoiSoLDTrongDNTheoHuyen(obj): Observable<any> {
        return super.post(apiUrl.LDVL.nld_dn.themMoiSoLDTrongDNTheoHuyen, obj);
    }

    capNhatSoLDTrongDNTheoHuyen(obj): Observable<any> {
        return super.post(apiUrl.LDVL.nld_dn.caNhatSoLDTrongDNTheoHuyen, obj);
    }

    xoaSoLDTrongDNTheoHuyen(obj): Observable<any> {
        return super.delete(apiUrl.LDVL.nld_dn.xoaSoLDTrongDNTheoHuyen, obj);
    }

    downloadSoLDTheoHuyenTemplate(filename): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.nld_dn.downloadTemplateSoLDTrongDNTheoHuyen, filename);
    }

    // Begin AGG

    // SỐ LAO ĐỘNG TRONG DOANH NGHIỆP THEO LOẠI HÌNH
    dmLoaiHinhDoanhNghiep() {
        return super.get(apiUrl.LDVL.nld_dn.danhMucLoaiHinhDoanhNghiep);
    }

    getSoLDTheoLH(obj): Observable<any> {
        return super.get(apiUrl.LDVL.nld_dn.timKiemSoLDTheoLH, obj);
    }

    uploadFileImportSoLDTheoLH(file, obj): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

        let api = apiUrl.LDVL.nld_dn.importSoLDTheoLH;
        // console.log("obj: ", obj)
        if (obj.nam != null && obj.nam != "null") {
            api += "?nam=" + obj.nam;
        }
        return this.http.post(api, file, { reportProgress: true, headers });
    }

    themMoiSoLDTrongDNTheoLH(obj): Observable<any> {
        return super.post(apiUrl.LDVL.nld_dn.themMoiSoLDTrongDNTheoLH, obj);
    }

    capNhatSoLDTrongDNTheoLH(obj): Observable<any> {
        return super.post(apiUrl.LDVL.nld_dn.caNhatSoLDTheoLH, obj);
    }

    xoaSoLDTrongDNTheoLH(obj): Observable<any> {
        return super.delete(apiUrl.LDVL.nld_dn.xoaSoLDTheoLH, obj);
    }

    downloadSoLDTheoLHTemplate(filename): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.nld_dn.downloadTemplateSoLDTrongDNTheoLH, filename);
    }

    uploadFileImportBHTN(file, obj): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

        let api = apiUrl.BHTN_AGG.bhtn.importDTHuongBHTN;
        console.log("obj: ", obj)
        if (obj.nam != null && obj.nam != "null") {
            api += "?nam=" + obj.nam;
            if (obj.thang != null && obj.thang != "null")
                api += "&thang=" + obj.thang;
        }

        return this.http.post(api, file, { reportProgress: true, headers });
    }

    getDmNgheTruocKhiThatNghiep() {
        return super.get(apiUrl.BHTN_AGG.danhMuc.ngheTruocKhiThatNghiep);
    }

    getDmNganhNgheDaoTao() {
        return super.get(apiUrl.BHTN_AGG.danhMuc.getDmNganhNgheDaoTaoAgg);
    }

    getDmChuyenMonKt() {
        return super.get(apiUrl.BHTN_AGG.danhMuc.chuyenMonKt);
    }

    getDmVeTinh(maTinh) {
        return super.get(apiUrl.BHTN_AGG.bhtn.getDmVeTinhAgg + "?maTinh=" + maTinh);
    }

    addDoiTuongHuongBHTN(obj): Observable<any> {
        return super.post(apiUrl.BHTN_AGG.bhtn.addDTHuongBHTN, obj);
    }

    updateDoiTuongHuongBHTN(obj): Observable<any> {
        return super.post(apiUrl.BHTN_AGG.bhtn.updateDTHuongBHTN, obj);
    }

    deleteDoiTuongHuongBHTN(idDoiTuong): Observable<any> {
        return super.delete(apiUrl.BHTN_AGG.bhtn.deleteDTHuongBHTN, { idDtHuongBHTN: idDoiTuong });
    }

    // End AGG

    //Start HGI

    // API thống kê tình hình lao động
    getAllThongKeTinhHinhLaoDong(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.thongKeTinhHinhLaoDong.timKiemThongKeTinhHinhLaoDong, obj);
    }


    getDetailThongKeTinhHinhLaoDong(id) {
        return super.get(apiUrl.LDVL_HGI.thongKeTinhHinhLaoDong.chiTietThongKeTinhHinhLaoDong, { id: id });
    }

    getDetailThongKeTinhHinhLaoDongThangNam(tinh, xa, thang, nam) {
        return super.get(apiUrl.LDVL_HGI.thongKeTinhHinhLaoDong.chiTietThongKeTinhHinhLaoDongThangNam, { tinh: tinh, xa: xa, thang: thang, nam: nam });
    }

    // AGG Việc tìm người
    getListViecTimNguoi(obj):Observable<any> {
        let api = apiUrl.AGG.getDanhSachViecTimNguoi + "?tin_tuyen_dung=" + obj.tin_tuyen_dung
                                                     + "&thang=" + obj.thang
                                                     + "&nam=" +obj.nam
                                                     + "&trang_thai_xoa=" + obj.trang_thai_xoa
                                                     + "&pageNumber=" + obj.pageNumber
                                                     + "&pageSize=" + obj.pageSize
        return super.get(apiUrl.AGG.getDanhSachViecTimNguoi, obj);

    }

    themThongKeTinhHinhLaoDong(requestBody) {
        return super.post(apiUrl.LDVL_HGI.thongKeTinhHinhLaoDong.themMoiThongKeTinhHinhLaoDong, requestBody);
    }

    updateThongKeTinhHinhLaoDong(requestBody) {
        return super.put(apiUrl.LDVL_HGI.thongKeTinhHinhLaoDong.capNhatThongKeTinhHinhLaoDong, requestBody);
    }

    deleteThongKeTinhHinhLaoDong(id) {
        return super.delete(apiUrl.LDVL_HGI.thongKeTinhHinhLaoDong.xoaThongKeTinhHinhLaoDong, { id: id });
    }

    getBCThongKeTinhHinhLaoDong(id): Observable<any> {
        return super.downloadFile(apiUrl.LDVL_HGI.thongKeTinhHinhLaoDong.xuatBaoCaoThongKeTinhHinhLaoDong + "?id=" + id, "Báo cáo thống kê tình hình lao động");
    }

    //Sổ thống kê TNLĐ  - SRS47
    dmDungChung_STKTNLD(code) {
        return super.get(apiUrl.LDVL.soThongKeTNLD.dmDungChung + "?codeDM=" + code);
    }

    dmNgheNghiep_STKTNLD() {
        return super.get(apiUrl.LDVL.soThongKeTNLD.dmNgheNghiep);
    }

    dsTaiNanLD(body) {
        return super.post(apiUrl.LDVL.soThongKeTNLD.dsTaiNanLD, body);
    }

    xuatBaoCao(requestBody, nameFile) {
        return super.downloadFile(apiUrl.LDVL.soThongKeTNLD.xuatBaoCao, nameFile, requestBody);
    }

    xoaSoThongKe(id) {
        return super.delete(apiUrl.LDVL.soThongKeTNLD.xoaSoThongKe, { id: id });
    }

    themMoiSoThongKe(requestBody) {
        return super.post(apiUrl.LDVL.soThongKeTNLD.themSoThongKe, requestBody);
    }
    dsCoSo_STKTNLD(tinh, xa) {
        return super.get(apiUrl.LDVL.soThongKeTNLD.dsCoSo + "?tinh=" + tinh + "&xa=" + xa);
    }
    dmNganhNgheKinhTe_STKTNLD() {
        return super.get(apiUrl.LDVL.soThongKeTNLD.dmNganhNgheKinhTe);
    }
    getTTSoThongKebyID(id) {
        return super.get(apiUrl.LDVL.soThongKeTNLD.dsTaiNanLD + "/" + Number(id));
    }
    suaSoThongKe(requestBody) {
        return super.put(apiUrl.LDVL.soThongKeTNLD.suaSoThongKe, requestBody);
    }
    //end sổ thống kê TNLĐ  - SRS47


    // API khai báo tai nạn lao động
    timKiemKhaiBaoTaiNanLaoDong(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.khaiBaoTaiNanLaoDong.timKiemKhaiBaoTaiNanLaoDong, obj);
    }

    danhSachDanhMucDungChung(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.khaiBaoTaiNanLaoDong.danhSachDanhMucDungChung, obj);
    }

    danhSachNanNhanTaiNanLaoDong(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.khaiBaoTaiNanLaoDong.danhSachNanNhanTaiNanLaoDong, obj);
    }

    getThongTinCoSo(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.khaiBaoTaiNanLaoDong.getThongTinCoSo, obj);
    }

    /**
      * @method POST
      * @param requestBody
      * @description Thêm tờ khai tai nạn lao động
      */
    themMoiKhaiBaoTaiNanLaoDong(requestBody) {
        return super.post(apiUrl.LDVL_HGI.khaiBaoTaiNanLaoDong.themMoiKhaiBaoTaiNanLaoDong, requestBody);
    }

    /**
        * @method PUT
        * @param requestBody
        * @description Cập nhật tờ khai tai nạn lao động
        */
    capNhatKhaiBaoTaiNanLaoDong(requestBody) {
        return super.put(apiUrl.LDVL_HGI.khaiBaoTaiNanLaoDong.capNhatKhaiBaoTaiNanLaoDong, requestBody);
    }

    /**
      * @method DELETE
      * @param requestParam
      * @description Xoá tờ khai tai nạn lao động
      */
    xoaKhaiBaoTaiNanLaoDong(id): Observable<any> {
        return super.delete(apiUrl.LDVL_HGI.khaiBaoTaiNanLaoDong.xoaKhaiBaoTaiNanLaoDong + "?id=" + id);
    }

    getTNLDNguoiLDKhongHopDongHuyenXa(obj): Observable<any> {
        return super.get(apiUrl.LDVL.TNLD.getTNLDNguoiLDKhongHopDongHuyenXa, obj);
    }

    getTNLDNguoiLDKhongHopDongTinh(obj): Observable<any> {
        return super.get(apiUrl.LDVL.TNLD.getTNLDNguoiLDKhongHopDongTinh, obj);
    }

    deleteTNLDNguoiLDKhongHopDong(obj): Observable<any> {
        return super.delete(apiUrl.LDVL.TNLD.deleteTNLDNguoiLDKhongHopDong, obj);
    }

    updateTNLDNguoiLDKhongHopDong(obj): Observable<any> {
        return super.post(apiUrl.LDVL.TNLD.updateTNLDNguoiLDKhongHopDong, obj);
    }


    getDMNgheNghiep() {
        return super.get(apiUrl.LDVL.TNLD.getDMNgheNghiep);
    }


    getDSTrangThai3Cap() {
        return super.get(apiUrl.LDVL.TNLD.getDSTrangThai3Cap);
    }

    getTNLDNguoiLDKhongHopDongChiTiet(obj): Observable<any> {
        return super.get(apiUrl.LDVL.TNLD.getTNLDNguoiLDKhongHopDongChiTiet, obj);
    }

    insertTNLDNguoiLDKhongHopDongChiTiet(obj): Observable<any> {
        return super.post(apiUrl.LDVL.TNLD.insertTNLDNguoiLDKhongHopDongChiTiet, obj);
    }

    updateTNLDNguoiLDKhongHopDongChiTiet(obj): Observable<any> {
        return super.post(apiUrl.LDVL.TNLD.updateTNLDNguoiLDKhongHopDongChiTiet, obj);
    }

    inbaocaoTNLDNguoiLDKhongHDLD_PDF(maTinh, maXa, nam, kyBC, trangThai, type): Observable<any> {
        let str = "?maTinh=" + maTinh;
        if (maXa != 'null') str = str + "&maXa=" + maXa;
        if (nam != null) str = str + "&nam=" + nam;
        if (kyBC != null) str = str + "&kyBaoCao=" + kyBC;
        if (trangThai != null) str = str + "&trangThai=" + trangThai;
        str = str + "&reportType=" + type;
        return this._apiService.getBlobFile(apiUrl.LDVL.TNLD.inbaocaoTNLDNguoiLDKhongHDLD + str);
    }

    inbaocaoTNLDNguoiLDKhongHDLD_DOC(maTinh, maXa, nam, kyBC, trangThai, type): Observable<any> {
        let str = "?maTinh=" + maTinh;
        if (maXa != 'null') str = str + "&maXa=" + maXa;
        if (nam != null) str = str + "&nam=" + nam;
        if (kyBC != null) str = str + "&kyBaoCao=" + kyBC;
        if (trangThai != null) str = str + "&trangThai=" + trangThai;
        str = str + "&reportType=" + type;
        return super.downloadFile(apiUrl.LDVL.TNLD.inbaocaoTNLDNguoiLDKhongHDLD + str, "tai nạn lao động người lao động làm việc không theo hợp đồng lao động");
    }

    // API báo cáo khai báo tai nạn lao động
    timKiemBaoCaoKhaiBaoTaiNanLaoDong(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.baoCaoKhaiBaoTaiNanLaoDong.timKiemBaoCaoKhaiBaoTaiNanLaoDong, obj);
    }

    danhSachNanNhanTaiNanLaoDongOfBaoCao(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.baoCaoKhaiBaoTaiNanLaoDong.danhSachNanNhanTaiNanLaoDongOfBaoCao, obj);
    }

    exportPdfBaoCaoKhaiBaoTNLD(idCoSo, idTaiNan): Observable<any> {
        return super.downloadFile(apiUrl.LDVL_HGI.baoCaoKhaiBaoTaiNanLaoDong.xuatBaoCaoKhaiBaoTNLDByIdCoSoAndIdTaiNan + "?idCoSo=" + idCoSo + "&idTaiNan=" + idTaiNan, "Báo cáo khai báo tai nạn lao động");
    }

    danhSachNguyenNhanXayRa(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.baoCaoKhaiBaoTaiNanLaoDong.danhSachNguyenNhanXayRa, obj);
    }

    getThongTinCoSoOfBaoCao(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.baoCaoKhaiBaoTaiNanLaoDong.getThongTinCoSoOfBaoCao, obj);
    }

    // API báo cáo nhanh tai nạn lao động chết người
    timkiemBaoCaoNhanhTnldChetNguoi(obj): Observable<any> {
      return super.post(apiUrl.LDVL_HGI.baoCaoNhanhTnldChetNguoi.timkiemQuanLyNhanhTnldChetNguoi, obj);
    }

    danhMucGioiTinhBaoCao(obj): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.baoCaoNhanhTnldChetNguoi.danhMucGioiTinh, obj);
    }

    getThongTinCoSoChetNguoiBaoCao(obj): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.baoCaoNhanhTnldChetNguoi.getThongTinCoSoChetNguoi, obj);
    }

    danhSachNanNhanTaiNanByIdTaiNanBaoCao(obj): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.baoCaoNhanhTnldChetNguoi.danhSachNanNhanTaiNanByIdTaiNan, obj);
    }

    xuatBaoCaoNhanhTNLDChetNguoiByIdCoSoAndIdTaiNanBaoCao(id, idTaiNan): Observable<any> {
      return this._apiService.getBlobFile(apiUrl.LDVL_HGI.baoCaoNhanhTnldChetNguoi.xuatBaoCaoNhanhTNLDChetNguoiByIdCoSoAndIdTaiNan + "?id=" + id + "&idTaiNan=" + idTaiNan);
    }

    // API quản lý nhanh tai nạn lao động chết người
    timkiemQuanLyNhanhTnldChetNguoi(obj): Observable<any> {
      return super.post(apiUrl.LDVL_HGI.qlNhanhTnldChetNguoi.timkiemQuanLyNhanhTnldChetNguoi, obj);
    }

    danhMucGioiTinh(obj): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.qlNhanhTnldChetNguoi.danhMucGioiTinh, obj);
    }

    getThongTinCoSoChetNguoi(obj): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.qlNhanhTnldChetNguoi.getThongTinCoSoChetNguoi, obj);
    }

    danhSachThongTinCoSo(obj): Observable<any> {
      return super.post(apiUrl.LDVL_HGI.qlNhanhTnldChetNguoi.danhSachThongTinCoSo, obj);
    }

    danhSachNanNhanTaiNanByIdTaiNan(obj): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.qlNhanhTnldChetNguoi.danhSachNanNhanTaiNanByIdTaiNan, obj);
    }

     /**
      * @method POST
      * @param requestBody
      * @description Thêm tờ quản lý nhanh tai nạn lao động chết người
      */
     themMoiQuanLyNhanhTnldChetNguoi(requestBody){
      return super.post(apiUrl.LDVL_HGI.qlNhanhTnldChetNguoi.themMoiQuanLyNhanhTnldChetNguoi, requestBody);
    }

    /**
      * @method PUT
      * @param requestBody
      * @description Cập nhật tờ quản lý nhanh tai nạn lao động chết người
      */
    capNhatQuanLyNhanhTnldChetNguoi(requestBody){
      return super.put(apiUrl.LDVL_HGI.qlNhanhTnldChetNguoi.capNhatQuanLyNhanhTnldChetNguoi, requestBody);
    }

    /**
      * @method DELETE
      * @param requestParam
      * @description Xoá tờ quản lý nhanh tai nạn lao động chết người
      */
    xoaQuanLyNhanhTnldChetNguoi(id): Observable<any>{
      return super.delete(apiUrl.LDVL_HGI.qlNhanhTnldChetNguoi.xoaQuanLyNhanhTnldChetNguoi + "?id=" + id);
    }

    xuatBaoCaoNhanhTNLDChetNguoiByIdCoSoAndIdTaiNan(id, idTaiNan): Observable<any> {
      return this._apiService.getBlobFile(apiUrl.LDVL_HGI.qlNhanhTnldChetNguoi.xuatBaoCaoNhanhTNLDChetNguoiByIdCoSoAndIdTaiNan + "?id=" + id + "&idTaiNan=" + idTaiNan);
    }

    // API quản lý sổ thống kê tai nạn lao động
    timkiemQLSoTnld(obj) {
      return super.post(apiUrl.LDVL_HGI.quanLySoTKTNLD.timkiemQLSoTnld, obj);
    }

    danhSachCoSo(id = null): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.quanLySoTKTNLD.danhSachCoSo+(id != null?"?id="+id:""));
    }

    danhSachNganh(): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.quanLySoTKTNLD.danhSachNganh);
    }

    danhSachNgheNghiep(): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.quanLySoTKTNLD.danhSachNgheNghiep);
    }

    danhSachLoaiChanThuong(): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.quanLySoTKTNLD.danhSachLoaiChanThuong);
    }

    /**
      * @method POST
      * @param requestBody
      * @description Thêm quản lý sổ thống kê tai nạn lao động
      */
     insertQLSoThongKeTNLD(requestBody){
      return super.post(apiUrl.LDVL_HGI.quanLySoTKTNLD.insertQLSoThongKeTNLD, requestBody);
    }

    /**
      * @method PUT
      * @param requestBody
      * @description Cập nhật quản lý sổ thống kê tai nạn lao động
      */
    updateQLSoThongKeTNLD(requestBody){
      return super.put(apiUrl.LDVL_HGI.quanLySoTKTNLD.updateQLSoThongKeTNLD, requestBody);
    }

    /**
      * @method DELETE
      * @param requestParam
      * @description Xoá quản lý sổ thống kê tai nạn lao động
      */
    deleteQLSoThongKeTNLD(id): Observable<any>{
      return super.delete(apiUrl.LDVL_HGI.quanLySoTKTNLD.deleteQLSoThongKeTNLD + "?id=" + id);
    }

    xuatBaoCaoQLTKTNLD(nam, id_co_so, ho_va_ten, isExcel): Observable<any> {
      return super.downloadFile(apiUrl.LDVL_HGI.quanLySoTKTNLD.xuatBaoCaoQLTKTNLD + "?nam=" + nam + "&id_co_so=" + id_co_so + "&ho_va_ten=" + ho_va_ten + "&isExcel=" +isExcel, "Báo cáo quản lý sổ thống kê tai nạn lao động");
    }

    // API quản lý tình hình sử dụng người lao động nước ngoài
    searchQuanLyTinhHinhSDNguoiLDNN(obj): Observable<any> {
      return super.post(apiUrl.LDVL_HGI.quanLyTinhHinhSdNguoiLdNuocNgoai.searchQuanLyTinhHinhSDNguoiLDNN, obj);
    }

    getThongTinDn(id): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.quanLyTinhHinhSdNguoiLdNuocNgoai.getThongTinDn + "?id=" + id);
    }

    getThongTinBaoCaoChiTiet(id): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.quanLyTinhHinhSdNguoiLdNuocNgoai.getThongTinBaoCaoChiTiet + "?id=" + id);
    }

    uploadFileQuanLyTinhHinhSDNguoiLDNN(file): Observable<any> {
      const token = localStorage.getItem('access_token');
      let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

          const formData = new FormData();
          formData.append('file', file);
      return this.http.post(apiUrl.LDVL_HGI.quanLyTinhHinhSdNguoiLdNuocNgoai.uploadFile, formData, {headers});
      }

    downloadFileQuanLyTinhHinhSDNguoiLDNN(fileId, fileName){
      return super.downloadFile(apiUrl.LDVL_HGI.quanLyTinhHinhSdNguoiLdNuocNgoai.downloadFile + "/" + fileId, fileName);
    }

    exportFileQuanLyTinhHinhSDNguoiLDNN_ROOT(id,typeFile){
      if(typeFile === 1){
        return super.downloadFile(apiUrl.LDVL_HGI.quanLyTinhHinhSdNguoiLdNuocNgoai.exportFile + "?id=" + id + "&isExcel=" +typeFile, 'Bao-cao-tinh-hinh-su-dung-lao-dong-nguoi-nuoc-ngoai.xlsx');
      }
      return super.downloadFile(apiUrl.LDVL_HGI.quanLyTinhHinhSdNguoiLdNuocNgoai.exportFile + "?id=" + id + "&isExcel=" +typeFile, 'Bao-cao-tinh-hinh-su-dung-lao-dong-nguoi-nuoc-ngoai.pdf');
    }

    /**
      * @method POST
      * @param requestBody
      * @description Thêm quản lý tình hình sử dụng người lao động nước ngoài
      */
    createQuanLyTinhHinhSDNguoiLDNN(requestBody){
      return super.post(apiUrl.LDVL_HGI.quanLyTinhHinhSdNguoiLdNuocNgoai.createQuanLyTinhHinhSDNguoiLDNN, requestBody);
    }

    /**
    * @method PUT
    * @param requestBody
    * @description Cập nhật quản lý tình hình sử dụng người lao động nước ngoài
    */
    updateQuanLyTinhHinhSDNguoiLDNN(requestBody){
      return super.put(apiUrl.LDVL_HGI.quanLyTinhHinhSdNguoiLdNuocNgoai.updateQuanLyTinhHinhSDNguoiLDNN, requestBody);
    }

    /**
    * @method DELETE
    * @param requestParam
    * @description Xoá quản lý tình hình sử dụng người lao động nước ngoài
    */
    deleteQuanLyTinhHinhSDNguoiLDNN(id): Observable<any>{
      return super.post(apiUrl.LDVL_HGI.quanLyTinhHinhSdNguoiLdNuocNgoai.deleteQuanLyTinhHinhSDNguoiLDNN + "?id=" + id);
    }

    /**
      * @method POST
      * @param requestParam
      * @description Cập nhật trạng thái xác nhận quản lý tình hình sử dụng người lao động nước ngoài
      */
    setTrangThaiXacNhan(id, status, lyDoTuChoi): Observable<any>{
      lyDoTuChoi = lyDoTuChoi == null ? '' : lyDoTuChoi;
      return super.post(apiUrl.LDVL_HGI.quanLyTinhHinhSdNguoiLdNuocNgoai.setTrangThaiXacNhan + "?id=" + id + "&status=" + status + "&lyDoTuChoi=" + lyDoTuChoi);
    }

    // API BÁO CÁO TÌNH HÌNH SỬ DỤNG NGƯỜI LAO ĐỘNG NƯỚC NGOÀI
    xuatBaoCaoQuanLyTinhHinhSDNguoiLDNN(idCoSo, nam, ky): Observable<any> {
      return this._apiService.getBlobFile(apiUrl.LDVL_HGI.baoCaoQuanLyThSdNldNuocNgoai.searchBcQuanLyTinhHinhSDNguoiLDNN + "?idCoSo=" + idCoSo + "&nam=" + nam + "&ky=" + ky + "&isExcel=" + 0);
    }

    taiBaoCaoQuanLyTinhHinhSDNguoiLDNN(idCoSo, nam, ky): Observable<any> {
      return super.downloadFile(apiUrl.LDVL_HGI.baoCaoQuanLyThSdNldNuocNgoai.searchBcQuanLyTinhHinhSDNguoiLDNN + "?idCoSo=" + idCoSo + "&nam=" + nam + "&ky=" + ky + "&isExcel=" + 0, 'Bao-cao-tinh-hinh-su-dung-lao-dong-nguoi-nuoc-ngoai.pdf')
    }

    // API QUẢN LÝ TÌNH HÌNH NGƯỜI LAO ĐỘNG NƯỚC NGOÀI
    searchQuanLyTinhHinhNguoiLDNN(obj): Observable<any>{
      return super.post(apiUrl.LDVL_HGI.quanLyTinhHinhNguoiLdNuocNgoai.searchQuanLyTinhHinhNguoiLDNN, obj);
    }

    listQuocTich(obj): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.quanLyTinhHinhNguoiLdNuocNgoai.listQuocTich + "?kv=" + obj);
    }

    getSoLieuTongHopQuanLyTinhHinhSdNguoiLDNN(obj): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.quanLyTinhHinhNguoiLdNuocNgoai.getSoLieuTongHopQuanLyTinhHinhSdNguoiLDNN, obj);
    }

    getChiTietQuanLyTinhHinhNguoiLDNN(id): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.quanLyTinhHinhNguoiLdNuocNgoai.getChiTietQuanLyTinhHinhNguoiLDNN + "?id=" + id);
    }

    exportFileQuanLyTinhHinhSDNguoiLDNN(id, tenTinhThanh, typeFile){
      if(typeFile === 1){
        return super.downloadFile(apiUrl.LDVL_HGI.quanLyTinhHinhNguoiLdNuocNgoai.exportFileQuanLyTinhHinhSDNguoiLDNN + "?id=" + id + "&tenTinhThanh=" + tenTinhThanh + "&isExcel=" + typeFile, 'Bao-cao-tinh-hinh-nguoi-lao-dong-nuoc-ngoai.xlsx');
      }
        return super.downloadFile(apiUrl.LDVL_HGI.quanLyTinhHinhNguoiLdNuocNgoai.exportFileQuanLyTinhHinhSDNguoiLDNN + "?id=" + id + "&tenTinhThanh=" + tenTinhThanh + "&isExcel=" + typeFile, 'Bao-cao-tinh-hinh-nguoi-lao-dong-nuoc-ngoai.pdf');
    }

    /**
    * @method POST
    * @param requestBody
    * @description Thêm quản lý tình hình người lao động nước ngoài
    */
    createQuanLyTinhHinhNguoiLDNN(requestBody){
      return super.post(apiUrl.LDVL_HGI.quanLyTinhHinhNguoiLdNuocNgoai.createQuanLyTinhHinhNguoiLDNN, requestBody);
    }

    /**
    * @method PUT
    * @param requestBody
    * @description Cập nhật quản lý tình hình người lao động nước ngoài
    */
    updateQuanLyTinhHinhNguoiLDNN(requestBody){
      return super.put(apiUrl.LDVL_HGI.quanLyTinhHinhNguoiLdNuocNgoai.updateQuanLyTinhHinhNguoiLDNN, requestBody);
    }

    /**
      * @method DELETE
      * @param requestParam
      * @description Xoá quản lý tình hình người lao động nước ngoài
      */
    deleteQuanLyTinhHinhNguoiLDNN(id): Observable<any>{
      return super.post(apiUrl.LDVL_HGI.quanLyTinhHinhNguoiLdNuocNgoai.deleteQuanLyTinhHinhNguoiLDNN + "?id=" + id);
    }

    setDisabled(danhMuc, idName, id, rows, idNameRow) {
      let item = danhMuc.find(p => p[idName] == id);
      if (item) {
        item.isDisable = true;
        let tmp = [];
        if (rows.value.length != 0) {
          rows.value.forEach(item => {
            if (item[idNameRow] != null && item[idNameRow] != "") tmp.push(item[idNameRow]);
          })
        }
        this.setViewDisable(danhMuc, tmp, idName);
        return danhMuc;
      }
    }
    resetDisabled(danhMuc) {
      danhMuc.forEach(item => {
        item.isDisable = false;
      });
    }

    setViewDisable(danhMuc, tmp, id) {
      danhMuc.forEach(item => {
        item.isDisable = (tmp.includes(item[id])) ? true : false;
      });
      return danhMuc;
    }

    setEable(danhMuc, idName, id, rows, idNameRow) {
      let item = danhMuc.find(p => p[idName] == id);
      if (item) {
        item.isDisable = false;
        let tmp = [];
        if (rows.value.length != 0) {
          rows.value.forEach(item => {
            if (item[idNameRow] != null && item[idNameRow] != "") tmp.push(item[idNameRow]);
          })
        }
        this.setViewDisable(danhMuc, tmp, idName);
        return danhMuc;
      }
    }

    // API BÁO CÁO TÌNH HÌNH NGƯỜI LAO ĐỘNG NƯỚC NGOÀI
    xuatBaoCaoQuanLyTinhHinhNguoiLDNN(nam, ky, tenTinhThanh): Observable<any> {
      return this._apiService.getBlobFile(apiUrl.LDVL_HGI.baoCaoQuanLyThNldNuocNgoai.searchBcQuanLyTinhHinhNguoiLDNN + "?nam=" + nam + "&ky=" + ky + "&tenTinhThanh=" + tenTinhThanh + "&isExcel=" + 0);
    }

    taiBaoCaoQuanLyTinhHinhNguoiLDNN(nam, ky, tenTinhThanh): Observable<any> {
      return super.downloadFile(apiUrl.LDVL_HGI.baoCaoQuanLyThNldNuocNgoai.searchBcQuanLyTinhHinhNguoiLDNN + "?nam=" + nam + "&ky=" + ky + "&tenTinhThanh=" + tenTinhThanh + "&isExcel=" + 0, 'Bao-cao-tinh-hinh-su-dung-lao-dong-nguoi-nuoc-ngoai.pdf')
    }

    // API TÌNH HÌNH TUYỂN DỤNG SỬ DỤNG NGƯỜI LAO ĐỘNG VIỆT NAM
    timkiemTinhHinhTuyenDungSuDungNldVn(obj){
      return super.post(apiUrl.LDVL_HGI.tinhHinhTuyenDungSuDungNldVn.timKiem, obj);
    }

    themMoiTinhHinhTuyenDungSuDungNldVn(obj){
      return super.post(apiUrl.LDVL_HGI.tinhHinhTuyenDungSuDungNldVn.themMoi, obj);
    }

    capNhatTinhHinhTuyenDungSuDungNldVn(obj){
      return super.put(apiUrl.LDVL_HGI.tinhHinhTuyenDungSuDungNldVn.capNhat, obj);
    }

    xoaTinhHinhTuyenDungSuDungNldVn(id){
      return super.post(apiUrl.LDVL_HGI.tinhHinhTuyenDungSuDungNldVn.xoa +"?id="+ id);
    }

    capNhatTrangThaiTinhHinhTuyenDungSuDungNldVn(id, status, lyDoTuChoi){
      lyDoTuChoi = lyDoTuChoi == null ? '' : lyDoTuChoi;
      return super.post(apiUrl.LDVL_HGI.tinhHinhTuyenDungSuDungNldVn.capNhatTrangThai+ "?id=" + id + "&status=" + status + "&lyDoTuChoi=" + lyDoTuChoi);
    }
    // API BÁO CÁO QUẢN LÝ TÌNH HÌNH TUYỂN DỤNG SỬ DỤNG NGƯỜI LAO ĐỘNG VIỆT NAM
    xuatBaoCaoTinhHinhTuyenDungSuDungNldVn(id = null, tinh = null, isExcel = false, nam = null, idCoSo = null, isWord = false){
      let url = apiUrl.LDVL_HGI.tinhHinhTuyenDungSuDungNldVn.xuatBaoCao + "?tinh="+tinh;
      if(id) url=url+"&id=" + id;
      if(isExcel) url=url+"&isExcel=" + isExcel;
      if(nam) url=url+"&nam=" + nam;
      if(idCoSo) url=url+"&idCoSo=" + idCoSo;
      if(isWord) url=url+"&isWord=" + isWord;
      if(isWord){
        return super.downloadFile(url, 'Bao-cao-tinh-hinh-td-ds-nld-vn.docx');
      }else{
        return super.downloadFile(url, 'Bao-cao-tinh-hinh-td-ds-nld-vn.pdf');
      }
    }
    xuatBaoCaoTinhHinhTuyenDungSuDungNldVn_view(id = null, tinh = null, isExcel = false, nam = null, idCoSo = null, isWord = false): Observable<any> {
        let url = apiUrl.LDVL_HGI.tinhHinhTuyenDungSuDungNldVn.xuatBaoCao + "?tinh="+tinh;
        if(id) url=url+"&id=" + id;
        if(isExcel) url=url+"&isExcel=" + isExcel;
        if(nam) url=url+"&nam=" + nam;
        if(idCoSo) url=url+"&idCoSo=" + idCoSo;
        if(isWord) url=url+"&isWord=" + isWord;
      return this._apiService.getBlobFile(url);
    }
    checkReportTinhHinhTuyenDungSDNLDVN(nam, idCoSo) {
      return super.get(apiUrl.LDVL_HGI.tinhHinhTuyenDungSuDungNldVn.checkReport, { nam: nam, idCoSo: idCoSo });
    }
    dsChitTiet(id) {
      return super.get(apiUrl.LDVL_HGI.tinhHinhTuyenDungSuDungNldVn.dsChiTiet, { id: id });
    }

    // API BÁO CÁO QUẢN LÝ TÌNH HÌNH CUNG ỨNG THUÊ LẠI LAO ĐỘNG VIỆT NAM
    xuatBaoCaoQuanLyTinhHinhCungUngTlLdvn(nam): Observable<any> {
      return this._apiService.getBlobFile(apiUrl.LDVL.laoDongVnLamViecChoTCCNNuocNgoaiTaiVN.xuatBaoCaoTinhHinhCungUngLD + "?nam=" + nam + "&reportType=" + 1);
    }

    taiBaoCaoQuanLyTinhHinhCungUngTlLdvn(nam): Observable<any> {
      return super.downloadFile(apiUrl.LDVL.laoDongVnLamViecChoTCCNNuocNgoaiTaiVN.xuatBaoCaoTinhHinhCungUngLD + "?nam=" + nam + "&reportType=" + 0, 'Bao-cao-ql-th-cung-ung-thue-lai-ldvn.docx')
    }

    //End HGI

    //QLDN  - SRS15_16
    dmDungChung_QLDN(code) {
        return super.get(apiUrl.LDVL.danhMuc.dmDungChung_ViecLam + "?codeDM=" + code);
    }


    themMoiDoanhNghiep(requestBody) {
        return super.post(apiUrl.LDVL.QLdoanhNghiep.themDoanhNghiep, requestBody);
    }

    suaDoanhNghiep(requestBody) {
        return super.put(apiUrl.LDVL.QLdoanhNghiep.capNhatDoanhNghiep, requestBody);
    }

    getTTDoanhNghiepbyID(id) {
        return super.get(apiUrl.LDVL.QLdoanhNghiep.dsDoanhNghiep + "/" + Number(id));
    }

    downFileGPKD(id, nameFile) {
        return super.downloadFile(apiUrl.LDVL.QLdoanhNghiep.downFileGPKD + "/" + id, nameFile);
    }

    layIDFileGPKD(file): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

        const formData = new FormData();
        formData.append('file', file);
        return this.http.post(apiUrl.LDVL.QLdoanhNghiep.layIDFileGPKD, formData, { headers });
    }
    //end SRS15_16
    getTrangThai2Cap(): Observable<any> {
        return super.get(apiUrl.LDVL.TNLD.getTrangThai2Cap);
    }

    getThongTinhDoanhNghiep(id): Observable<any> {
        return super.get(apiUrl.LDVL.TNLD.getThongTinDoanhNghiep + "?id=" + id);
    }

    getDMYeuTo() {
        return super.get(apiUrl.LDVL.TNLD.getDMYeuToGayChanThuong);
    }

    getDMNguyenNhan() {
        return super.get(apiUrl.LDVL.TNLD.getDMNguyenNhanChiTiet);
    }

    getDMNganhKinhTe() {
        return super.get(apiUrl.LDVL.TNLD.getDMNganhKinhTe);
    }

    getDSCoSo(obj) {
        let str = "?tinh=" + obj["tinh"];
        if (obj["huyen"] != null) str = str + "&huyen=" + obj["huyen"];
        if (obj["xa"] != null) str = str + "&xa=" + obj["xa"];
        return super.get(apiUrl.LDVL.TNLD.getDSCoSo + str);
    }
    getDSLoaiHinhCoSo() {
        return super.get(apiUrl.LDVL.TNLD.getDSLoaiHinhCoSo);
    }

    getDSLinhVuc() {
        return super.get(apiUrl.LDVL.TNLD.getDSLinhVuc);
    }

    getTongHopTinhHinhTNLD(nam, ky, id, loai) {
        return super.get(apiUrl.LDVL.TNLD.getTongHopTinhHinhTNLD + "?nam=" + nam + "&kyBaoCao=" + ky + "&idCoSo=" + id + "&loai=" + loai);
    }

    getTongHopThietHaiTNLD(nam, ky, id, loai) {
        return super.get(apiUrl.LDVL.TNLD.getTongHopThietHaiTNLD + "?nam=" + nam + "&kyBaoCao=" + ky + "&idCoSo=" + id + "&loai=" + loai);
    }

    themTongHopTinhHinhLaoDongCapCoSo(requestBody) {
        return super.post(apiUrl.LDVL.TNLD.themTongHopTinhHinhLaoDongCapCoSo, requestBody);
    }

    getQuanLyTongHopTinhHinhTNLD(obj) {
        return super.get(apiUrl.LDVL.TNLD.getQuanLyTongHopTinhHinhTNLDCapCoSo, obj);
    }

    updateTrangThaiQuanLyTongHopTinhHinhTNLDCpaCoSo(idTongHop, trangThai, lyDoTuChoi) {
        return super.post(apiUrl.LDVL.TNLD.updateQuanLyTongHopTinhHinhTNLDCapCoSo + "?idTongHop=" + idTongHop + "&trangThai=" + trangThai + "&lyDoTuChoi=" + lyDoTuChoi);
    }

    deleteQuanLyTongHopTinhHinhTNLDCpaCoSo(idTongHop, username) {
        return super.post(apiUrl.LDVL.TNLD.deleteQuanLyTongHopTinhHinhTNLDCapCoSo + "?idTongHop=" + idTongHop + "&username=" + username);
    }

    getChiTietQuanLyTongHopTinhHinhTNLD(idTongHop) {
        return super.get(apiUrl.LDVL.TNLD.getChiTietQuanLyTongHopTinhHinhTNLDCapCoSo + "?idTongHop=" + idTongHop);
    }

    capNhatTongHopTinhHinhLaoDongCapCoSo(requestBody) {
        return super.post(apiUrl.LDVL.TNLD.capNhatTongHopTinhHinhLaoDongCapCoSo, requestBody);
    }

    getDMNgheNghiepTongHop() {
        return super.get(apiUrl.LDVL.TNLD.getDMNgheNghiepTongHop);
    }


    //SRS_17_18//
    dsDoanhNghiepChoThueLaiLD(body) {
        return super.post(apiUrl.LDVL.QLdoanhNghiepChoThueLaiLD.dsDoanhNghiep, body);
    }

    themMoiDoanhNghiepChoThueLaiLD(requestBody) {
        return super.post(apiUrl.LDVL.QLdoanhNghiepChoThueLaiLD.themDoanhNghiep, requestBody);
    }

    suaDoanhNghiepChoThueLaiLD(requestBody) {
    return super.put(apiUrl.LDVL.QLdoanhNghiepChoThueLaiLD.suaDoanhNghiep, requestBody);
    }

    getTTDoanhNghiepChoThueLaiLDbyID(id) {
        return super.get(apiUrl.LDVL.QLdoanhNghiepChoThueLaiLD.dsDoanhNghiep + "/" + Number(id));
    }

    layGPKDChoThueLaiLDbyID(id) {
        return super.get(apiUrl.LDVL.QLdoanhNghiepChoThueLaiLD.layGPKD + "?idCoSo=" + id + "&PAGENUMBER=0&PAGESIZE=100");
    }

    downFileGPKDChoThueLaiLD(id, nameFile) {
        return super.downloadFile(apiUrl.LDVL.QLdoanhNghiepChoThueLaiLD.downFileGPKD + "/" + id, nameFile);
    }

    layIDFileGPKDChoThueLaiLD(file): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post(apiUrl.LDVL.QLdoanhNghiepChoThueLaiLD.layIDFileGPKD, formData, {headers});
    }

    xoaDoanhNghiepChoThueLaiLD(id, trangThai) {
        return super.delete(apiUrl.LDVL.QLdoanhNghiepChoThueLaiLD.xoaDoanhNghiep, { id: id, trangThai: trangThai });
    }
    xuatDSDoanhNghiepChoThueLaiLD(requestBody, nameFile) {
        return super.downloadFile(apiUrl.LDVL.QLdoanhNghiepChoThueLaiLD.downFileDanhSach, nameFile, requestBody);
    }
    //end SRS_17_18//
    //SRS_45
    getTNLDNguoiLDKhongHopDongTongHop(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.TNLD_TONG_HOP.getTNLDNguoiLDKhongHopDongTongHop, obj);
    }

    getTNLDNguoiLDKhongHopDongChiTietTH(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.TNLD_TONG_HOP.getTNLDNguoiLDKhongHopDongChiTiet, obj);
    }

    getTNLDNguoiLDKhongHopDongTongHopChiTiet(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.TNLD_TONG_HOP.getTNLDNguoiLDKhongHopDongTongHopChiTiet, obj);
    }

    deleteTNLDNguoiLDKhongHopDongTongHop(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.TNLD_TONG_HOP.deleteTNLDNguoiLDKhongHopDongTongHop, obj);
    }

    insertTNLDNguoiLDKhongHopDongTongHop(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.TNLD_TONG_HOP.insertTNLDNguoiLDKhongHopDongTongHop, obj);
    }

    upsertTNLDNguoiLDKhongHopDongTongHop(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.TNLD_TONG_HOP.upsertTNLDNguoiLDKhongHopDongTongHop, obj);
    }

    inbaocaoTNLDNguoiLDKhongHDLD_PDF_TongHop(maTinh, nam,kyBC,type): Observable<any>{
        let str="?maTinh="+maTinh;
        if(nam!=null) str=str+"&nam="+nam;
        if(kyBC!=null) str=str+"&kyBaoCao="+kyBC;
        str=str+"&reportType="+type;
        return this._apiService.getBlobFile(apiUrl.LDVL_HGI.TNLD_TONG_HOP.inbaocaoTNLDNguoiLDKhongHDLDTongHop+str);
    }
    //end SRS_45//
    //SRS_79//
    baocaoThongKeNguoiLDNuocNgoaiTaiVN(nam,type): Observable<any>{
        if(type == 1){
            let str="";
            if(nam!=null) str=str+"?nam="+nam;
            str=str+"&reportType="+type;
            return this._apiService.getBlobFile(apiUrl.LDVL_HGI.baoCaoThongKeNguoiLDNuocNgoaiTaiVietNam+str);
        }else{
            return super.downloadFile(apiUrl.LDVL_HGI.baoCaoThongKeNguoiLDNuocNgoaiTaiVietNam + "?nam=" + nam +"&reportType=" + type, "Báo cáo thống kê người LDNN làm việc tại VN được cấp phép");
        }
    }
    //end SRS_79
    // getQuocTichNguoiLaoDong() {
    //     return super.get(apiUrl.LDVL_HGI.danhMucNguoiLaoDong.danhMucQuocTich);
    // }
    getListDanhSachNguoiLaoDong(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.danhMucNguoiLaoDong.timKiem, obj);
    }
    getDanhMucViTriCongViec() {
        return super.get(apiUrl.LDVL_HGI.danhMucNguoiLaoDong.danhMucViTriCongViec);
    }
    getDanhMucHopDonglaoDong() {
        return super.get(apiUrl.LDVL_HGI.danhMucNguoiLaoDong.danhMucHopDongLaoDong);
    }
    getDanhMucQuocTich() {
        return super.get(apiUrl.LDVL_HGI.danhMucNguoiLaoDong.danhMucQuocTich);
    }
    getDanhMucDanToc() {
        return super.get(apiUrl.LDVL_HGI.danhMucNguoiLaoDong.danhMucDanToc);
    }
    getDanhMucGioiTinh() {
        return super.get(apiUrl.LDVL_HGI.danhMucNguoiLaoDong.danhMucGioiTinh);
    }
    getDanhMucTrinhDoChuyenMon() {
        return super.get(apiUrl.LDVL_HGI.danhMucNguoiLaoDong.danhMucTrinhDoChuyenMon);
    }
    getDanhMucLyDoNghi() {
        return super.get(apiUrl.LDVL_HGI.danhMucNguoiLaoDong.danhMucLyDoNghi);
    }
    addDanhSachNguoiLaoDong(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.danhMucNguoiLaoDong.themMoi, obj);
    }
    updateDanhSachNguoiLaoDong(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.danhMucNguoiLaoDong.capNhat, obj);
    }

    deleteDanhSachNguoiLaoDong(idDoiTuong): Observable<any> {
        return super.delete(apiUrl.LDVL_HGI.danhMucNguoiLaoDong.xoa, {idDtHuongBHTN: idDoiTuong});
    }
    getFileSampleDanhSachNguoiLaoDong(filename: string): Observable<any> {
        return super.downloadFile(apiUrl.LDVL_HGI.danhMucNguoiLaoDong.getSampleFileDanhSachNguoiLaoDong, filename);
    }

    uploadFileImportDSNLD(file, idCoSo): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

        let api = apiUrl.LDVL_HGI.danhMucNguoiLaoDong.importDanhSachNguoiLaoDong + "?idCoSo=" + idCoSo;

        return this.http.post(api, file, { reportProgress: true, headers });
    }
    xuatBCLaoDongTaiDiaPhuong(maTinh, maXa, nam): Observable<any>{
        let str="?tinh="+maTinh;
        if(maXa!='null') str=str+"&xa="+maXa;
        if(nam!=null) str=str+"&nam="+nam;

        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: this._apiService.getJsonHeaders()
        };
        return this.http.get(apiUrl.LDVL_HGI.thongKeLaoDongTaiDiaPhuongV2.xuatBaoCaoThongKeLaoDongTaiDiaPhuong+str,requestOptions);
    }
    // AGG Người tìm việc
    getListNguoiTimViec(obj):Observable<any> {
        return super.post(apiUrl.AGG_NGUOITIMVIEC.getDanhSachNguoiTimViec, obj);
    }
    getChiTietNguoiTimViec(id): Observable<any> {
        return super.get(apiUrl.AGG_NGUOITIMVIEC.getDanhSachChiTietNguoiTimViec + "?id=" +id);
    }
    updateDanhSachNguoiTimViec(requestBody) {
        return super.put(apiUrl.AGG_NGUOITIMVIEC.capNhatDanhSachNguoiTimViec, requestBody);
    }
    downloadTemplateImportHsNguoiTimViec(filename){
        return super.downloadFile(apiUrl.AGG_NGUOITIMVIEC.exportSampleFile, filename);
      }
    uploadFileImportQlNguoiTimViec(obj,file): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');
        const formData = new FormData();
        formData.append("thang", obj.thang);
        formData.append("nam", obj.nam);
        formData.append("file", obj.file);
        let api = apiUrl.AGG_NGUOITIMVIEC.ImportDataFromExcelDanhSachNguoiTimViec;
        if(obj.nam != null && obj.nam != "null") {
          api += "?nam=" + obj.nam;
        }
        if(obj.thang != null && obj.thang != "null") {
          api += "&thang=" + obj.thang;
        }
        return this.http.post(api, file, { reportProgress: true, headers });
    }
    deleteDanhSachNguoiTimViec(id, trang_thai_xoa): Observable<any> {
        return super.delete(apiUrl.AGG_NGUOITIMVIEC.deleteDanhSachNguoiTimViec + "?id=" + id + "&trang_thai_xoa=" + trang_thai_xoa);
    }
    themDanhSachNguoiTimViec(requestBody) {
        return super.post(apiUrl.AGG_NGUOITIMVIEC.themDanhSachNguoiTimViec, requestBody);
    }

    // IT5ASXH-14279
    addOrUpdateQLTinhHinhHoatDongDVVL(obj){
        return super.post(apiUrl.LDVL.DVVL.addOrUpdateQLTinhHinhHoatDongDVVL,obj);
    }

    timKiemQLTinhHinhHoatDongDVVL(obj){
        return super.get(apiUrl.LDVL.DVVL.timKiemQLTinhHinhHoatDongDVVL,obj);
    }

    xoaQLTinhHinhHoatDongDVVL(id){
        return super.delete(apiUrl.LDVL.DVVL.xoaQLTinhHinhHoatDongDVVL+"?id="+id);
    }

    capnhatTrangThaiQLTinhHinhHoatDongDVVL(id,trangThai,lyDoTuChoi){
        return super.post(apiUrl.LDVL.DVVL.capnhatTrangThaiQLTinhHinhHoatDongDVVL+"?id="+id+"&trangThai="+trangThai+"&lyDoTuChoi="+lyDoTuChoi);
    }

    downloadQLTinhHinhHoatDongDVVL(){
        return super.downloadFile(apiUrl.LDVL.DVVL.downloadMauQLTinhHinhHoatDongDVVL,"Mẫu quản lý tình hình hoạt động dịch vụ việc làm.xlsx");
    }

    importQLTinhHinhHoatDongDVVL(file){
        let api = apiUrl.LDVL.DVVL.importQLTinhHinhHoatDongDVVL;
        return super.post(api,file);

    }

    // End IT5ASXH-14279
    /**
     *
     * @description Thống kê tổ chức GTVL được cấp phép HGI
     * @returns
     */
    getAllThongKeToChucGTVLDuocCapPhep(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.thongKeToChucGTVLDuocCapPhep.timKiemThongKeToChucGTVLDuocCapPhep, obj);
    }
    getDetailThongKeToChucGTVLDuocCapPhep(id) {
        return super.get(apiUrl.LDVL_HGI.thongKeToChucGTVLDuocCapPhep.chiTietThongKeToChucGTVLDuocCapPhep, { id: id});
    }

    addThongKeToChucGTVLDuocCapPhep(requestBody){
        return super.post(apiUrl.LDVL_HGI.thongKeToChucGTVLDuocCapPhep.themMoiThongKeToChucGTVLDuocCapPhep, requestBody);
    }

    updateThongKeToChucGTVLDuocCapPhep(requestBody){
        return super.put(apiUrl.LDVL_HGI.thongKeToChucGTVLDuocCapPhep.capNhatThongKeToChucGTVLDuocCapPhep, requestBody);
    }

    deleteThongKeToChucGTVLDuocCapPhep(id) {
        return super.delete(apiUrl.LDVL_HGI.thongKeToChucGTVLDuocCapPhep.xoaThongKeToChucGTVLDuocCapPhep, {id:id});
    }

    getBCThongKeToChucGTVLDuocCapPhep(id, reportType): Observable<any>{
        if(reportType == 1){

            let requestOptions = {
                responseType: 'blob' as 'json',
                headers: this._apiService.getJsonHeaders()
            };
            return this.http.get(apiUrl.LDVL_HGI.thongKeToChucGTVLDuocCapPhep.xuatBaoCaoThongKeToChucGTVLDuocCapPhep + "?id=" + id +"&reportType=" + reportType,requestOptions);
        }else{
            return super.downloadFile(apiUrl.LDVL_HGI.thongKeToChucGTVLDuocCapPhep.xuatBaoCaoThongKeToChucGTVLDuocCapPhep + "?id=" + id +"&reportType=" + reportType, "Báo cáo thống kê tổ chức giới thiệu việc làm được cấp phép");
        }

    }

    sendThongKeToChucGTVLDuocCapPhep(id) {
        return super.put(apiUrl.LDVL_HGI.thongKeToChucGTVLDuocCapPhep.GuiThongKeToChucGTVLDuocCapPhep + "?id=" + id);
    }

    getDSSoTheoDoi(requestParam):Observable<any> {
        return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getDSSoTheoDoi, requestParam);
    }

    getDSSoTheoDoiTheoNam(requestParam):Observable<any>{
        return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getDSSoTheoDoiTheoNam, requestParam);
    }

    getChiTietSoTheoDoiNguoiLaoDongNuocNgoai(requestParam):Observable<any>{
        return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getChiTietSoTheoDoiNguoiLaoDongNuocNgoai, requestParam);
    }

    updateSoTheoDoiNguoiLDNuocNgoai(requestParam):Observable<any>{
        return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.updateSoTheoDoiNguoiLDNuocNgoai, requestParam);
    }

    insertSoTheoDoiNguoiLDNuocNgoai(isAdd, tenSo, nam, ngayBC, requestBody):Observable<any>{
        return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.insertSoTheoDoiNguoiLDNuocNgoai + "?isAdd=" + isAdd + "&maSo=" + tenSo + "&nam=" + nam + "&ngayBC=" + ngayBC, requestBody);
    }

    xoaSoTheoDoi(requestParam):Observable<any>{
        return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.xoaSoTheoDoi + "?nam=" + requestParam);
    }

    xoaSoTheoDoiNguoiLDNuocNgoai(requestParam):Observable<any>{
        return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.xoaSoTheoDoiNguoiLDNuocNgoai + "?idSo=" + requestParam);
    }

    xuatBCSoTheoDoiNguoiLDNuocNgoai(nam, doanhNghiep, reportType):Observable<any>{
        let str = "?nam="+nam;
        if(doanhNghiep != null && doanhNghiep != "null" && doanhNghiep != 0) str+="&doanhNghiep=" + doanhNghiep;
        if(reportType == 1){
            return this._apiService.getBlobFile(apiUrl.LDVL.nguoiNNLVTaiVN.xuatBCSoTheoDoiNguoiLDNuocNgoai+str+"&reportType=" + reportType);
        }else{
            return super.downloadFile(apiUrl.LDVL.nguoiNNLVTaiVN.xuatBCSoTheoDoiNguoiLDNuocNgoai +str+"&reportType=" + reportType, "Quản lý tình hình người lao động nước ngoài");
        }
    }

    getDSCoSoLNNN(idTinh):Observable<any>{
        return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getDSCoSo + "?id=" + idTinh);
    }

    getDSGiayPhepLD(requestParam):Observable<any>{
        return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getDSGiayPhepLD, requestParam);
    }

    capGiayPhepLD(requestBody):Observable<any>{
        return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.capGiayPhepLD, requestBody);
    }

    getThongTinChiTietNguoiLD(requestParam):Observable<any>{
        return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getThongTinChiTietNguoiLD, requestParam);
    }

    getDSGiayPhepTheoIDNguoiLDPhanTrang(requestParam):Observable<any>{
        return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getDSGiayPhepTheoIDNguoiLDPhanTrang, requestParam);
    }

    capLaiGiayPhepLD(requestBody):Observable<any>{
        return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.capLaiGiayPhepLD, requestBody);
    }

    getChiTietGiayPhepById(requestParam):Observable<any>{
        return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getChiTietGiayPhepById, requestParam);
    }

    thuHoiGiayPhepById(requestParam):Observable<any>{
        return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.thuHoiGiayPhepById + "?idGP=" + requestParam);
    }

    xoaGiayPhepLaoDong(requestParam):Observable<any>{
        return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.xoaGiayPhepLaoDong + "?idGP=" + requestParam);
    }

    xoaThongTinNguoiLD(requestParam):Observable<any>{
        return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.xoaThongTinNguoiLD + "?idNLD=" + requestParam);
    }

    xuatGiayPhep(idGP, idCoSo, idQuocTich, search, trangThai, tinhTrang,type): Observable<any>{
        if(type == 1 || type == 2){
            let str="";
            if(idGP!=null) str=str+"?idGP="+idGP;
            str=str+"&reportType="+type;
            let requestOptions = {
                responseType: 'blob' as 'json',
                headers: this._apiService.getJsonHeaders()
            };
            return this.http.get(apiUrl.LDVL.nguoiNNLVTaiVN.xuatGiayPhep+str,requestOptions);
        }else{
            let str="";
            if(idCoSo!=null) str=str+"&idCoSo="+idCoSo;
            if(idQuocTich!=null) str=str+"&idQuocTich="+idQuocTich;
            if(search!=null && search != "") str=str+"&search="+search;
            if(trangThai!=null) str=str+"&trangThai="+trangThai;
            if(tinhTrang!=null) str=str+"&tinhTrang="+tinhTrang;
            return super.downloadFile(apiUrl.LDVL.nguoiNNLVTaiVN.xuatGiayPhep + "?reportType=" + type + str, "Danh sách giấy phép hết hạn và sắp hết hạn");
        }
    }


    uploadFileGiayPhep(payload: { file: File, fileName: string, fileUrl?: string, originalFilename?: string }, data: any): Observable<any> {
      const formData = new FormData();

      // Append file và các trường khác vào FormData
      formData.append('file', payload.file);
      formData.append('fileName', payload.fileName);
      if (payload.fileUrl) {
        formData.append('fileUrl', payload.fileUrl);
      }
      if (payload.originalFilename) {
        formData.append('originalFilename', payload.originalFilename);
      }

      // Tạo query string từ data
      const queryString = Object.entries(data)
        .filter(([key, value]) => value !== null)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
      const headers = new HttpHeaders({
        'Authorization': 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
        'Accept': 'application/json'
      });

      // Gửi yêu cầu POST với FormData
      return this.http.post(apiUrl.LDVL.nguoiNNLVTaiVN.uploadFileGiayPhep + "?" + queryString, formData, { headers });
    }

    downloadFileGiayPhep(fileID, name):Observable<any>{
      return super.downloadFile(apiUrl.LDVL.nguoiNNLVTaiVN.downloadFileGiayPhep + `/${fileID}`, name);
      // return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.downloadFileGiayPhep + `/${fileID}`);
    }
    getFileGiayPhep(fileID):Observable<any>{
      // return super.downloadFile(apiUrl.LDVL.nguoiNNLVTaiVN.downloadFileGiayPhep + `/${fileID}`, 'oke.pdf');
      return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getFileGiayPhep + `/${fileID}`);
    }

    getDSGiayPhepSapHetHan(requestParam):Observable<any>{
        return super.get(apiUrl.LDVL.nguoiNNLVTaiVN.getDSGiayPhepSapHetHan, requestParam);
    }

    getDSTinhHinhCungUngChoThueLai(requestParam): Observable<any>{
        return super.get(apiUrl.LDVL.laoDongVnLamViecChoTCCNNuocNgoaiTaiVN.getDSTinhHinhCungUngChoThueLai, requestParam);
    }

    getDSChiTietThongTinLDThueLai(requestParam): Observable<any>{
        return super.get(apiUrl.LDVL.laoDongVnLamViecChoTCCNNuocNgoaiTaiVN.getDSChiTietThongTinLDThueLai, requestParam);
    }

    addThongTinChoThueLD(requestBody): Observable<any>{
        return super.post(apiUrl.LDVL.laoDongVnLamViecChoTCCNNuocNgoaiTaiVN.addThongTinChoThueLD, requestBody);
    }

    capNhatThongTinChoThueLDChiTiet(requestBody): Observable<any>{
        return super.post(apiUrl.LDVL.laoDongVnLamViecChoTCCNNuocNgoaiTaiVN.capNhatThongTinChoThueLDChiTiet, requestBody);
    }

    capNhatTrangThaiThongTinCungUngLD(requestParam): Observable<any>{
        return super.post(apiUrl.LDVL.laoDongVnLamViecChoTCCNNuocNgoaiTaiVN.capNhatTrangThaiThongTinCungUngLD + "?nam=" + requestParam["nam"] + "&trangThai=" + requestParam["trangThai"] + "&lyDoTC=" + requestParam["lyDoTC"]);
    }

    xoaThongTinCungUngLD(requestParam): Observable<any>{
        return super.post(apiUrl.LDVL.laoDongVnLamViecChoTCCNNuocNgoaiTaiVN.xoaThongTinCungUngLD + "?nam=" + requestParam["nam"]);
    }

    xuatBaoCaoTinhHinhCungUngLD(reportType, nam): Observable<any>{
        if(reportType == 1){
            let requestOptions = {
                responseType: 'blob' as 'json',
                headers: this._apiService.getJsonHeaders()
            };
            return this.http.get(apiUrl.LDVL.laoDongVnLamViecChoTCCNNuocNgoaiTaiVN.xuatBaoCaoTinhHinhCungUngLD + "?reportType=" + reportType +"&nam=" + nam,requestOptions);
        }else{
            return super.downloadFile(apiUrl.LDVL.laoDongVnLamViecChoTCCNNuocNgoaiTaiVN.xuatBaoCaoTinhHinhCungUngLD + "?reportType=" + reportType +"&nam=" + nam, "Báo cáo tình hình cung ứng lao động thuê lại");
        }
    }
    checkReportTinhHinhCungUngLD(nam) {
      return super.get(apiUrl.LDVL.laoDongVnLamViecChoTCCNNuocNgoaiTaiVN.checkReport, { nam: nam});
    }

    //End HGI
    /**END */
    //SRS_30//
    dsChiTieu(body) {
        return super.post(apiUrl.LDVL.chiTieuGQVL_HGI.dsChiTieu, body);
    }

    danhMucKTHanhChinhSuNghiep() {
      return super.get(apiUrl.LDVL.QLdoanhNghiep.danhMucKTHanhChinhSuNghiep);
    }

    danhMucNganhNgheKinhTe() {
      return super.get(apiUrl.LDVL.QLdoanhNghiep.danhMucNganhNgheKinhTe);
    }

    dsDoanhNghiep(params) : Observable<any>{
        const filteredParams = Object.keys(params)
        .filter(key => params[key] !== null && params[key] !== undefined && params[key] !== '')
        .reduce((obj, key) => {
          obj[key] = params[key];
          return obj;
        }, {});
        return super.get(apiUrl.LDVL.QLdoanhNghiep.dsDoanhNghiep, filteredParams);
    }
    themMoiTaiKhoanDN(requestBody) {
        return super.post(apiUrl.LDVL.QLdoanhNghiep.theMoiTaiKhoanDN, requestBody);
    }
    themMoiTaiKhoanDNChoThueLaiLĐ(requestBody) {
      return super.post(apiUrl.LDVL.QLdoanhNghiep.themMoiTaiKhoanDNChoThueLaiLĐ, requestBody);
    }
    dsDoanhNghieplogin(params) : Observable<any>{
        const filteredParams = Object.keys(params)
        .filter(key => params[key] !== null && params[key] !== undefined && params[key] !== '')
        .reduce((obj, key) => {
          obj[key] = params[key];
          return obj;
        }, {});
        return super.get(apiUrl.LDVL.QLdoanhNghiep.dsDoanhNghiepLogin, filteredParams);
        // return this.http.get<any>(apiUrl.LDVL.QLdoanhNghiep.dsDoanhNghiepLogin, { params: filteredParams, headers: this.getHeader() });
    }
    capNhatDoanhNghiep(requestBody) {
        return super.put(apiUrl.LDVL.QLdoanhNghiep.capNhatDoanhNghiep, requestBody);
    }
    capNhatTaiKhoanDN(requestBody) {
        return super.put(apiUrl.LDVL.QLdoanhNghiep.capNhatTaiKhoanDN, requestBody);
    }

    themMoiChiTieu(requestBody) {
        return super.post(apiUrl.LDVL.chiTieuGQVL_HGI.themChiTieu, requestBody);
    }

    suaChiTieu(requestBody) {
        return super.put(apiUrl.LDVL.chiTieuGQVL_HGI.suaChiTieu, requestBody);
    }

    getTTChiTieubyID(id) {
        return super.get(apiUrl.LDVL.chiTieuGQVL_HGI.dsChiTieu + "/" + Number(id));
    }

    xoaChiTieu(id) {
        return super.delete(apiUrl.LDVL.chiTieuGQVL_HGI.xoaChiTieu, { id: id });
    }

    // Start Hgi code Tình hình sử dụng lao động và danh sách tham gia bhyt, bhtn, bhxh
    getTinhHinhSuDungLaoDong(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.QUAN_LY_TINH_HINH_SU_DUNG_LAO_DONG.getDuLieu, obj);
    }

    deleteTinhHinhSuDungLaoDong(obj): Observable<any> {
        return super.delete(apiUrl.LDVL_HGI.QUAN_LY_TINH_HINH_SU_DUNG_LAO_DONG.deletetDuLieu, obj);
    }

    getDuLieuChiTietTinhHinhSuDungLaoDong(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.QUAN_LY_TINH_HINH_SU_DUNG_LAO_DONG.getDuLieuChiTiet, obj);
    }

    getDuLieuThongTinDoanhnghiep(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.QUAN_LY_TINH_HINH_SU_DUNG_LAO_DONG.getDuLieuDoanhnghiep, obj);
    }

    themDuLieuChiTietTinhHinhSuDungLaoDong(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.QUAN_LY_TINH_HINH_SU_DUNG_LAO_DONG.themMoiDuLieu, obj);
    }

    getDuLieuChiTietUpdate(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.QUAN_LY_TINH_HINH_SU_DUNG_LAO_DONG.getDuLieuDoanhnghiepChiTietUpdate, obj);
    }

    updateDuLieuChiTietTinhHinhSuDungLaoDong(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.QUAN_LY_TINH_HINH_SU_DUNG_LAO_DONG.updateDuLieu, obj);
    }

    capNhatDuLieuChiTietTinhHinhSuDungLaoDong(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.QUAN_LY_TINH_HINH_SU_DUNG_LAO_DONG.capNhatMoiDuLieu, obj);
    }

    xuatBaoCaoTinhHinhSuDungLaoDong(idThld): Observable<any> {
      return this._apiService.getBlobFile(apiUrl.LDVL_HGI.QUAN_LY_TINH_HINH_SU_DUNG_LAO_DONG.xuatBaoCao + "?idThld=" + idThld + "&isExcel=" + 0);
    }

    xuatBaoCaoTinhHinhSuDungLaoDongSo(namBaoCao) {
        return this._apiService.getBlobFile(apiUrl.LDVL_HGI.QUAN_LY_TINH_HINH_SU_DUNG_LAO_DONG.xuatBaoCaoSo + "?namBaocao=" + namBaoCao + "&isExcel=" + 0);
    }

    xuatBaoCaoTinhHinhSuDungLaoDongSoWord(namBaoCao) {
        return super.downloadFile(apiUrl.LDVL_HGI.QUAN_LY_TINH_HINH_SU_DUNG_LAO_DONG.xuatBaoCaoSo + "?namBaocao=" + namBaoCao + "&isExcel=" + 1, "Bao-cao-quan_ly_danh_sach_nguoi_lao_dong.docx");
    }

    chotSoLieu(obj){
        return super.get(apiUrl.LDVL_HGI.QUAN_LY_TINH_HINH_SU_DUNG_LAO_DONG.chotSoLieu+ "?namBaocao=" + obj);
    }
    // End Hgi code Tình hình sử dụng lao động và danh sách tham gia bhyt, bhtn, bhxh
    // IT5ASXH-14346
    addOrUpdateQLKQHoatDongDVVL(obj){
        return super.post(apiUrl.LDVL.DVVL.addOrUpdateQLKQHoatDongDVVL,obj);
    }

    timKiemQLKQHoatDongDVVL(obj){
        return super.get(apiUrl.LDVL.DVVL.timKiemQLKQHoatDongDVVL,obj);
    }

    xoaQLKQHoatDongDVVL(id){
        return super.delete(apiUrl.LDVL.DVVL.xoaQLKQHoatDongDVVL+"?id="+id);
    }

    capnhatTrangThaiQLKQHoatDongDVVL(id,trangThai,lyDoTuChoi){
        return super.post(apiUrl.LDVL.DVVL.capnhatTrangThaiQLKQHoatDongDVVL+"?id="+id+"&trangThai="+trangThai+"&lyDoTuChoi="+lyDoTuChoi);
    }

    downloadQLKQHoatDongDVVL(){
        return super.downloadFile(apiUrl.LDVL.DVVL.downloadMauQLKQHoatDongDVVL,"Mẫu quản lý kết quả hoạt động dịch vụ việc làm.xlsx");
    }

    importQLKQHoatDongDVVL(file){
        let api = apiUrl.LDVL.DVVL.importQLKQHoatDongDVVL;
        return super.post(api,file);

    }
    // End IT5ASXH-14346
    xuatBCLaoDongThongKeToChucGTVLDuocCapPhep(maTinh, nam, reportType): Observable<any>{
        if(reportType == 1){
            let str="?tinh="+maTinh;
            if(nam!=null) str=str+"&nam="+nam;

            let requestOptions = {
                responseType: 'blob' as 'json',
                headers: this._apiService.getJsonHeaders()
            };
            return this.http.get(apiUrl.LDVL_HGI.baocaothongKeToChucGTVLDuocCapPhep.xuatBaoCaoThongKeToChucGTVLDuocCapPhepHoatDong+str+"&reportType=" + reportType,requestOptions);
        }else{
            return super.downloadFile(apiUrl.LDVL_HGI.baocaothongKeToChucGTVLDuocCapPhep.xuatBaoCaoThongKeToChucGTVLDuocCapPhepHoatDong + "?tinh=" + maTinh + "&nam=" + nam +"&reportType=" + reportType, "Báo cáo thống kê tổ chức giới thiệu việc làm được cấp phép");
        }

    }


    getAllThongKeSoNguoiHuongTroCapThatNghiep(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.thongKeSoNguoiHuongTroCapThatNghiep.timKiemThongKeSoNguoiHuongTroCapThatNghiep, obj);
    }

    getDetailThongKeSoNguoiHuongTroCapThatNghiep(id) {
        return super.get(apiUrl.LDVL_HGI.thongKeSoNguoiHuongTroCapThatNghiep.chiTietThongKeSoNguoiHuongTroCapThatNghiep, { id: id});
    }
    addThongKeSoNguoiHuongTroCapThatNghiep(requestBody){
        return super.post(apiUrl.LDVL_HGI.thongKeSoNguoiHuongTroCapThatNghiep.themMoiThongKeSoNguoiHuongTroCapThatNghiep, requestBody);
    }
    updateThongKeSoNguoiHuongTroCapThatNghiep(requestBody){
        return super.put(apiUrl.LDVL_HGI.thongKeSoNguoiHuongTroCapThatNghiep.capNhatThongKeSoNguoiHuongTroCapThatNghiep, requestBody);
    }
    deleteThongKeSoNguoiHuongTroCapThatNghiep(id) {
        return super.delete(apiUrl.LDVL_HGI.thongKeSoNguoiHuongTroCapThatNghiep.xoaThongKeSoNguoiHuongTroCapThatNghiep, {id:id});
    }

    getBCThongKeSoNguoiHuongTroCapThatNghiep(id, reportType): Observable<any>{
        if(reportType == 1){

            let requestOptions = {
                responseType: 'blob' as 'json',
                headers: this._apiService.getJsonHeaders()
            };
            return this.http.get(apiUrl.LDVL_HGI.thongKeSoNguoiHuongTroCapThatNghiep.xuatBaoCaoThongKeSoNguoiHuongTroCapThatNghiep + "?id=" + id +"&reportType=" + reportType,requestOptions);
        }else{
            return super.downloadFile(apiUrl.LDVL_HGI.thongKeSoNguoiHuongTroCapThatNghiep.xuatBaoCaoThongKeSoNguoiHuongTroCapThatNghiep + "?id=" + id +"&reportType=" + reportType, "Báo cáo thống kê số người hưởng trợ cấp thất nghiệp được hỗ trợ học nghề và tư vấn giới thiệu việc làm");
        }

    }

    guiThongKeSoNguoiHuongTroCapThatNghiep(id) {
        return super.put(apiUrl.LDVL_HGI.thongKeSoNguoiHuongTroCapThatNghiep.guiThongKeSoNguoiHuongTroCapThatNghiep + "?id=" + id);
    }

    duyetThongKeSoNguoiHuongTroCapThatNghiep(id) {
        return super.put(apiUrl.LDVL_HGI.thongKeSoNguoiHuongTroCapThatNghiep.duyetThongKeSoNguoiHuongTroCapThatNghiep + "?id=" + id);
    }
    tuChoiThongKeSoNguoiHuongTroCapThatNghiep(id,lydo) {
        return super.put(apiUrl.LDVL_HGI.thongKeSoNguoiHuongTroCapThatNghiep.tuChoiThongKeSoNguoiHuongTroCapThatNghiep + "?id=" + id +"&lyDo=" + lydo);
    }

    // SRS_70_Báo cáo công tác An Toàn vệ sinh lao động (doanh nghiệp) / Phụ lục II
  xuatBaoCaoTinhHinhAnToanVeSinhLaoDong(idCoSo, namBaoCao) {
    return this._apiService.getBlobFile(
      apiUrl.LDVL_HGI.BAO_CAO_CONG_TAC_AN_TOAN_VE_SINH_LAO_DONG
        .layThongTinBaoCao +
        '?idCoSo=' +
        idCoSo +
        '&namBaoCao=' +
        namBaoCao +
        '&isWord=' +
        0
    );
  }

  xuatBaoCaoCongTacAnToanVeSinhLaoDong(idCoSo, namBaoCao) {
    return super.downloadFile(apiUrl.LDVL_HGI.BAO_CAO_CONG_TAC_AN_TOAN_VE_SINH_LAO_DONG
        .layThongTinBaoCao +
        '?idCoSo=' +
        idCoSo +
        '&namBaoCao=' +
        namBaoCao +
        '&isWord=' +
        1, "Bao-cao-cong-tac-an-toan-ve-sinh-lao-dong.docx")
  }
  // End SRS_70_Báo cáo công tác An Toàn vệ sinh lao động (doanh nghiệp) / Phụ lục II

    XuatBCThongKeSoNguoiHuongTroCapThatNghiep(maTinh,nam, reportType): Observable<any>{
        if(reportType == 1){
            let str="?tinh="+maTinh;
            if(nam!=null) str=str+"&nam="+nam;

            let requestOptions = {
                responseType: 'blob' as 'json',
                headers: this._apiService.getJsonHeaders()
            };
            return this.http.get(apiUrl.LDVL_HGI.baocaoThongKeSoNguoiHuongTroCapThatNghiep.xuatBaoCaoThongKeSoNguoiHuongTroCapThatNghiep+str+"&reportType=" + reportType,requestOptions);
        }else{
            return super.downloadFile(apiUrl.LDVL_HGI.baocaoThongKeSoNguoiHuongTroCapThatNghiep.xuatBaoCaoThongKeSoNguoiHuongTroCapThatNghiep + "?tinh=" + maTinh + "&nam=" + nam +"&reportType=" + reportType, "Báo cáo thống kê số người hưởng trợ cấp thất nghiệp được hỗ trợ học nghề và tư vấn giới thiệu việc làm");
        }
    }

    getAllDanhSachMayMoc(): Observable<any> {
        return super.get(apiUrl.LDVL.danhMuc.getAllDanhMucMayMoc);
    }

    getDanhSachKhaiBaoMayMoc(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.KhaiBaoMayMoc.timKiemKhaiBaoMayMoc, obj);
    }

    getChiTietThongTinCoSo(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.KhaiBaoMayMoc.getChiTietThongTinCoSo, obj);
    }

    themMoiKhaiBaoMayMoc(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.KhaiBaoMayMoc.themMoiKhaiBaoMayMoc, obj);
    }

    getChiTietKhaiBaoMayMoc(id): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.KhaiBaoMayMoc.getChiTietKhaiBaoMayMoc,id);
    }

    uploadFileKhaiBaoMayMoc(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.KhaiBaoMayMoc.uploadFile , obj);
    }

    capNhatKhaiBaoMayMoc(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.KhaiBaoMayMoc.capNhatKhaiBaoMayMoc , obj);
    }

    downloadFileKhaiBaoMayMoc(fileID, tenFile): Observable<any> {
        return super.downloadFile(apiUrl.LDVL_HGI.KhaiBaoMayMoc.downloadFile +"/" + fileID , tenFile);
    }

    getFileNameKhaiBaoMayMoc(fileID): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.KhaiBaoMayMoc.getFileName + "?fileID=" + fileID);
    }

    duyetKhaiBaoMayMoc(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.KhaiBaoMayMoc.duyetKhaiBaoMayMoc, obj );
    }

    xuatBaoCaoKhaiBaoMayMoc(id): Observable<any> {
        return super.downloadFile(apiUrl.LDVL_HGI.KhaiBaoMayMoc.xuatBaoCao +"?id=" + id, "Báo cáo khai báo máy móc" );
    }

    xuatDanhSachKhaiBao(request): Observable<any> {
        return super.downloadFile(apiUrl.LDVL_HGI.KhaiBaoMayMoc.xuatDanhSachKhaiBao +"?idCoSo=" + request.idCoSo+"&nam=" + request.nam+"&thang=" + request.thang+"&trangThai=" + request.trangThai, "Danh sách khai báo máy móc" );
    }

    xoaKhaiBaoMayMoc(id): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.KhaiBaoMayMoc.xoaKhaiBaoMayMoc, id);
    }
    // START QUẢN LÝ BAN ĐẦU VỀ SỐ LAO ĐỘNG HGI
    getQuanLySoLaoDong(obj){
        return super.get(apiUrl.QLLĐ.quanLySoLaoDong.timKiemQuanLySoLaoDong,obj);
    }

    getDataFormThemMoi(obj){
        return super.get(apiUrl.QLLĐ.quanLySoLaoDong.getDataFormThemMoi,obj);
    }


    getDanhMucGioiTinhSoLaoDong() {
        return super.get(apiUrl.QLLĐ.quanLySoLaoDong.getDmGioiTinh);
    }

    getDanhMucDanTocSoLaoDong() {
        return super.get(apiUrl.QLLĐ.quanLySoLaoDong.getDmDantoc);
    }

    getDanhMucChuyenMonSoLaoDong() {
        return super.get(apiUrl.QLLĐ.quanLySoLaoDong.getDmchuyenmon);
    }

    getDanhMucGioiTinhLoaiHdldSoLaoDong() {
        return super.get(apiUrl.QLLĐ.quanLySoLaoDong.getDmLoaiHdld);
    }

    getDanhMucViTricvSoLaoDong() {
        return super.get(apiUrl.QLLĐ.quanLySoLaoDong.getDmViTriCV);
    }

    themDuLieuSoLaoDong(obj): Observable<any> {
        return super.post(apiUrl.QLLĐ.quanLySoLaoDong.themMoiDuLieu, obj);
    }

    capNhatDuLieuSoLaoDong(obj): Observable<any> {
        return super.post(apiUrl.QLLĐ.quanLySoLaoDong.capNhatDuLieu, obj);
    }

    getDataCapNhat(obj){
        return super.get(apiUrl.QLLĐ.quanLySoLaoDong.getDataCapNhat,obj);
    }

    deleteQuanLySoLaoDongHgi(obj): Observable<any>{
        return super.delete(apiUrl.QLLĐ.quanLySoLaoDong.delete,obj);
    }

    guiDuyetQuanLySoLaoDongHgi(obj): Observable<any> {
        return super.post(apiUrl.QLLĐ.quanLySoLaoDong.guiDuyet, obj);
    }

    tuChoiQuanLySoLaoDongHgi(obj): Observable<any> {
        return super.post(apiUrl.QLLĐ.quanLySoLaoDong.tuChoi, obj);
    }
    // END QUẢN LÝ BAN ĐẦU VỀ SỐ LAO ĐỘNG HGI

    // Begin IT5ASXH-14432
    addOrUpdateQLTinhHinhHoatDongDVVLTongHop(obj){
        return super.post(apiUrl.LDVL.DVVL.addOrUpdateQLTinhHinhHoatDongDVVLTongHop,obj);
    }
    timKiemQLTinhhinhHoatDongDVVLTongHop(obj){
        return super.get(apiUrl.LDVL.DVVL.timKiemQLTinhHinhHoatDongDVVLTongHop,obj);
    }
    xoaQLTinhHinhHoatDongDVVLTongHop(id){
        return super.delete(apiUrl.LDVL.DVVL.xoaQLTinhHinhHoatDongDVVLTongHop+"?id="+id);
    }
    capnhatTrangThaiQLTinhHinhHoatDongDVVLTongHop(id,trangThai,lyDoTuChoi){
        return super.post(apiUrl.LDVL.DVVL.capnhatTrangThaiQLTinhHinhHoatDongDVVLTongHop+"?id="+id+"&trangThai="+trangThai+"&lyDoTuChoi="+lyDoTuChoi);
    }
    /**
     *
     * @description Thống kê đình công HGI
     * @returns
     */
    getDmNganhNghe(): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.thongKeDinhCong.dmNganhNgheKinhTe);
    }
    getAllThongKeDinhCong(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.thongKeDinhCong.timKiemThongKeDinhCong, obj);
    }
    getDetailThongKeDinhCong(id) {
        return super.get(apiUrl.LDVL_HGI.thongKeDinhCong.chiTietThongKeDinhCong, { id: id});
    }
    addThongKeDinhCong(requestBody){
        return super.post(apiUrl.LDVL_HGI.thongKeDinhCong.themMoiThongKeDinhCong, requestBody);
    }
    updateThongKeDinhCong(requestBody){
        return super.put(apiUrl.LDVL_HGI.thongKeDinhCong.capNhatThongKeDinhCong, requestBody);
    }
    deleteThongKeDinhCong(id) {
        return super.delete(apiUrl.LDVL_HGI.thongKeDinhCong.xoaThongKeDinhCong, {id:id});
    }

    getBCThongKeDinhCong(id, reportType, nam): Observable<any>{
        if(reportType == 1){

            let requestOptions = {
                responseType: 'blob' as 'json',
                headers: this._apiService.getJsonHeaders()
            };
            return this.http.get(apiUrl.LDVL_HGI.thongKeDinhCong.xuatBaoCaoThongKeDinhCong + "?id=" + id +"&reportType=" + reportType +"&nam=" + nam,requestOptions);
        }else{
            return super.downloadFile(apiUrl.LDVL_HGI.thongKeDinhCong.xuatBaoCaoThongKeDinhCong + "?id=" + id +"&reportType=" + reportType +"&nam=" + nam, "Báo cáo đình công");
        }

    }

  //end SRS15_16
  // Start srs 51 CHỨC NĂNG KẾT QUẢ TRIỂN KHAI THÁNG HÀNH ĐỘNG VỀ AN TOÀN, VỆ SINH LAO ĐỘNG
    layDanhSachBaoCaoKetQuaSo(obj) {
    return super.get(apiUrl.LDVL_HGI.ketQuaTrienKhaiThangHanhDongVeATVSLD.apiLayDanhSachBaoCaoSo, obj);
    }

    layDanhSachBaoCaoKetQuaDN(obj) {
        return super.get(apiUrl.LDVL_HGI.ketQuaTrienKhaiThangHanhDongVeATVSLD.apiLayDanhSachBaoCaoDN, obj);
    }

    layThongTinDoanhNghiepDN(id) {
      return super.get(apiUrl.LDVL_HGI.ketQuaTrienKhaiThangHanhDongVeATVSLD.apiLayThongTinDoanhNghiep, {id});
    }

    capNhatTrangThaiBaoCao(obj, lyDoTuChoi) {
        return super.put(apiUrl.LDVL_HGI.ketQuaTrienKhaiThangHanhDongVeATVSLD.apiCapNhatTrangThaiBaoCao + "?id=" + obj.id + "&trangThaiXacNhan=" + obj.trangThaiXacNhan, lyDoTuChoi);
    }

    xemChiTietBaoCao(id) {
        return super.get(apiUrl.LDVL_HGI.ketQuaTrienKhaiThangHanhDongVeATVSLD.apiXemChiTietBaoCao, {id});
    }

    xuatBaoCaokKetQuaTrenKhaiThangHanhDongVeATVSLD(namTrienKhai) {
        return super.downloadFile(apiUrl.LDVL_HGI.ketQuaTrienKhaiThangHanhDongVeATVSLD.apiXuatBaoCao + "?namTrienKhai=" + namTrienKhai, "Bao-cao-ket-qua-trien-khai-thang-hanh-dong-ve-atvsld.docx" );
    }

    themMoiBaoCaoTrienKhaiThangHanhDongVeATVSLD(newRecord) {
        return super.post(apiUrl.LDVL_HGI.ketQuaTrienKhaiThangHanhDongVeATVSLD.apiThemBaoCaoMoi, newRecord);
    }

    capNhatBaoCaoTrienKhaiThangHanhDongVeATVSLD(obj) {
        return super.put(apiUrl.LDVL_HGI.ketQuaTrienKhaiThangHanhDongVeATVSLD.apiCapNhatBaoCaoDN + "?id=" + obj.id, obj.updatedRecord);
    }

    xoaBaoCaoTrienKhaiThangHanhDongVeATVSLD(id) {
        return super.delete(apiUrl.LDVL_HGI.ketQuaTrienKhaiThangHanhDongVeATVSLD.apiXoaBaoCaoDN, {id});
    }
  //end srs 51 CHỨC NĂNG KẾT QUẢ TRIỂN KHAI THÁNG HÀNH ĐỘNG VỀ AN TOÀN, VỆ SINH LAO ĐỘNG

  // Start SRS 70 QUẢN LÝ CÔNG TÁC AN TOÀN, VỆ SINH LAO ĐỘNG CỦA CÁC CƠ SỞ ĐÓNG TRÊN ĐỊA BÀN
  danhSachCongtacATVSLD(obj): Observable<any> {
    return super.get(apiUrl.LDVL_HGI.tongHopBaoCaoATVSLD.layDanhsachCongtacATVSLD, obj);
  }
  xoaCongtacATVSLD(obj): Observable<any> {
    return super.delete(apiUrl.LDVL_HGI.tongHopBaoCaoATVSLD.xoaCongtacATVSLD, {idCongTacCoSo: obj});
  }
  layChitietBaoCaoSRS38(obj): Observable<any> {
    return super.get(apiUrl.LDVL_HGI.tongHopBaoCaoATVSLD.layChitietBaocaoSRS38, {namBaoCao: obj});
  }
  layChitietBaoCaoSRS39(obj): Observable<any> {
    return super.get(apiUrl.LDVL_HGI.tongHopBaoCaoATVSLD.layChitietBaocaoSRS39, {namBaoCao: obj});
  }
  themBaocao (obj): Observable<any> {
    return super.post(apiUrl.LDVL_HGI.tongHopBaoCaoATVSLD.themBaocao, obj);
  }
  capNhatBaocao (id,obj): Observable<any> {
    return super.put(apiUrl.LDVL_HGI.tongHopBaoCaoATVSLD.capNhatBaoCao + "?idCongTacCoSo=" + id, obj);
  }
  layChitietQuanTracSRS38 (obj): Observable<any> {
    return super.get(apiUrl.LDVL_HGI.tongHopBaoCaoATVSLD.layChitietQuanTracSRS38, {namBaoCao: obj});
  }
  layChitietQuanTracSRS39 (obj): Observable<any> {
    return super.get(apiUrl.LDVL_HGI.tongHopBaoCaoATVSLD.layChitietQuanTracSRS39, {namBaoCao: obj});
  }
  // End SRS 70 QUẢN LÝ CÔNG TÁC AN TOÀN, VỆ SINH LAO ĐỘNG CỦA CÁC CƠ SỞ ĐÓNG TRÊN ĐỊA BÀN

    //   Start IT5ASXH-14636
    xuatbaocaoQLTinhHinhHoatDongDVVL_PDF(namBaoCao,kyBaoCao,type): Observable<any>{
        let str="?namBaoCao="+namBaoCao;
        if(kyBaoCao!=null) str=str+"&kyBaoCao="+kyBaoCao;
        str=str+"&reportType="+type;
        return this._apiService.getBlobFile(apiUrl.LDVL.DVVL.xuatbaocaoQLTinhHinhHoatDongDVVL+str);
    }
    downloadBaoCaoQLTinhHinhHoatDongDVVL_Word(namBaoCao,kyBaoCao,type){
        let str="?namBaoCao="+namBaoCao;
        if(kyBaoCao!=null) str=str+"&kyBaoCao="+kyBaoCao;
        str=str+"&reportType="+type;
        return super.downloadFile(apiUrl.LDVL.DVVL.xuatbaocaoQLTinhHinhHoatDongDVVL+str,"Báo cáo tình hình hoạt động dịch vụ việc làm.doc");
    }
    // End IT5ASXH-14636

    getListChauLuc() {
        return super.get(apiUrl.LDVL_HGI.dmChauLucKhuVuc.getListChauLuc);
    }

    getListByChauLuc(chauLuc) {
        return super.get(apiUrl.LDVL_HGI.dmChauLucKhuVuc.getListByChauLuc + "?chauLuc=" + chauLuc );
    }

    getListTKLDLamViecNuocNgoaiTheoHopDong(obj) {
        return super.get(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDong.getList,obj );
    }
    getTongHopTheoNamTKLD(nam, maTinh) {
        return super.get(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDong.getTongHopTheoNam + "?nam=" + nam + "&maTinh=" + maTinh );
    }
    themMoiTKLDLamViecNuocNgoaiTheoHopDong(obj) {
        return super.post(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDong.themMoi,obj );
    }
    capNhatTKLDLamViecNuocNgoaiTheoHopDong(obj) {
        return super.post(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDong.capNhat,obj );
    }
    getChiTietTKLDLamViecNuocNgoaiTheoHopDong(id) {
        return super.get(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDong.getChiTiet + "?id=" + id );
    }
    xoaTKLDLamViecNuocNgoaiTheoHopDong(id) {
        return super.post(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDong.xoa,id );
    }

    chuyenDuyetTKLDLamViecNuocNgoaiTheoHopDong(obj) {
        return super.post(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDong.chuyenDuyet,obj );
    }
    xuatBaoCaoTKLDLamViecNuocNgoaiTheoHopDong(id) {
        return super.downloadFile(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDong.xuatBaoCao + "?id=" + id, 'BaoCaoThongKeLdLV' );
    }
    getListTKLDLamViecNuocNgoaiTheoHopDongSo(obj) {
        return super.get(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDongSo.getList,obj );
    }
    getTongHopTheoNamTKLDSo(nam, maTinh) {
        return super.get(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDongSo.getTongHopTheoNam+ "?nam=" + nam + "&maTinh=" + maTinh );
    }
    themMoiTKLDLamViecNuocNgoaiTheoHopDongSo(obj) {
        return super.post(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDongSo.themMoi,obj );
    }
    capNhatTKLDLamViecNuocNgoaiTheoHopDongSo(obj) {
        return super.post(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDongSo.capNhat,obj );
    }
    getChiTietTKLDLamViecNuocNgoaiTheoHopDongSo(id) {
        return super.get(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDongSo.getChiTiet + "?id=" + id );
    }
    xoaTKLDLamViecNuocNgoaiTheoHopDongSo(id) {
        return super.post(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDongSo.xoa,id );
    }
    getDMNgheNghiepTH() {
        return super.get(apiUrl.LDVL.TNLD_TONG_HOP.getDMNgheNghiep);
    }

    getDSTrangThai3CapTH() {
        return super.get(apiUrl.LDVL.TNLD_TONG_HOP.getDSTrangThai3Cap);
    }

    inbaocaoTNLDNguoiLDKhongHDLD_PDF_TongHopHGI(maTinh, maXa, nam, kyBC, trangThai, type): Observable<any> {
        let str = "?maTinh=" + maTinh;
        if (maXa != null && maXa != 'null') str = str + "&maXa=" + maXa;
        if (nam != null) str = str + "&nam=" + nam;
        if (kyBC != null) str = str + "&kyBaoCao=" + kyBC;
        if (trangThai != null) str = str + "&trangThai=" + trangThai;
        str = str + "&reportType=" + type;
        return this._apiService.getBlobFile(apiUrl.LDVL.TNLD_TONG_HOP.inbaocaoTNLDNguoiLDKhongHDLDTongHop + str);
    }

    inbaocaoTNLDNguoiLDKhongHDLD_DOC_TongHopHGI(maTinh, maXa, nam, kyBC, trangThai, type): Observable<any> {
        let str = "?maTinh=" + maTinh;
        if (maXa != null && maXa != 'null') str = str + "&maXa=" + maXa;
        if (nam != null) str = str + "&nam=" + nam;
        if (kyBC != null) str = str + "&kyBaoCao=" + kyBC;
        if (trangThai != null) str = str + "&trangThai=" + trangThai;
        str = str + "&reportType=" + type;
        return super.downloadFile(apiUrl.LDVL.TNLD_TONG_HOP.inbaocaoTNLDNguoiLDKhongHDLDTongHop + str, "tai nạn lao động người lao động làm việc không theo hợp đồng lao động");
    }

    xuatBaoCaoTKLDLamViecNuocNgoaiTheoHopDongSo(id) {
        return super.downloadFile(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoHopDongSo.xuatBaoCao + "?id=" + id, 'baoBaoThongKeLdLVSo' );
    }
    baoCaoTinhHinhBienDongLaoDong(idCoSo,namBaoCao,ngayBaoCao) {
        return this._apiService.getBlobFile(apiUrl.LDVL_HGI.thongBaoTinhHinhBienDongLaodong.xuatBaoCao + "?idCoSo=" + idCoSo+ "&namBaoCao=" + namBaoCao+ "&ngayBaoCao=" + ngayBaoCao + "&isExcel=" + 0);
    }

    xuatBaoCaoTinhHinhBienDongLaoDongWord(idCoSo,namBaoCao,ngayBaoCao) {
            return super.downloadFile(apiUrl.LDVL_HGI.thongBaoTinhHinhBienDongLaodong.xuatBaoCao + "?idCoSo=" + idCoSo+ "&namBaoCao=" + namBaoCao+ "&ngayBaoCao=" + ngayBaoCao + "&isExcel=" + 1, "Thong_bao_tinh_hinh_bien_dong_lao_dong.docx");
    }

    //SRS_85//
    baoCaoThongkeTNLD(nam,type): Observable<any>{
        if(type == 1){
            let str="";
            if(nam!=null) str=str+"?nam="+nam;
            str=str+"&reportType="+type;
            return this._apiService.getBlobFile(apiUrl.LDVL_HGI.baoCaoThongkeTNLD+str);
        }else{
            return super.downloadFile(apiUrl.LDVL_HGI.baoCaoThongkeTNLD + "?nam=" + nam +"&reportType=" + type, "thong_ke_tai_nan_lao_dong_nam_" + nam);
        }
    }
    //end SRS_85
    baoCaoTinhHinhBienDongLaoDongMau29(idCoSo,namBaoCao,ngayBaoCao,thang) {
        return this._apiService.getBlobFile(apiUrl.LDVL_HGI.thongBaoTinhHinhBienDongLaoDongMau29.xuatBaoCaoMau29 + "?idCoSo=" + idCoSo+ "&namBaoCao=" + namBaoCao+ "&ngayBaoCao=" + ngayBaoCao + "&thang=" + thang + "&isExcel=" + 0);
    }
    xuatBaoCaoTinhHinhBienDongLaoDongWordMau29(idCoSo,namBaoCao,ngayBaoCao,thang) {
        return super.downloadFile(apiUrl.LDVL_HGI.thongBaoTinhHinhBienDongLaoDongMau29.xuatBaoCaoMau29 + "?idCoSo=" + idCoSo+ "&namBaoCao=" + namBaoCao+ "&ngayBaoCao=" + ngayBaoCao + "&thang=" + thang + "&isExcel=" + 1, "Thong_bao_tinh_hinh_bien_dong_lao_dong_mau29.docx");
    }
    // SRS48
    searchBienBanCoSo(idCoSo, namBaoCao, tenCoSo, pageSize, pageIndex) {
      let url = apiUrl.LDVL_HGI.bienBanKiemTraATVSLD.searchBienBanCoSo;
      let queryParams = '';

      if (idCoSo !== null) {
          queryParams += `?idCoSo=${idCoSo}`;
      }

      if (namBaoCao !== null) {
          queryParams += `${queryParams ? '&' : '?'}namBaoCao=${namBaoCao}`;
      }

      if (tenCoSo !== null && tenCoSo.trim() !== '') {
          queryParams += `${queryParams ? '&' : '?'}tenCoSo=${tenCoSo}`;
      }
      queryParams += `${queryParams ? '&' : '?'}page=${pageIndex}&size=${pageSize}`;

      url += queryParams;

      return super.get(url);
    }

    layThongTinCoSo(idCoSo){
      return super.get(apiUrl.LDVL_HGI.bienBanKiemTraATVSLD.layThongTinCoSo + "?idCoSo=" + idCoSo)
    }
    layThongTinNguoiLaoDong(idCoSo){
      return super.get(apiUrl.LDVL_HGI.bienBanKiemTraATVSLD.layThongTinNguoiLD + "?idCoSo=" + idCoSo)
    }
    layChucVu(){
      return super.get(apiUrl.LDVL_HGI.bienBanKiemTraATVSLD.layChucVu)
    }
    layThongTinBienBanATVSLD(idBienBan){
      return super.get(apiUrl.LDVL_HGI.bienBanKiemTraATVSLD.layBienBanKiemTra + "?idBienBan=" + idBienBan)
    }
    themMoiBienBan(data){
      return super.post(apiUrl.LDVL_HGI.bienBanKiemTraATVSLD.themMoiBienBan, data)
    }
    chinhSuaBienBan(idBienBan, data){
      return super.put(apiUrl.LDVL_HGI.bienBanKiemTraATVSLD.chinhSuaBienBan + "?idBienBan=" + idBienBan, data)
    }
    xoaBienBan(idBienBan){
      return super.delete(apiUrl.LDVL_HGI.bienBanKiemTraATVSLD.chinhSuaBienBan + "?idBienBan=" + idBienBan)
    }
    xuatFile(idBienBan){
      return super.downloadFile(apiUrl.LDVL_HGI.bienBanKiemTraATVSLD.xuatFile + "?idBienBan=" + idBienBan, "Bien_ban_kiem_tra_ATVSLD.pdf")
    }
    xuatBaoCaoTKLDLamViecNNKetThucHDSo(nam, loai) {
        return super.downloadFile(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoKetThucHopDongSo.xuatBaoCao + "?nam=" + nam + "&loai=" + loai, 'baoBaoThongKeLdKtLVSo');
    }

    // END SRS48
       /**
     *
     * @description Thống kê lao động có việc làm tăng thêm
     * @returns
     */
    getAllThongKeLaoDongCoViecLamTangThem(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.thongKeLaoDongCoViecLamTangThem.timKiem, obj);
    }
    getDetailThongKeLaoDongCoViecLamTangThem(id) {
        return super.get(apiUrl.LDVL_HGI.thongKeLaoDongCoViecLamTangThem.chiTiet, { id: id});
    }
    addThongKeLaoDongCoViecLamTangThem(requestBody){
        return super.post(apiUrl.LDVL_HGI.thongKeLaoDongCoViecLamTangThem.themMoi, requestBody);
    }
    updateThongKeLaoDongCoViecLamTangThem(requestBody){
        return super.put(apiUrl.LDVL_HGI.thongKeLaoDongCoViecLamTangThem.capNhat, requestBody);
    }
    deleteThongKeLaoDongCoViecLamTangThem(id) {
        return super.delete(apiUrl.LDVL_HGI.thongKeLaoDongCoViecLamTangThem.xoa, {id:id});
    }
    getBaoCaoTKLDLamViecNNKetThucHDSo(nam, loai) {
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + localStorage.getItem(AUTH.TOKEN_KEY),
                'Content-Type': 'application/json'
            })
        };
        return this.http.get(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoKetThucHopDongSo.xuatBaoCao + "?nam=" + nam + "&loai=" + loai, requestOptions);
    }
    checkReportBaoCaoTKLDLamViecNNKetThucHDSo(nam) {
      return super.get(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoKetThucHopDongSo.checkReport, { nam: nam});
    }

    getBCThongKeLaoDongCoViecLamTangThem(obj): Observable<any>{
        let url =apiUrl.LDVL_HGI.thongKeLaoDongCoViecLamTangThem.xuatBaoCao + "?nam=" + obj.nam +"&reportType=" + obj.reportType;
        if(obj.id != null){
            url= url + "&id=" + obj.id;
        }
        if(obj.tinh != null){
            url= url + "&tinh=" + obj.tinh;
        }
        if(obj.xa != null){
            url= url + "&xa=" + obj.xa;
        }
        if(obj.reportType == 1){
            let requestOptions = {
                responseType: 'blob' as 'json',
                headers: this._apiService.getJsonHeaders()
            };
            return this.http.get(url,requestOptions);
        }else{
            return super.downloadFile(url, "Báo cáo thống kê lao động có việc làm tăng thêm");
        }

    }

    chotSoLieuThongKeLdcvlTangThemTheoNam(nam,tinh,xa) {
        let url = apiUrl.LDVL_HGI.thongKeLaoDongCoViecLamTangThem.chotSoLieuTheoNam + "?nam=" + nam+"&tinh=" + tinh;
        if(xa!=null){
            url=url+"&xa=" + xa;
        }
        return super.put(url);
    }
    chotSoLieuThongKeLdcvlTangThemTheoId(id, trangThai) {
        let url = apiUrl.LDVL_HGI.thongKeLaoDongCoViecLamTangThem.chotSoLieuTheoId + "?id=" + id+"&trangThai=" + trangThai;
        return super.put(url);
    }
    /**END */

    getTongHopTinhHinhQuanLyTNLD(nam,ky,id,loai){
        return super.get(apiUrl.LDVL.TNLD.getTongHopTinhHinhQuanLyTNLDCapCoSo+"?namBaoCao="+nam+"&kyBaoCao="+ky+"&trangThai="+loai);
    }

    inbaocaoTNLDTuNguoiSDLD_PDF(maTinh, coso, nam,kyBC,trangThai,type): Observable<any>{
        let str="?maTinh="+maTinh;
        if(coso!=null) str=str+"&coso="+coso;
        if(nam!=null) str=str+"&nam="+nam;
        if(kyBC!=null) str=str+"&kyBaoCao="+kyBC;
        if(trangThai!=null) str=str+"&trangThai="+trangThai;
        str=str+"&reportType="+type;
        return this._apiService.getBlobFile(apiUrl.LDVL.TNLD.inbaocaoTNLDTuNguoiSDLD+str);
    }


    inbaocaoTNLDSDLDNguoiLDKhongHDLD_DOC(maTinh, coso, nam,kyBC,trangThai,type): Observable<any>{
        let str="?maTinh="+maTinh;
        if(coso!=null) str=str+"&coso="+coso;
        if(nam!=null) str=str+"&nam="+nam;
        if(kyBC!=null) str=str+"&kyBaoCao="+kyBC;
        if(trangThai!=null) str=str+"&trangThai="+trangThai;
        str=str+"&reportType="+type;
        return super.downloadFile(apiUrl.LDVL.TNLD.inbaocaoTNLDTuNguoiSDLD+str,"tai nạn lao động từ người SDLĐ trên địa bàn Tỉnh/TP");
    }

    // SRS71
    xemBaoCaoCongTacATVSLDTrenDiaBan(namBaoCao) {
      return this.http.get<any>(apiUrl.LDVL_HGI.baoCaoCongTacATVSLĐTrenDiaBan.xuatBaoCaoCongTacATVSLĐTrenDiaBan + "?namBaoCao=" + namBaoCao + '&isWord=' + 0, { responseType: 'blob' as 'json', headers: this.getHeader() })
    }
    xuatBaoCaoCongTacATVSLDTrenDiaBan(namBaoCao) {
      return super.downloadFile(apiUrl.LDVL_HGI.baoCaoCongTacATVSLĐTrenDiaBan.xuatBaoCaoCongTacATVSLĐTrenDiaBan + "?namBaoCao=" + namBaoCao + '&isWord=' + 1, "Bao-cao-cong-tac-atvsld-tren-dia-ban.docx")
    }
    // END SRS71
    // TÀI LIỆU SRS 81 THỐNG KÊ LAO ĐỘNG ĐƯỢC TẠO VIỆC LÀM, DUY TRÌ VÀ MỞ RỘNG VIỆC LÀM TỪ QUỸ QUỐC GIA VỀ VIỆC LÀM
    layDanhSachBaoCaoKetQuaThongKeViecLamQuyViecLam(obj) {
       return super.get(apiUrl.LDVL_HGI.baoCaoThongKeViecLamQuyQuocGia.layDanhSachBaoCaoThongKe, obj);
    }
    xuatBaoCaoThongKeViecLamQuyQuocGiaExcel(id) {
       return super.downloadFile(apiUrl.LDVL_HGI.baoCaoThongKeViecLamQuyQuocGia.xuatBaoCaoExcel + "?idThongKe=" + id + "&isPDF="+ 0, "Bao-cao-thong-ke-lao-dong-duoc-tao-viec-lam.xlsx");
    }
    xuatBaoCaoThongKeViecLamQuyQuocGiaPDF(id) {
       return super.downloadFile(apiUrl.LDVL_HGI.baoCaoThongKeViecLamQuyQuocGia.xuatBaoCaoPDF + "?idThongKe=" + id + "&isPDF="+ 1, "Bao-cao-thong-ke-lao-dong-duoc-tao-viec-lam.pdf");
    }
    themBaoCaoThongKeViecLamQuyQuocGia(requestBody) {
      return super.post(apiUrl.LDVL_HGI.baoCaoThongKeViecLamQuyQuocGia.themBaoCaoThongKe, requestBody);
    }
    capNhatBaoCaoThongKeViecLamQuyQuocGia(idThongKe, requestBody) {
      return super.put(apiUrl.LDVL_HGI.baoCaoThongKeViecLamQuyQuocGia.capNhatBaoCaoThongKe + "?idThongKe=" + idThongKe, requestBody);
    }
    xemChiTietBaoCaoThongKeViecLamQuyQuocGia(idThongKe) {
      return super.get(apiUrl.LDVL_HGI.baoCaoThongKeViecLamQuyQuocGia.layChiTietBaoCaoThongKe, {idThongKe});
    }
    xoaBaoCaoThongKeViecLamQuyQuocGia(idThongKe) {
      return super.delete(apiUrl.LDVL_HGI.baoCaoThongKeViecLamQuyQuocGia.xoaBaoCaoThongKe, {idThongKe});
    }
    // TÀI LIỆU SRS 81 THỐNG KÊ LAO ĐỘNG ĐƯỢC TẠO VIỆC LÀM, DUY TRÌ VÀ MỞ RỘNG VIỆC LÀM TỪ QUỸ QUỐC GIA VỀ VIỆC LÀM
     // START HGI SRS 87
     getDanhMucNganhNgheHgi() {
        return super.get(apiUrl.QLLĐ.thongKeTienLuongLaodong.getDmNgheNghiep);
    }
    getDanhMucNgheNghiepHgi() {
        return super.get(apiUrl.QLLĐ.thongKeTienLuongLaodong.getDmNgheNghiepHgi);
    }
    getDanhMucTinhThanhHgi() {
        return super.get(apiUrl.QLLĐ.thongKeTienLuongLaodong.getDmTinhThanhHgi);
    }
    getTenDoanhNghiep(idDoanhNghiep) {
        return super.get(apiUrl.QLLĐ.thongKeTienLuongLaodong.getTenDoanhNghiep+ "?idDoanhNghiep=" + idDoanhNghiep);
    }
    themThongKeTienLuongLaoDongHgi(obj): Observable<any> {
        return super.post(apiUrl.QLLĐ.thongKeTienLuongLaodong.themMoiDuLieu, obj);
    }
    getThongKeTienLuongLaoDongHgi(obj){
        return super.get(apiUrl.QLLĐ.thongKeTienLuongLaodong.timKiemDulieu,obj);
    }
    getDataCapNhat1(obj){
        return super.get(apiUrl.QLLĐ.thongKeTienLuongLaodong.getDataCapNhat,obj);
    }
    capNhatThongKeTienLuongLaoDongHgi(obj): Observable<any> {
        return super.post(apiUrl.QLLĐ.thongKeTienLuongLaodong.capNhatDuLieu, obj);
    }
    deletethongKeTienLuongLaodongHgi(obj): Observable<any>{
        return super.delete(apiUrl.QLLĐ.thongKeTienLuongLaodong.delete,obj);
    }
    xuatBaoCaoThongKeTienLuongLaoDongHgi(id): Observable<any> {
        return this._apiService.getBlobFile(apiUrl.QLLĐ.thongKeTienLuongLaodong.xuatBaoCao + "?id=" + id + "&isExcel=" + 0);
    }
    xuatEXcelTienLuongLD_HGI(id): Observable<any> {
        return super.downloadFile(apiUrl.QLLĐ.thongKeTienLuongLaodong.xuatBaoCao + "?id=" + id + "&isExcel=" + 1, "Thong-ke-tien-luong-lao-dong-trong-doanh-nghiep");
    }
    xuatPDFTienLuongLD_HGI(id): Observable<any> {
        return super.downloadFile(apiUrl.QLLĐ.thongKeTienLuongLaodong.xuatBaoCao + "?id=" + id + "&isExcel=" + 0, "Thong-ke-tien-luong-lao-dong-trong-doanh-nghiep");
    }
    // END HGI SRS 87

    xoaQuanLyTongHopTinhHinhLaoDongCapCoSo(idTongHop, username) {
      return super.post(apiUrl.LDVL.TNLD.xoaQuanLyTongHopTinhHinhLaoDongCapCoSo + "?idTongHop=" + idTongHop + "&username=" + username);
  }

    getBCTongHopTinhHinhTNLDCapCoSo(nam, kyBC, idCoSo, reportType){
      let str="?nam="+nam;
      if(kyBC!=null) str=str+"&kyBC="+kyBC;
      if(idCoSo!=null) str=str+"&idCoSo="+idCoSo;
      str=str+"&reportType="+reportType;
      if(reportType == 1){
          return this._apiService.getBlobFile(apiUrl.LDVL.TNLD.getBCTongHopTinhHinhTNLDCapCoSo + str);
      }else{
          return super.downloadFile(apiUrl.LDVL.TNLD.getBCTongHopTinhHinhTNLDCapCoSo+str,"Báo cáo tổng hợp tình hình tai nạn lao động cấp cơ sở (doanh nghiệp).docx");
      }
    }


    getDMLoaiHDLD(): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.tinhTrangViecLam.dmLoaiHDLD);
    }

    getAllTinhTrangViecLam(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.tinhTrangViecLam.timKiemTinhTrangViecLam, obj);
    }

    getDetailTinhTrangViecLam(id) {
        return super.get(apiUrl.LDVL_HGI.tinhTrangViecLam.chiTietTinhTrangViecLam, { id: id});
    }
    addTinhTrangViecLam(requestBody){
        return super.post(apiUrl.LDVL_HGI.tinhTrangViecLam.themMoiTinhTrangViecLam, requestBody);
    }
    updateTinhTrangViecLam(requestBody){
        return super.put(apiUrl.LDVL_HGI.tinhTrangViecLam.capNhatTinhTrangViecLam, requestBody);
    }
    deleteTinhTrangViecLam(id) {
        return super.delete(apiUrl.LDVL_HGI.tinhTrangViecLam.xoaTinhTrangViecLam, {id:id});
    }

    getBCTinhTrangViecLam(id): Observable<any>{
            let requestOptions = {
                responseType: 'blob' as 'json',
                headers: this._apiService.getJsonHeaders()
            };
            return this.http.get(apiUrl.LDVL_HGI.tinhTrangViecLam.xuatBaoCaoTinhTrangViecLam + "?id=" + id ,requestOptions);
    }

    guiTinhTrangViecLam(id) {
        return super.put(apiUrl.LDVL_HGI.tinhTrangViecLam.guiTinhTrangViecLam + "?id=" + id);
    }

    duyetTinhTrangViecLam(id) {
        return super.put(apiUrl.LDVL_HGI.tinhTrangViecLam.duyetTinhTrangViecLam + "?id=" + id);
    }
    tuChoiTinhTrangViecLam(id,lydo) {
        return super.put(apiUrl.LDVL_HGI.tinhTrangViecLam.tuChoiTinhTrangViecLam + "?id=" + id +"&lyDo=" + lydo);
    }

    // SRS_102_103_Dashboard thể hiện số người có việc làm, thất nghiệp trong tỉnh

    layThongTinBieuDoNguoiCoViecLam(req) {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienSoNguoiCoViecLamThatNghiepTrongTinh.layThongTinBieuDoNguoiCoViecLam, req)
    }

    layThongTinBieuDoTyLeLaoDongTheoHopDong(req) {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienSoNguoiCoViecLamThatNghiepTrongTinh.layThongTinBieuDoTyLeLaoDongTheoHopDong, req)
    }

    layThongTinBieuDoTyLeLaoDongTheoLoaiHinhNoiLamViec(req) {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienSoNguoiCoViecLamThatNghiepTrongTinh.layThongTinBieuDoTyLeLaoDongTheoLoaiHinhNoiLamViec, req)
    }

    layThongTinBieuDoNguoiThatNghiep(req) {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienSoNguoiCoViecLamThatNghiepTrongTinh.layThongTinBieuDoNguoiThatNghiep, req)
    }

    layThongTinBieuDoTyLeChuaVaDaLamViec(req) {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienSoNguoiCoViecLamThatNghiepTrongTinh.layThongTinBieuDoTyLeChuaVaDaLamViec, req)
    }

    layThongTinBieuDoTyLeThoiGianThatNghiep(req) {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienSoNguoiCoViecLamThatNghiepTrongTinh.layThongTinBieuDoTyLeThoiGianThatNghiep, req)
    }

    // SRS_102_103_Dashboard thể hiện số người có việc làm, thất nghiệp trong tỉnh

    // SRS_104_TÀI LIỆU SRS DASHBOARD BIỂU ĐỒ SỐ LIỆU CUNG CẦU LAO ĐỘNG

    layThongTinTinhTongSoLaoDongNamNu(req) {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienSoLieuCungCauLaoDongTrongTinh.layThongTinTinhTongSoLaoDongNamNu, req)
    }

    layThongTinTinhLucLuongLaoDongTheoDiaBan(req) {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienSoLieuCungCauLaoDongTrongTinh.layThongTinTinhLucLuongLaoDongTheoDiaBan, req)
    }

    layThongTinTinhTyLeTrinhDoGiaoDuc(req) {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienSoLieuCungCauLaoDongTrongTinh.layThongTinTinhTyLeTrinhDoGiaoDuc, req)
    }

    layThongTinTinhTyLeTrinhDoChuyenMonKyThuat(req) {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienSoLieuCungCauLaoDongTrongTinh.layThongTinTinhTyLeTrinhDoChuyenMonKyThuat, req)
    }

    // SRS_104_TÀI LIỆU SRS DASHBOARD BIỂU ĐỒ SỐ LIỆU CUNG CẦU LAO ĐỘNG
    // SRS 105 DASHBOARD THỂ HIỆN SỐ DOANH NGHIỆP TRONG TỈNH
    layThongTinSoDoanhNghiepChuaDungHoatDong(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienThongTinDoanhNghiepTrongTinh.layThongTinSoDoanhNghiepChuaDungHoatDong, obj);
    }

    layThongTinSoDoanhNghiepDaThanhLapCongDoan(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienThongTinDoanhNghiepTrongTinh.layThongTinSoDoanhNghiepDaThanhLapCongDoan, obj);
    }

    layThongTinSoDoanhNghiepCoTongSoNguoiLaoDongTren1000(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienThongTinDoanhNghiepTrongTinh.layThongTinSoDoanhNghiepCoTongSoNguoiLaoDongTren1000, obj);
    }

    layThongTinSoDoanhNghiepTheoDiaBan(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienThongTinDoanhNghiepTrongTinh.layThongTinSoDoanhNghiepTheoDiaBan, obj);
    }

    layThongTinSoDoanhNghiepTheoDieuKien(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienThongTinDoanhNghiepTrongTinh.layThongTinSoDoanhNghiepTheoDieuKien, obj);
    }

    layThongTinSoDoanhNghiepTheoLoaiHinhCoSo(obj): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienThongTinDoanhNghiepTrongTinh.layThongTinSoDoanhNghiepTheoLoaiHinhCoSo, obj);
    }
    // SRS 105 DASHBOARD THỂ HIỆN SỐ DOANH NGHIỆP TRONG TỈNH

  // START HGI SRS 80
    getDmQuanHuyen() {
      return super.get(apiUrl.QLLĐ.thongKeLaoDongTimDuocVieclam.getDmQuanHuyen);
  }
  themThongKeLaoDongTimDuocViecLamHgi(obj): Observable<any> {
      return super.post(apiUrl.QLLĐ.thongKeLaoDongTimDuocVieclam.themMoiDuLieu, obj);
  }
  getThongKeLaoDongTimDuocViecLamHgi(obj){
      return super.get(apiUrl.QLLĐ.thongKeLaoDongTimDuocVieclam.timKiemDulieu,obj);
  }
  getDataCapNhatLaoDongTimDuocViecLam(obj){
      return super.get(apiUrl.QLLĐ.thongKeLaoDongTimDuocVieclam.getDataCapNhat,obj);
  }
  capNhatThongKeLaoDongTimDuocViecLam(obj): Observable<any> {
      return super.post(apiUrl.QLLĐ.thongKeLaoDongTimDuocVieclam.capNhatDuLieu, obj);
  }
  deletethongKeLaoDongTimDuocViecLam(obj): Observable<any>{
      return super.delete(apiUrl.QLLĐ.thongKeLaoDongTimDuocVieclam.delete,obj);
  }

  xuatBaoCaoThongKeLaoDongTimDuocViecLam(id, type): Observable<any> {
    if(type == 0){
       return this._apiService.getBlobFile(apiUrl.QLLĐ.thongKeLaoDongTimDuocVieclam.xuatBaoCao + "?id=" + id + "&isExcel=" + type);
    }else{
        return super.downloadFile(apiUrl.QLLĐ.thongKeLaoDongTimDuocVieclam.xuatBaoCao + "?id=" + id + "&isExcel=" + type, "Thống kê lao động tìm được việc làm");
    }
  }
  // END HGI SRS 80
    // SRS56
    formatDateToDDMMYYYY(date: Date): string {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    }
    xemBaoCaoKQHDVVL(namBaoCao, kyBaoCao, diaDiem, ngayBaoCao, isWord = 0) {
        let url = apiUrl.LDVL_HGI.baoCaoKetQuaHoatDongDichVuViecLam.xuatBaoCaoKetQuaHoatDongDichVuViecLam + "?namBaoCao=" + namBaoCao;
        if (kyBaoCao !== null) {
          url += '&kyBaoCao=' + kyBaoCao;
        }
        if (diaDiem !== null) {
          url += '&diaDiem=' + diaDiem;
        }
        if (ngayBaoCao !== null) {
          const formattedDate = this.formatDateToDDMMYYYY(ngayBaoCao);
          url += '&ngayBaoCao=' + formattedDate;
        }
        url += '&isWord=' + isWord;

        if (isWord === 1) {
          return super.downloadFile(url, "Bao-cao-cong-tac-atvsld-tren-dia-ban.docx");
        } else {
          return this._apiService.getBlobFile(url);
        }
      }
    //


    xuatbaocaoQLTinhHinhHoatDongDVVL_TongHop_PDF(namBaoCao,kyBaoCao,reportType,trangThai): Observable<any>{
        let str='?namBaoCao='+namBaoCao+'&kyBaoCao='+kyBaoCao+'&trangThai='+trangThai+'&reportType='+reportType;
        return this._apiService.getBlobFile(apiUrl.LDVL.DVVL.xuatbaocaoQLTinhHinhHoatDongDVVL_TongHop+str);
    }
    xuatbaocaoQLTinhHinhHoatDongDVVL_TongHop_Word(namBaoCao,kyBaoCao,reportType,trangThai): Observable<any>{
        let str='?namBaoCao='+namBaoCao+'&kyBaoCao='+kyBaoCao+'&trangThai='+trangThai+'&reportType='+reportType;
        return this._apiService.downloadFile(apiUrl.LDVL.DVVL.xuatbaocaoQLTinhHinhHoatDongDVVL_TongHop+str,'Báo cáo tình hình hoạt động dịch vụ việc làm (Tổng hợp)');
    }

    //END SRS_20

    //BEGIN SRS_20
    getListTinhHinhHDChoThueLaiLD(obj): Observable<any>{
      return super.get(apiUrl.LDVL.THUE_LAI_LD.getListTinhHinhHDChoThueLaiLD, obj);
    }
    getThongTinChiTiet(idBC): Observable<any>{
      return super.get(apiUrl.LDVL.THUE_LAI_LD.getThongTinChiTiet,{ idBC: idBC });
    }

    insertTinhHinhHDChoThueLaiLD(obj): Observable<any>{
      return super.post(apiUrl.LDVL.THUE_LAI_LD.insertTinhHinhHDChoThueLaiLD, obj);
    }

    updateTinhHinhHDChoThueLaiLD(obj): Observable<any>{
      return super.put(apiUrl.LDVL.THUE_LAI_LD.updateTinhHinhHDChoThueLaiLD, obj);
    }

    capNhatTrangThaiDuyet(obj): Observable<any>{
      return super.put(apiUrl.LDVL.THUE_LAI_LD.capNhatTrangThaiDuyet, obj);
    }

    deleteTinhHinhHDChoThueLaiLD(id): Observable<any>{
      return super.delete(apiUrl.LDVL.THUE_LAI_LD.deleteTinhHinhHDChoThueLaiLD+"/"+id);
    }

    xuatBaoCaoTinhHinhHDChoThueLaiLD(obj){
      var str = "?nam=" + obj["nam"] + "&kyBC=" + obj["kyBC"] + "&reportType=" + obj["reportType"];
      if(obj["idCS"] != null && obj["idCS"] != 'null') str = str + "&idCS=" + obj["idCS"];
      if(obj["dnNN"] != null && obj["dnNN"] != 'null') str = str + "&dnNN=" + obj["dnNN"];
      if(obj["dnTN"] != null && obj["dnTN"] != 'null') str = str + "&dnTN=" + obj["dnTN"];
      if(obj["dnFDI"] != null && obj["dnFDI"] != 'null') str = str + "&dnFDI=" + obj["dnFDI"];
      if(obj["tenDoanhNghiep"] != null && obj["tenDoanhNghiep"] != 'null') str = str + "&tenDoanhNghiep=" + obj["tenDoanhNghiep"];
      return this._apiService.getBlobFile(apiUrl.LDVL.THUE_LAI_LD.xuatBaoCaoTinhHinhHDChoThueLaiLD + str);
    }

    downloadxuatBaoCaoTinhHinhHDChoThueLaiLD(obj){
      var str = "?nam=" + obj["nam"] + "&kyBC=" + obj["kyBC"] + "&reportType=" + obj["reportType"];
      if(obj["idCS"] != null && obj["idCS"] != 'null') str = str + "&idCS=" + obj["idCS"];
      if(obj["dnNN"] != null && obj["dnNN"] != 'null') str = str + "&dnNN=" + obj["dnNN"];
      if(obj["dnTN"] != null && obj["dnTN"] != 'null') str = str + "&dnTN=" + obj["dnTN"];
      if(obj["dnFDI"] != null && obj["dnFDI"] != 'null') str = str + "&dnFDI=" + obj["dnFDI"];
      if(obj["tenDoanhNghiep"] != null && obj["tenDoanhNghiep"] != 'null') str = str + "&tenDoanhNghiep=" + obj["tenDoanhNghiep"];
      return this._apiService.downloadFile(apiUrl.LDVL.THUE_LAI_LD.xuatBaoCaoTinhHinhHDChoThueLaiLD + str, "Báo cáo tình hình hoạt động cho thuê lại lao động.docx")
    }

    checkBaoCaoTinhHinhHDChoThueLaiLD(obj){
      var str = "?nam=" + obj["nam"] + "&kyBC=" + obj["kyBC"];
      if(obj["idCS"] != null && obj["idCS"] != 'null') str = str + "&idCS=" + obj["idCS"];
      return super.get(apiUrl.LDVL.THUE_LAI_LD.checkBaoCaoTinhHinhHDChoThueLaiLD + str);
    }

     // TÀI LIỆU SRS_106_Dashboard thể hiện số tai nạn lao động
    tinhTongSoTNLD(obj) {
        return super.get(apiUrl.LDVL_HGI.dashboardThongKeSoTaiNanLaoDong.tinhTongSoTNLD, obj);
    }
    tinhTongSoTNLDKhongTheoHD(obj) {
        return super.get(apiUrl.LDVL_HGI.dashboardThongKeSoTaiNanLaoDong.tinhTongSoTNLDKhongTheoHD, obj);
    }
    tinhTongSoTNLDChart(obj) {
        return super.get(apiUrl.LDVL_HGI.dashboardThongKeSoTaiNanLaoDong.tinhTongSoTNLDChart, obj);
    }
    tinhTongSoTNLDKhongTheoHDChart(obj) {
        return super.get(apiUrl.LDVL_HGI.dashboardThongKeSoTaiNanLaoDong.tinhTongSoTNLDKhongTheoHDChart, obj);
    }
    tongHopSoTaiNanLaoDong(obj) {
        return super.get(apiUrl.LDVL_HGI.dashboardThongKeSoTaiNanLaoDong.tongHopSoTaiNanLaoDong, obj);
    }
    // TÀI LIỆU SRS_106_Dashboard thể hiện số tai nạn lao động
    //end SRS15_16


    getListTKLDLamViecNuocNgoaiTheoKetThucHopDong(obj) {
        return super.get(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoKetThucHopDong.getList,obj );
    }
    getTongHopTheoKetThucNamTKLD(nam, maTinh) {
        return super.get(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoKetThucHopDong.getTongHopTheoNam + "?nam=" + nam + "&maTinh=" + maTinh);
    }
    themMoiTKLDLamViecNuocNgoaiTheoKetThucHopDong(obj) {
        return super.post(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoKetThucHopDong.themMoi,obj );
    }
    capNhatTKLDLamViecNuocNgoaiTheoKetThucHopDong(obj) {
        return super.post(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoKetThucHopDong.capNhat,obj );
    }
    getChiTietTKLDLamViecNuocNgoaiTheoKetThucHopDong(id) {
        return super.get(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoKetThucHopDong.getChiTiet + "?id=" + id );
    }
    xoaTKLDLamViecNuocNgoaiTheoKetThucHopDong(id) {
        return super.post(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoKetThucHopDong.xoa,id );
    }

    chuyenDuyetTKLDLamViecNuocNgoaiTheoKetThucHopDong(obj) {
        return super.post(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoKetThucHopDong.chuyenDuyet,obj );
    }
    xuatBaoCaoTKLDLamViecNuocNgoaiTheoKetThucHopDong(id,loai) {
        return super.downloadFile(apiUrl.LDVL_HGI.TKLDLamViecNuocNgoaiTheoKetThucHopDong.xuatBaoCao + "?id=" + id + "&loai="+ loai, 'baoBaoThongKeLdLV' );
    }

    // TÀI LIỆU SRS_107_Dashboard thể hiện số người nước ngoài làm việc tại Việt Nam được cấp phép
    tinhTongSoGiayPhepDuocCapMoi(obj) {
        return super.get(apiUrl.LDVL_HGI.dashboardThongKeSoNguoiNNLamViecTaiVietNam.tinhTongSoGiayPhepDuocCapMoi, obj);
    }
    tinhTongSoGiayPhepDuocCap2_3(obj) {
        return super.get(apiUrl.LDVL_HGI.dashboardThongKeSoNguoiNNLamViecTaiVietNam.tinhTongSoGiayPhepDuocCap2_3, obj);
    }
    tinhTongSoGiayPhepDuocCap5(obj) {
        return super.get(apiUrl.LDVL_HGI.dashboardThongKeSoNguoiNNLamViecTaiVietNam.tinhTongSoGiayPhepDuocCap5, obj);
    }
    tinhTongSoGiayPhepThuHoi(obj) {
        return super.get(apiUrl.LDVL_HGI.dashboardThongKeSoNguoiNNLamViecTaiVietNam.tinhTongSoGiayPhepThuHoi, obj);
    }
    tinhTongHopGiayPhepChart(obj) {
        return super.get(apiUrl.LDVL_HGI.dashboardThongKeSoNguoiNNLamViecTaiVietNam.tinhTongHopGiayPhepChart, obj);
    }
    tinhTyLeQuocTich(obj) {
        return super.get(apiUrl.LDVL_HGI.dashboardThongKeSoNguoiNNLamViecTaiVietNam.tinhTyLeQuocTich, obj);
    }
    tinhTyLeLoaiHinhDoanhNghiep(obj) {
        return super.get(apiUrl.LDVL_HGI.dashboardThongKeSoNguoiNNLamViecTaiVietNam.tinhTyLeLoaiHinhDoanhNghiep, obj);
    }
    // TÀI LIỆU SRS_107_Dashboard thể hiện số người nước ngoài làm việc tại Việt Nam được cấp phép

     // START QUẢN LÝ TÌNH HÌNH BIẾN ĐỘNG LAO ĐỘNG
     getQuanLyBiendongLaoDong(obj){
        return super.get(apiUrl.QLLĐ.quanLyBienDongLaoDong.timKiemQuanLyBienDongLaoDong,obj);
    }

    getDataFormThemMoiSo2(obj){
        return super.get(apiUrl.QLLĐ.quanLyBienDongLaoDong.getDataFormThemMoiSo2,obj);
    }

    getDataFormThemMoiSo3(obj){
        return super.get(apiUrl.QLLĐ.quanLyBienDongLaoDong.getDataFormThemMoiSo3,obj);
    }

    getDataFormThemMoiSo1(obj){
        return super.get(apiUrl.QLLĐ.quanLyBienDongLaoDong.getDataFormThemMoiSo1,obj);
    }

    getTenDoanhNghiepBienDongLaoDong(idDoanhNghiep) {
        return super.get(apiUrl.QLLĐ.quanLyBienDongLaoDong.getTenDoanhNghiep+ "?idDoanhNghiep=" + idDoanhNghiep);
    }

    getDmCoSo(idCoSo) {
        return super.get(apiUrl.QLLĐ.quanLyBienDongLaoDong.getDmCoSo + "?idCoSo=" + idCoSo  );
    }



    getDanhMucGioiTinhBiendongLaoDong() {
        return super.get(apiUrl.QLLĐ.quanLyBienDongLaoDong.getDmGioiTinh);
    }

    getDanhMucDanTocBiendongLaoDong() {
        return super.get(apiUrl.QLLĐ.quanLyBienDongLaoDong.getDmDantoc);
    }

    getDanhMucChuyenMonBiendongLaoDong() {
        return super.get(apiUrl.QLLĐ.quanLyBienDongLaoDong.getDmchuyenmon);
    }

    getDanhMucGioiTinhLoaiHdldBiendongLaoDong() {
        return super.get(apiUrl.QLLĐ.quanLyBienDongLaoDong.getDmLoaiHdld);
    }

    getDanhMucLyDoBiendongLaoDong() {
        return super.get(apiUrl.QLLĐ.quanLyBienDongLaoDong.getDmLyDo);
    }

    getDanhMucViTricvBiendongLaoDong() {
        return super.get(apiUrl.QLLĐ.quanLyBienDongLaoDong.getDmViTriCV);
    }

    themDuLieuTinhHinhBienDonglaoDong(obj): Observable<any> {
        return super.post(apiUrl.QLLĐ.quanLyBienDongLaoDong.themMoiDuLieu, obj);
    }

    capNhatDuLieuBiendongLaoDong(obj): Observable<any> {
        return super.post(apiUrl.QLLĐ.quanLyBienDongLaoDong.capNhatDuLieu, obj);
    }

    getDataCapNhatBiendongLaoDong(obj){
        return super.get(apiUrl.QLLĐ.quanLyBienDongLaoDong.getDataCapNhat,obj);
    }

    deleteQuanLyBiendongLaoDongHgi(obj): Observable<any>{
        return super.delete(apiUrl.QLLĐ.quanLyBienDongLaoDong.delete,obj);
    }

    guiDuyetQuanLyBienDongLaoDongHgi(obj): Observable<any> {
        return super.post(apiUrl.QLLĐ.quanLyBienDongLaoDong.guiDuyet, obj);
    }

    tuChoiQuanLyBiendongLaoDongHgi(obj): Observable<any> {
        return super.post(apiUrl.QLLĐ.quanLyBienDongLaoDong.tuChoi, obj);
    }
    // END QUẢN LÝ TÌNH HÌNH BIẾN ĐỘNG LAO ĐỘNG

    // SRS_108_Dashboard thể hiện số người nước Việt Nam làm việc tại nước ngoài

    tinhTongSoNguoiVietLamViecTaiNN(req) {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienSoNguoiVietNamLamViecTaiNuocNgoai.tinhTongSoNguoiVietLamViecTaiNN, req)
    }

    tinhTongSoNguoiVietLamViecTaiNNTheoDiaBan(req) {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienSoNguoiVietNamLamViecTaiNuocNgoai.tinhTongSoNguoiVietLamViecTaiNNTheoDiaBan, req)
    }

    tinhTongSoNguoiVietLamViecTaiNNTheoQuocGia(req) {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienSoNguoiVietNamLamViecTaiNuocNgoai.tinhTongSoNguoiVietLamViecTaiNNTheoQuocGia, req)
    }

    tinhTongSoNguoiVietLamViecTaiNNTheoTrinhDoChuyenMon(req) {
        return super.get(apiUrl.LDVL_HGI.dashboardTheHienSoNguoiVietNamLamViecTaiNuocNgoai.tinhTongSoNguoiVietLamViecTaiNNTheoTrinhDoChuyenMon, req)
    }

    // SRS_108_Dashboard thể hiện số người nước Việt Nam làm việc tại nước ngoài
        //SRS101
    searchTraCuuNguoiLDONuocNgoai(data){
      return super.get(apiUrl.LDVL_HGI.traCuuNguoiLDONuocNgoai.searchTraCuu, data)
    }
    layThanhVien(idXuatKhauLD){
      return super.get(apiUrl.LDVL_HGI.traCuuNguoiLDONuocNgoai.getThanhVien + "?idXuatKhauLD=" + idXuatKhauLD)
    }
    layQuocGia(){
      return super.get(apiUrl.LDVL_HGI.traCuuNguoiLDONuocNgoai.getQuocGia)
    }
    //END SRS101

    // START HGI SRS 99 TRA CỨU THÔNG TIN LAO ĐỘNG CÓ VIỆC LÀM
    traCuuThongTinNguoiCoViecLam(obj) {
        return super.get(apiUrl.LDVL_HGI.traCuuThongTinNguoiCoViecLamTrongDiaBan.traCuuThongTinNguoiCoViecLam, obj);
    }

    danhSachDoanhNghiepTrongDiaBan(obj) {
        return super.get(apiUrl.LDVL_HGI.traCuuThongTinNguoiCoViecLamTrongDiaBan.danhSachDoanhNghiepTrongDiaBan, obj);
    }
    // END HGI SRS 99 TRA CỨU THÔNG TIN LAO ĐỘNG CÓ VIỆC LÀM
        // SRS68
    xemBaoCaoThongKeLDVLCoThoiHanNNTheoHD(namBaoCao, isSo) {
      return this._apiService.getBlobFile(apiUrl.LDVL_HGI.baoCaoThongKeLDVLCoThoiHanNNTheoHD.xuatBaoCaoThongKeLDVLCoThoiHanNNTheoHD + "?namBaoCao=" + namBaoCao + '&isExcel=' + 0 + '&isSo=' + isSo)
    }
    xuatBaoCaoThongKeLDVLCoThoiHanNNTheoHD(namBaoCao, isSo) {
      return super.downloadFile(apiUrl.LDVL_HGI.baoCaoThongKeLDVLCoThoiHanNNTheoHD.xuatBaoCaoThongKeLDVLCoThoiHanNNTheoHD + "?namBaoCao=" + namBaoCao + '&isExcel=' + 1 + '&isSo=' + isSo, "Thong-ke-lao-dong-lam-viec-o-nuoc-ngoai-co-thoi-han-trong-nam.xlsx")
    }
    checkReportBaoCaoThongKeLDVLCoThoiHanNNTheoHD(nam) {
      return super.get(apiUrl.LDVL_HGI.baoCaoThongKeLDVLCoThoiHanNNTheoHD.checkReport, { nam: nam});
    }
    //

    // SRS 98 THONG TIN NGUOI VIET NAM LAM VIEC TAI NUOC NGOAI

    taiFileMauThongTinNguoiVietNamLVTaiNN(){
      return super.downloadFile(apiUrl.LDVL_HGI.thongTinNguoiVietNamLamViecTaiNN.taiFileMau,"Mẫu thông tin người Việt Nam làm việc tại nước ngoài.xlsx");
    }

    importFileThongTinNguoiVietNamLVTaiNN(file,maTinh): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');
        const formData = new FormData();
        formData.append('file', file);
        formData.append('maTinh', maTinh);
        return this.http.post(apiUrl.LDVL_HGI.thongTinNguoiVietNamLamViecTaiNN.importFile,formData,{headers});
    }
    // END SRS 98 THONG TIN NGUOI VIET NAM LAM VIEC TAI NUOC NGOAI
    xoaDoanhNghiep(id, trangThai) {
      return super.delete(apiUrl.LDVL.QLdoanhNghiep.xoaDoanhNghiep, { id: id, trangThai: trangThai });
    }
    downloadTemplateImport() {
        return super.downloadFile(apiUrl.LDVL.QLdoanhNghiep.downloadTemplateImport, "template-import-doanh-nghiep.xlsx");
    }
    uploadFileImportDoanhNghiep(file, loaiDoanhNghiep = 1): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');
        const formData = new FormData();
        formData.append('file', file);
        formData.append('loaiDoanhNghiep', loaiDoanhNghiep.toString());
        return this.http.post(apiUrl.LDVL.QLdoanhNghiep.importDoanhNghiep, formData, {headers});
    }

    xoaTaiKhoanDoanhNghiep(uuidNguoiDung, trangThai) {
        return super.delete(apiUrl.LDVL.QLdoanhNghiep.xoaTaiKhoanDoanhNghiep, { uuidNguoiDung: uuidNguoiDung, trangThai: trangThai });
    }

    khoaTaiKhoanDoanhNghiep(uuidNguoiDung, trangThai) {
        return super.post(apiUrl.LDVL.QLdoanhNghiep.khoaTaiKhoanDoanhNghiep, { uuidNguoiDung: uuidNguoiDung, trangThai: trangThai });
    }
    reSetTaiKhoanDoanhNghiep(uuidNguoiDung, matkhau = null) {
        return super.post(apiUrl.LDVL.QLdoanhNghiep.resetTaiKhoanDoanhNghiep, { uuidNguoiDung: uuidNguoiDung});
    }

    xuatDanhSachDoanhNghiepChoThueLaiLaoDong(maTinh,tenCoSo,trangThai,linhVucSanXuatChinh,loaiHinhCoSo,tinhTrangHoatDong,loaiDoanhNghiep) {
        if(tenCoSo==='null'){
            tenCoSo=null
        }
        if(trangThai==='null'){
            trangThai=null
        }
        if(linhVucSanXuatChinh==='null'){
            linhVucSanXuatChinh=null
        }
        if(loaiHinhCoSo==='null'){
            loaiHinhCoSo=null
        }
        if(tinhTrangHoatDong==='null'){
            tinhTrangHoatDong=null
        }
        return super.downloadFile(apiUrl.LDVL.QLdoanhNghiep.xuatDanhSach + "?maTinh=" + maTinh  + "&tenCoSo=" + tenCoSo  + "&trangThai=" + trangThai  + "&linhVucSanXuatChinh=" + linhVucSanXuatChinh  + "&loaiHinhCoSo=" + loaiHinhCoSo  + "&tinhTrangHoatDong=" + tinhTrangHoatDong  + "&loaiDoanhNghiep=" + loaiDoanhNghiep , "Danh_sach.xlsx");
    }

    //end SRS15_16s
    //API QUẢN LÝ TỔNG HỢP TÌNH HÌNH HOẠT ĐỘNG THUÊ LẠI LAO ĐỘNG
    searchQuanLyTongHopTinhHinhHdThueLaiLd(obj): Observable<any>{
      return super.post(apiUrl.LDVL_HGI.quanLyTongHopTinhHinhHdThueLaiLd.searchList, obj);
    }

    listDetailsQuanLyTongHopTinhHinhHdThueLaiLd(id): Observable<any> {
      return super.get(apiUrl.LDVL_HGI.quanLyTongHopTinhHinhHdThueLaiLd.listDetails + "?id=" + id);
    }

    exportFileQuanLyTongHopTinhHinhHdThueLaiLd(id, tinh_or_huyen, nam, kyBC, typeFile){
      let url = apiUrl.LDVL_HGI.quanLyTongHopTinhHinhHdThueLaiLd.exportFile +"?tinh_or_huyen=" + tinh_or_huyen+"&typeFile=" + typeFile;
      if(id!=null){
        url=url+"&id=" + id;
      }
      if(nam!=null){
        url=url+"&nam=" + nam;
      }
      if(kyBC!=null){
        url=url+"&kyBC=" + kyBC;
      }
      if(typeFile === 1){
        return super.downloadFile(url, 'Bao-cao-tong-hop-tinh-hinh-hoat-dong-thue-lai-ld.docx');
      }else{
        return super.downloadFile(url, 'Bao-cao-tong-hop-tinh-hinh-hoat-dong-thue-lai-ld.pdf');
      }
    }
    getBolbFileQuanLyTongHopTinhHinhHdThueLaiLd(id, tinh_or_huyen, nam, kyBC, typeFile){
      let url = apiUrl.LDVL_HGI.quanLyTongHopTinhHinhHdThueLaiLd.exportFile +"?tinh_or_huyen=" + tinh_or_huyen+"&typeFile=" + typeFile;
      if(id!=null){
        url=url+"&id=" + id;
      }
      if(nam!=null){
        url=url+"&nam=" + nam;
      }
      if(kyBC!=null){
        url=url+"&kyBC=" + kyBC;
      }
      return this._apiService.getBlobFile(url);
    }

    /**
      * @method POST
      * @param requestBody
      * @description Thêm QUẢN LÝ TỔNG HỢP TÌNH HÌNH HOẠT ĐỘNG THUÊ LẠI LAO ĐỘNG
      */
    createQuanLyTongHopTinhHinhHdThueLaiLd(requestBody){
      return super.post(apiUrl.LDVL_HGI.quanLyTongHopTinhHinhHdThueLaiLd.create, requestBody);
    }

    /**
        * @method PUT
        * @param requestBody
        * @description Cập nhật QUẢN LÝ TỔNG HỢP TÌNH HÌNH HOẠT ĐỘNG THUÊ LẠI LAO ĐỘNG
        */
    updateQuanLyTongHopTinhHinhHdThueLaiLd(requestBody){
      return super.put(apiUrl.LDVL_HGI.quanLyTongHopTinhHinhHdThueLaiLd.update, requestBody);
    }

      /**
        * @method DELETE
        * @param requestParam
        * @description Xoá QUẢN LÝ TỔNG HỢP TÌNH HÌNH HOẠT ĐỘNG THUÊ LẠI LAO ĐỘNG
        */
    deleteQuanLyTongHopTinhHinhHdThueLaiLd(id): Observable<any>{
        return super.post(apiUrl.LDVL_HGI.quanLyTongHopTinhHinhHdThueLaiLd.delete + "?id=" + id);
    }

    getListQuanLyBaoCao(obj): Observable<any> {
        return super.get(apiUrl.LDVL.danhSachBaoCao, obj);
    }

    requestOptions(){
        let requestOptions = {
            responseType: 'blob' as 'json',
            headers: this._apiService.getJsonHeaders()
          };
        return requestOptions;
    }

    rootUrl_Micro = localStorage.getItem("url");
    getXemQuanLyBaoCao(obj, url): Observable<any> {
        return this.http.post(this.rootUrl_Micro + url, obj, this.requestOptions());
    }

    xuatFileQuanLyBaoCao(obj, url, tenFile): Observable<any> {
        return super.downloadFile(this.rootUrl_Micro + url, tenFile, obj);
    }

    downloadFileBaoCao(uuidFile, tenFile): Observable<any> {
        return super.downloadFile(apiUrl.GDNN_BAOCAO_SO.BAO_CAO_GDNN.xemBaoCaoCanDuyet + "/" + uuidFile, tenFile);
    }

    xuatTemplateImportNNLDTVN(): Observable<any> {
        return super.downloadFile(apiUrl.LDVL.nguoiNNLVTaiVN.xuatFileImport, "File mẫu import Thông tin NLĐNN làm việc tại VN (Mẫu 03).xlsx");
    }

    checkFileImportNNLDTVN(obj): Observable<any> {
        return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.checkImport, obj);
    }

    uploadFileImportNNLDTVN(obj): Observable<any> {
        return super.post(apiUrl.LDVL.nguoiNNLVTaiVN.importNguoiNNLVTaiVN, obj);
    }

    getQuanLyTinhHinhLaoDongCapCoSo(obj): Observable<any>{
        return super.get(apiUrl.LDVL.TNLD.getQuanLyTinhHinhLaoDongCapCoSo,obj);
    }

    deleteQuanLyTongHopTinhHinhTNLDCapCoSoTongHop(idTongHop, username) {
      return super.post(apiUrl.LDVL.TNLD.deleteQuanLyTongHopTinhHinhTNLDCapCoSoTongHop + "?idTongHop=" + idTongHop + "&username=" + username);
    }

    getTNLDQuanLyTongHopChitiet(idTongHop): Observable<any>{
        return super.get(apiUrl.LDVL.TNLD.getTNLDQuanLyTongHopChitiet+"?idTongHop="+idTongHop);
    }

    themQuanLyTongHopTinhHinhLaoDongCapCoSo(requestBody) : Observable<any> {
      return super.post(apiUrl.LDVL.TNLD.themQuanLyTongHopTinhHinhLaoDongCapCoSo, requestBody);
    }

    capNhatQuanLyTongHopTinhHinhLaoDongCapCoSo(requestBody):Observable<any> {
      return super.post(apiUrl.LDVL.TNLD.capNhatQuanLyTongHopTinhHinhLaoDongCapCoSo, requestBody);
    }

    getTNLDTongHopChitiet(nam,tinh,huyen,xa,ky,trangthai){
        return super.get(apiUrl.LDVL.TNLD.getTNLDTongHopChitiet+"?namBaoCao="+nam+"&tinh="+tinh+"&kyBaoCao="+ky+"&trangThai=DU_THAO");
    }

    getTongHopQuanLyTinhHinhTNLD(nam,ky,id,loai){
        return super.get(apiUrl.LDVL.TNLD.getTongHopQuanLyTinhHinhTNLD+"?nam="+nam+"&kyBaoCao="+ky+"&loai="+loai);
      }

    getTongHopQuanLyThietHaiTNLD(nam,ky,id,loai){
      return super.get(apiUrl.LDVL.TNLD.getQuanLyTongHopThietHaiTNLD+"?nam="+nam+"&kyBaoCao="+ky+"&loai="+loai);
    }
    traCuuThongTinDoanhNghiep(obj): Observable<any>{
        return super.get(apiUrl.LDVL.traCuuThongTinDoanhNghiep,obj);
    }


    traCuuThongTinDoanhNghiepChiTiet(id): Observable<any>{
        return super.get(apiUrl.LDVL.traCuuThongTinDoanhNghiepChiTiet+"?idCoSo="+ id);
    }
    getFullThongTinCoSoById(id) {
        return super.get(apiUrl.LDVL.QLdoanhNghiep.getFullThongTinCoSoById + "/" + Number(id));
    }

    checkTonTaiDuLieuNamSoLaoDong(obj): Observable<any> {
        return super.post(apiUrl.QLLĐ.quanLySoLaoDong.checkTonTaiDuLieuNam, obj);
    }

    checkQuyenQuanLyLaoDong(obj): Observable<any> {
        return super.post(apiUrl.QLLĐ.quanLyBienDongLaoDong.checkQuyenQuanLyLaoDong, obj);
    }

    getDanhMucTrangThaiMayMoc(): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.KhaiBaoMayMoc.getDmTrangThaiMayMoc);
    }

    uploadMultipleFileKhaiBaoMayMoc(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.KhaiBaoMayMoc.uploadMultipleFiles , obj);
    }

    getDsFileDinhKemKhaiBaoMayMoc(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.KhaiBaoMayMoc.getDsFileDinhKem, obj);
    }

    deleteFileDinhKemKhaiBaoMayMoc(obj): Observable<any> {
        return super.post(apiUrl.LDVL_HGI.KhaiBaoMayMoc.deleteFileDinhKem, obj);
    }

    getPdfFileKhaiBaoMayMoc(fileID): Observable<any> {
        return  this._apiService.getBlobFile(apiUrl.LDVL_HGI.KhaiBaoMayMoc.getPdfFile +"/" + fileID);
    }

    downloadTemplateKhaiBaoMayMoc(filename: string): Observable<any> {
        return super.downloadFile(apiUrl.LDVL_HGI.KhaiBaoMayMoc.downloadTemplateKhaiBaoMayMoc, filename);
    }

    getChiTietNguoiLaoDong(id) {
        return super.get(apiUrl.LDVL_HGI.danhMucNguoiLaoDong.chiTiet + "?id=" + id);
    }
    
    uploadFileImportKhaiBaoMayMoc(file): Observable<any> {
        const token = localStorage.getItem('access_token');
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + token);
        headers.append('Access-Control-Allow-Origin', '*');

        let api = apiUrl.LDVL_HGI.KhaiBaoMayMoc.importKhaiBaoMayMoc;

        return this.http.post(api, file, { reportProgress: true, headers });
    }

    getDmDoanhNghiepKhaiBaoMayMoc(maTinh): Observable<any> {
        return super.get(apiUrl.LDVL_HGI.KhaiBaoMayMoc.dmDoanhNgiep + "?maTinh=" + maTinh);
    }

    getDmLoaiThietBiVatTuAtvsld(id?:number, stt?:string, name?:string): Observable<any> {
        let url = apiUrl.LDVL_HGI.KhaiBaoMayMoc.dmThietBiVatTuAtvsld;
        if(id!=null && id!=undefined && id!=0){
            url=url+`?id=${id}`;
        }
        if(stt!=null && stt!=undefined){
            url=url+`&stt=${stt}`;
        }
        if(name!=null && name!=undefined){
            url=url+`&name=${name}`;
        }
        return super.get(url);
    }
    tongHopTinhTrangThietBiVatTuATVSLD(request): Observable<any> {
        let requestUrl = apiUrl.LDVL_HGI.KhaiBaoMayMoc.tongHopTinhTrangThietBiVatTuATVSLD+"?tinh="+request.tinh;
        if(request.idCoSo!=null || request.idCoSo!=undefined){
            requestUrl=requestUrl+"&idCoSo=" + request.idCoSo;
        }
        if(request.nam!=null || request.nam!=undefined){
            requestUrl=requestUrl+"&nam=" + request.nam;
        }
        if(request.thang!=null || request.thang!=undefined){
            requestUrl=requestUrl+"&thang=" + request.thang;
        }
        if(request.trangThai!=null || request.trangThai!=undefined){
            requestUrl=requestUrl+"&trangThai=" + request.trangThai;
        }
        if(request.xa!=null || request.xa!=undefined){
            requestUrl=requestUrl+"&xa=" + request.xa;
        }
        return super.downloadFile(requestUrl, "Tổng hợp tình trạng thiết bị vật tư ATVSLD.xlsx" );
    }
}
